module.exports = {
  messages: {
    A11Y_LOGO: 'Go to XING homepage',
    A11Y_SETTINGS_DROPDOWN_LABEL: 'Edit settings',
    A11Y_XDS_CONNECTION_DEGREE_1: '1st level contact',
    A11Y_XDS_CONNECTION_DEGREE_2: '2nd level contact',
    A11Y_XDS_CONNECTION_DEGREE_3: '3rd level contact',
    ABOUT_ME: 'About me',
    ACCOUNT: 'Member account',
    ACTION_BLOCK_USER: 'Block this user',
    ACTION_BLOCK_USER_DIALOG_DESCRIPTION:
      "Blocking {displayName} means they can't view your profile or contact you via XING.",
    ACTION_BLOCK_USER_DIALOG_TITLE: 'Really block this user?',
    ACTION_BLOCK_USER_SUCCESS: 'Member blocked',
    ACTIVE_LANGUAGE: 'English',
    ADD_ADDRESS: 'add address',
    ADD_COMPANY_SIZE: 'Add company size',
    ADD_ENTRY: 'Add entry',
    ADD_IM_ID: 'Add instant messaging ID',
    ADD_PROFILE: 'add profile',
    ADD_SUBJECT: 'Add field of study',
    ADD_WEBSITE: 'Add website',
    ADDRESS: 'Address',
    AMBASSADOR_ICON_LINK:
      'http://official-events.xing.com/ambassador.php?dpt=prd&ttp=plat&plf=amb&pid=20070712&lng=en',
    ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT: 'Exchange',
    AWARD: 'Award',
    AWARDS: 'Awards',
    AWARDS_EMPTY:
      'Enter awards that you have received such as "Networker of the Year 2010".',
    BASE_PROFILE: 'Basic profile',
    BILLING_ADDRESS_CHANGE_HINT:
      'The billing address is not automatically updated. To edit your billing address please click here: "<a href="{!BILLING_ADDRESS_URL}">{\'NAVI_ACCOUNTS}</a>".',
    BILLING_ADDRESS_CHANGE_HINT_TITLE:
      'Is your billing information up to date?',
    BIRTHDATE_EMPTY: 'You have not yet entered your birthday.',
    BIRTHDATE_PROFILES_EMPTY: 'You have not yet entered your birthday.',
    BOTTOM_BAR_FIND_JOBS_LABEL: 'Find jobs',
    BOTTOM_BAR_INSIGHTS_LABEL: 'Insights',
    BOTTOM_BAR_NETWORK_LABEL: 'Network',
    BOTTOM_BAR_NOTIFICATIONS_LABEL: 'Notifications',
    BOTTOM_BAR_YOUR_JOBS_LABEL: 'Your jobs',
    BREWERY_NOCOOKIES_LINK_TARGET:
      'https://faq.xing.com/en/security/what-are-cookies-and-why-do-i-need-them-log',
    BREWERY_NOCOOKIES_LINK_TEXT: 'Activate cookies',
    BREWERY_NOCOOKIES_PARAGRAPH:
      "You need to activate cookies to log in. Here's how to do that:",
    BREWERY_NOCOOKIES_TITLE: 'Please activate cookies.',
    BREWERY_NOJAVASCRIPT_LINK_TARGET:
      'https://faq.xing.com/en/settings/enable-javascript-my-browser',
    BREWERY_NOJAVASCRIPT_LINK_TEXT: 'Activate JavaScript',
    BREWERY_NOJAVASCRIPT_PARAGRAPH:
      "XING only works properly with JavaScript. Here's how to activate it:",
    BREWERY_NOJAVASCRIPT_TITLE: 'Please activate JavaScript.',
    BUSINESS: 'Business',
    BUSINESS_ADDRESS_STUDENT_CHANGE_HINT:
      'Once you’ve completed your studies and entered the world of work, please don’t forget to change your status accordingly.',
    BUSINESS_UNIVERSITY: 'Business/University',
    BUTTON_ACCEPT: 'Accept',
    BUTTON_ADD: 'Add',
    BUTTON_ADDCONTACT: 'Add as contact',
    BUTTON_BACK: 'Back',
    BUTTON_BACKTOP: 'Back to overview',
    BUTTON_CANCEL: 'Cancel',
    BUTTON_CHANGE: 'Change entries',
    BUTTON_CLEAR_FIELDS: 'Clear',
    BUTTON_CLOSE: 'Close',
    BUTTON_CLOSEWINDOW: 'Close window',
    BUTTON_COMMENT: 'Comment',
    BUTTON_CONFIRM: 'Confirm',
    BUTTON_CONTINUE: 'OK',
    BUTTON_CORRECTNEWS: 'Make corrections to news entry',
    BUTTON_CORRECTNEWSLETTER: 'Correct newsletter',
    BUTTON_CREATE_FILE: 'Create updated file',
    BUTTON_DELCONTACT: 'Delete contact',
    BUTTON_DELETE: 'Delete',
    BUTTON_DELETE_LANGUAGE: 'Delete language',
    BUTTON_EDIT: 'Edit',
    BUTTON_FILTER: 'Filter',
    BUTTON_FORWARD: 'Next',
    BUTTON_FURTHER_INVITATIONS: 'Invite more people',
    BUTTON_GRANT_PERMISSIONS: 'Grant access rights',
    BUTTON_JOIN: 'Join',
    BUTTON_JOIN_NOW: 'Join group now',
    BUTTON_LESS: 'Less',
    BUTTON_LOAD_MORE: 'More',
    BUTTON_MORE: 'More',
    BUTTON_NEW_LANGUAGE: 'New language',
    BUTTON_NEXT_STEP: 'Next step',
    BUTTON_OK: 'OK',
    BUTTON_POST: 'Post',
    BUTTON_POST_AND_TWEET: 'Post and tweet',
    BUTTON_POST_STATUS: 'Post',
    BUTTON_PREVIEW: 'Preview',
    BUTTON_PRINT: 'Print',
    BUTTON_PRINT_PROFILE: 'Print profile',
    BUTTON_PUBLISH: 'Post',
    BUTTON_RELOAD_PAGE: 'Refresh page',
    BUTTON_SAVE: 'Save',
    BUTTON_SAVE_AND_CONTINUE: 'Save and continue',
    BUTTON_SAVENEWS: 'Save news entry',
    BUTTON_SEARCH: 'Search',
    BUTTON_SEND: 'Send',
    BUTTON_SENDMESSAGE: 'Send message',
    BUTTON_SENDNEWSLETTER: 'Send newsletter',
    BUTTON_SHOW: 'Show',
    BUTTON_SHOW_ERRORS: 'Display error',
    BUTTON_SHOW_LESS: 'Less',
    BUTTON_SHOW_MORE: 'Show more',
    BUTTON_SKIP_STEP: 'Skip',
    BUTTON_SUBMIT: 'Submit',
    BUTTON_SUGGEST: 'Suggest contacts',
    BUTTON_TEXT_RECOVERY: 'Retrieve text',
    BUTTON_TRY_AGAIN: 'Try again',
    BUTTON_UPDATE: 'Save changes',
    CAL_DATE_FORMAT: 'DD/MM/YYYY',
    CAL_DATE_FORMAT_HINT: 'DD/MM/YYYY',
    CB_POSTING_ERROR: "Sorry, that didn't work. Please try again.",
    CELLPHONE: 'Mobile',
    CERTIFICATE_ERROR_DOWNLOAD_FAILED:
      'Unfortunately, this file could not be downloaded. Please try again.',
    CERTIFICATE_ERROR_EMPTY_FILE: 'Please select a file.',
    CERTIFICATE_ERROR_EMPTY_TITLE: 'Please enter a title for the file.',
    CERTIFICATE_ERROR_ERROR_FILE_TOO_BIG:
      'Please select a file with a maximum size of 2 MB.',
    CERTIFICATE_ERROR_FILE_NOT_SAVED:
      "We're sorry, the file wasn't uploaded. Please try again.",
    CERTIFICATE_ERROR_FILE_TYPE_NOT_ALLOWED:
      'Please select a file in one of the following formats: PDF, JPG or PNG.',
    CERTIFICATE_FILE: 'File',
    CERTIFICATE_MIMETYPE_APPLICATION_PDF: 'pdf',
    CERTIFICATE_MIMETYPE_IMAGE_JPEG: 'jpg',
    CERTIFICATE_MIMETYPE_IMAGE_PNG: 'png',
    CERTIFICATE_OPEN_OR_SAVE: 'Open or save',
    CERTIFICATE_PRIVACY: 'File visible to:',
    CERTIFICATE_PRIVACY_ALL: 'All XING members',
    CERTIFICATE_PRIVACY_CONTACTS_ONLY: 'Only my contacts',
    CERTIFICATE_TITLE: 'File description',
    CERTIFICATE_UPLOAD_NEW_FILE: 'change file',
    CERTIFICATE_VISIBILITY_CONTACTS_ONLY: 'Only visible to contacts',
    CERTIFICATES: 'Document upload',
    CERTIFICATES_EDIT_INFO: 'You can upload up to 3 files',
    CERTIFICATES_EDIT_INFO_2:
      '(A maximum of 2 MB each in PDF, JPG or PNG format).',
    CERTIFICATES_EMPTY:
      'More information about yourself (such as work samples and diplomas)',
    CERTIFICATES_NEW: 'NEW',
    CHANGE_PRIMARY_JOB_EXPL:
      'You can change the display of your main job by checking the box on another of your occupations.',
    CHANGE_PRIMARY_SCHOOL_EXPL:
      'Check the box next to another university to change which university you have displayed in your profile.',
    CHANGE_UN_PW:
      'Change the login details of your {-SITENAME} member account.',
    CHOOSE_LANG: 'Select the language in which you wish to use {-SITENAME}.',
    CHOOSE_NOTIFICATION_TYPES:
      'Select which notifications you wish to receive from {-SITENAME}.',
    CHOOSE_PRIVACY:
      'Select the level of privacy you wish to have on {-SITENAME}.',
    CITY: 'City',
    COMMBOX_ACTOR_SWITCH_CANCEL: 'Keep role',
    COMMBOX_ACTOR_SWITCH_CONFIRM: 'Change role',
    COMMBOX_ACTOR_SWITCH_HEADLINE: 'In what role do you want to post this?',
    COMMBOX_ACTOR_SWITCH_HINT:
      'To change the author of this post, just tap on the name above.',
    COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE:
      "Do you really want to change the name of the author? You'd then have to re-upload the image.",
    COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO:
      "Do you really want to change the name of the author? You'd then have to re-upload the video.",
    COMMBOX_ACTOR_SWITCH_TYPE_PAGE: 'Page',
    COMMBOX_ACTOR_SWITCH_TYPE_USER: 'Member',
    COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER:
      'You can add 1 more image to your post.',
    COMMBOX_AUDIENCE_CITY_CONTACTS: 'Only contacts in my city ({totalCount})',
    COMMBOX_AUDIENCE_FOLLOWERS: 'Followers only',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS: 'Followers & contacts',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC: 'Your post can be shared',
    COMMBOX_AUDIENCE_FOLLOWERS_DESC: 'Your post can be shared.',
    COMMBOX_AUDIENCE_HEADLINE: 'Who can see this?',
    COMMBOX_AUDIENCE_PRIVATE: 'Private (XING contacts only)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: "Your post can't be shared.",
    COMMBOX_AUDIENCE_PRIVATE_SELECTED: 'Private',
    COMMBOX_AUDIENCE_PUBLIC: 'Public',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Anyone can see and share this.',
    COMMBOX_BUTTON_ADD_VIDEO_LABEL: 'Select video',
    COMMBOX_BUTTON_OPEN_FILES_LABEL: 'Select document',
    COMMBOX_BUTTON_OPEN_POLL_LABEL: 'Create a poll',
    COMMBOX_CANCEL_POSTING_BUTTON_BACK: 'Continue editing',
    COMMBOX_CANCEL_POSTING_BUTTON_CANCEL: 'Discard post',
    COMMBOX_CANCEL_POSTING_HEADLINE: 'Discard post?',
    COMMBOX_CANCEL_POSTING_TEXT_MESSAGE:
      "You'll lose what you wrote if you discard it.",
    COMMBOX_CHARACTERS_LEFT: 'left',
    COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT: 'Select images',
    COMMBOX_EMPTY_DROPZONE_TEXT: 'JPG, BMG or PNG (max. {max_size} MB each)',
    COMMBOX_EMPTY_DROPZONE_TITLE:
      'Drag & drop or select up to {max_images} images',
    COMMBOX_EMPTY_TEXT_FIELD: 'Share your thoughts, a photo or a link...',
    COMMBOX_EMPTY_TEXT_FIELD_MENTIONS:
      "Create a new post (and use '@' to mention others)…",
    COMMBOX_ENTRY_POINT_LABEL: 'Text box for your post',
    COMMBOX_ENTRY_POINT_TEXT: "What's new with you?",
    COMMBOX_FILLED_DROPZONE_HEADER:
      'You can add {pictures} more images to your post.',
    COMMBOX_FULL_FILLED_DROPZONE_HEADER:
      "You've reached the maximum number of photos you can post.",
    COMMBOX_IMAGE_BUTTON_LABEL: 'Add image',
    COMMBOX_IMAGE_SIZE_UPLOAD_ERROR:
      'Please select an image less than 10 MB in size.',
    COMMBOX_IMAGE_TYPE_UPLOAD_ERROR:
      'Please select an image in JPG or PNG format.',
    COMMBOX_POST: 'Post',
    COMMBOX_SUCCESS_ACTION: 'View post',
    COMMBOX_SUCCESS_DESC: 'Your post is now live on XING.\t',
    COMMBOX_SUCCESS_HEADLINE: 'Great!',
    COMMBOX_SUCCESS_SCHEDULED_DESC:
      'Your message was scheduled for {time} on {date}.',
    COMMBOX_UPDATE_BTN: 'Update',
    COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED:
      "You've reached the limit of 10 images.",
    COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE:
      'Your video is being prepared. This will take a moment.',
    COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR:
      "Sorry, that didn't work. Please try again.",
    COMMBOX_VIEW_POST_BTN: 'View post',
    COMMENT_BUTTON_LABEL: 'Comment',
    COMPANY: 'Company',
    COMPANY_HP: 'Company Homepage',
    COMPANY_SIZE: 'Employees',
    COMPANY_SIZE_1: 'Just me',
    COMPANY_SIZE_2: '1-10 employees',
    COMPANY_SIZE_3: '11-50 employees',
    COMPANY_SIZE_4: '51-200 employees',
    COMPANY_SIZE_5: '201-500 employees',
    COMPANY_SIZE_6: '501-1,000 employees',
    COMPANY_SIZE_7: '1,001-5,000 employees',
    COMPANY_SIZE_8: '5,001-10,000 employees',
    COMPANY_SIZE_9: '10,001 or more employees',
    COMPANY_UPDATES_ADD_NEWS_TEXTAREA:
      "Here you can enter up to 400 characters and/or a link to let people know what's new at your company.",
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_BODY:
      'You can either cancel and continue editing, or you can discard the update without saving it.',
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_BUTTON_CANCEL: 'Cancel',
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_BUTTON_CONFIRM: 'Discard',
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_HEADLINE:
      'Really discard your update?',
    COMPANY_UPDATES_CREATE_UPDATE_BUTTON_BODY:
      'Just click here to start writing your first company update.',
    COMPANY_UPDATES_CREATE_UPDATE_BUTTON_HEADLINE:
      'This is where your updates appear.',
    COMPANY_UPDATES_ERROR_CREATE_UPDATE:
      'Sorry, something went wrong. Please try again.',
    COMPANY_UPDATES_ERROR_CREATE_UPDATE_HEADLINE:
      "Unfortunately your update wasn't posted.",
    COMPANY_UPDATES_ERROR_PREVIEW_LINK:
      "Sorry, we can't create a preview for this link. You can still go ahead and share it as a text link though.",
    COMPANY_UPDATES_ERROR_PREVIEW_LINK_HEADLINE: 'No preview available',
    COMPANY_UPDATES_ERROR_UPLOADING_FILE:
      "Unfortunately your file wasn't uploaded properly. Please try again.",
    COMPANY_UPDATES_ERROR_UPLOADING_FILE_HEADLINE:
      "Unfortunately your file wasn't uploaded.",
    COMPANY_UPDATES_PREVIEW_LOADING_LINK: 'Fetching preview...',
    COMPLETE_BUSINESS_ADDRESS: 'Please complete your business address.',
    COMPLETENESS_HINT:
      'Networking is all about “finding” and “being found” – such as for jobs and by coworkers, friends and business partners. Make sure that you have completed your profile page and included a photo - it will make you much easier to find.',
    COMPLETION_LEVEL_WHATS_THIS: "What's this?",
    CONTACT_DETAILS: 'Contact details',
    CONTACTSHTML_LIST_DISABLED:
      'This person has chosen not to display their contacts.',
    CONTENT_ERROR_404_BUTTON: 'Go to XING homepage',
    CONTENT_ERROR_404_HEADLINE: 'This page appears to have gone with the wind.',
    CONTENT_ERROR_404_SUBLINE:
      'But go ahead and check out what else is on offer:',
    CONTENT_ERROR_503_HEADLINE:
      'Looks like the server is playing cat and mouse with us.',
    CONTENT_ERROR_503_SUBLINE:
      'Please bear with us while we get some cheese for them.',
    CONTENT_ERROR_OFFLINE:
      'Please check your Internet connection and try again.',
    CONTENT_FOLLOW: 'Follow',
    CONTENT_FOLLOW_LIGHTBOX_HEADLINE: 'Follow {title}',
    CONTENT_FOLLOW_LIGHTBOX_TEXT:
      'Interested in reading {title} articles on XING on a regular basis?',
    CONTENT_FOLLOWED: 'Following',
    CONTENT_SWITCHER_MORE: 'More',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG:
      '{minutesCount, plural,\n   =1 {Just now}\n   other {# minutes ago}\n}',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_SHORT:
      '{minutesCount, plural,\n   =1 {Now}\n   other {# mins}\n}',
    CONTENT_TIMESTAMP_DAYS: 'days',
    CONTENT_TIMESTAMP_DAYS_AGO_LONG:
      '{daysCount, plural,\n    =0 {Today}\n    one {Yesterday}\n    other {# days ago}\n}',
    CONTENT_TIMESTAMP_DAYS_AGO_SHORT:
      '{daysCount, plural,\n    =0 {Today}\n    one {Yesterday}\n    other {# days}\n}',
    CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO: 'Just now',
    CONTENT_TIMESTAMP_SOME_HOUR_AGO_SHORT:
      '{hoursCount, plural,\n   =1 {1 hr}\n   other {# hrs}\n}',
    CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG:
      '{hoursCount, plural,\n   =1 {1 hour ago}\n   other {# hours ago}\n}',
    CONTENT_TIMESTAMP_TODAY: 'Today',
    CONTENT_UNFOLLOW: 'Do not follow',
    CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER:
      'Add a title for your video here.',
    CONTENT_VIDEO_RECOS_REASON: 'Popular videos on XING',
    CONTROL_DISPLAY_NAME:
      'You can change your personal info here and enter your academic titles.',
    CONTROL_PROFILE_VISIBILITY:
      'Decide for yourself which parts of your profile are visible to others.',
    CORPORATE_PAGES_TEST_RESOURCE: 'test',
    CORRECT_END_DATE: 'Please enter a correct end date.',
    CORRECT_START_DATE: 'Please enter a correct start date.',
    COUNTRY: 'Country',
    CP_000_CUSTOMER_FEEDBACK_LEGAL_INFO_HEADLINE: 'Please note:',
    CP_000_CUSTOMER_FEEDBACK_LEGAL_INFO_TEXT:
      "We want to know what you think. To make getting your feedback even easier, we've partnered with Uservoice, an independent product feedback website.<br />\nYour ideas will determine where the product goes from here. When you click on \"Next\", you'll be forwarded to the user forum where you can vote for others' ideas or submit your own.<br /><br />\nBy using the feedback forum you agree that your full name and e-mail address may be encrypted and sent to our partner, Uservoice, in the United States.",
    CP_000_FOLLOWED_COMPANIES_BOX_HEADLINE: 'Followed companies',
    CP_000_FOLLOWED_COMPANIES_BOX_INFO: '({limit} of {absolute_number})',
    CP_000_FOLLOWED_COMPANIES_LINK_ALT:
      "Go to the Company Profile of '{company_name}'",
    CP_000_RECOMMEND_SUBJECT_TEMPLATE:
      '{recommender_name} thinks you might be interested in the company {company_name}',
    CP_000_RECOMMEND_TEXT_TEMPLATE:
      'I found a company profile for "{company_name}" on {SITENAME}, and thought of you. You can find out more here:\n\n{SSLURL}/companies/{+company_tag}\n\nKind regards,\n\n{recommender_name}',
    CP_000_REQUIRED_INFORMATION: 'Required information',
    CP_100_ACTIVITY_STREAM: "What's new in Companies",
    CP_100_ADVANCED_SEARCH_LABEL: 'Advanced Search',
    CP_100_ALL_OPTION_COUNTRY: '(all)',
    CP_100_ALL_OPTION_INDUSTRY: '(all)',
    CP_100_ALL_OPTION_SIZE: '(all)',
    CP_100_BOOKMARK_JOB: 'Bookmark',
    CP_100_CHARACTERS_LEFT_COLON: 'Remaining:',
    CP_100_CITY_LABEL: 'City',
    CP_100_COMPANY_COLHEADER: 'Name & address',
    CP_100_COMPANY_DIRECTORY_ALL_LINK: 'All',
    CP_100_COMPANY_DIRECTORY_ALL_LINK_ALT: 'Show all companies',
    CP_100_COMPANY_DIRECTORY_HEADLINE:
      'Companies by name (in alphabetical order)',
    CP_100_COMPANY_DIRECTORY_LINK_ALT: 'Go to Company Profile',
    CP_100_COMPANY_DIRECTORY_PAGINATION_CHAR_LINK_ALT:
      'Show companies starting with this letter',
    CP_100_COMPANY_LABEL: 'Company name',
    CP_100_COUNTRY_LABEL: 'Country',
    CP_100_DESCRIBE_BRAND_MANAGER:
      'Manage your employer profiles in the BrandManager.',
    CP_100_DIRECTORY_DESCRIPTION:
      'XING hosts Company Profiles that cover almost the entire spectrum, including IT, tourism and banking.',
    CP_100_DIRECTORY_DESCRIPTION_INDUSTRY:
      'Employers in the {industry} industry: See employee benefits, current vacancies and contacts at a glance.',
    CP_100_DIRECTORY_INTRO:
      "More than just a list of employers: On XING you can subscribe to company updates you're interested in so you're always up to date. You can also see which XING members work there, the benefits on offer, and whether they have any current vacancies.",
    CP_100_DIRECTORY_INTRO_INDUSTRY:
      "Overview of employers in the {industry} industry: On XING you can follow company updates posted by businesses in the {industry} industry so you're always up to date. On top of that, you can see which XING members work for {industry} companies, the benefits they offer, and a list of current vacancies.",
    CP_100_DIRECTORY_TITLE: 'Companies by industry',
    CP_100_DIRECTORY_TITLE_INDUSTRY: 'Companies in the {industry} industry',
    CP_100_DIRECTORY_TITLE_NEW: 'Employers by industry',
    CP_100_DISPLAY_FILTER_LABEL: 'Display filter:',
    CP_100_ERROR_CONNECTION:
      'Unfortunately the connection to the server is down. Please try again later.',
    CP_100_ERROR_MESSAGE_COMPANY_NAME:
      'Please enter a name with at least 3 and at most 256 characters.',
    CP_100_ERROR_SEARCH_HIRING_COMPANIES:
      'Please refine you search, either by adding a keyword, a company name or a city and country.',
    CP_100_ERROR_UNKNOWN_OPERATION:
      'Die aufgerufene Operation ist nicht bekannt.',
    CP_100_FOUND_POSTINGS_COLHEADER: 'Number of jobs',
    CP_100_FOUND_PROFILES_COLHEADER: 'No. of member profiles',
    CP_100_HIRING_LABEL: 'Companies hiring',
    CP_100_IMG_ALT_HEADER: '{company_name}: cover image',
    CP_100_IMG_ALT_LOGO: "{company_name}'s logo",
    CP_100_INDUSTRY_COLHEADER: 'Industry',
    CP_100_INDUSTRY_DIRECTORY_ALL_LINK: 'All',
    CP_100_INDUSTRY_DIRECTORY_ALL_LINK_ALT: 'Additional industries',
    CP_100_INDUSTRY_DIRECTORY_HEADLINE: 'Industries',
    CP_100_INDUSTRY_DIRECTORY_LINK: 'Additional industries',
    CP_100_INDUSTRY_DIRECTORY_LINK_ALT: 'Show companies in this industry',
    CP_100_INDUSTRY_DIRECTORY_PAGINATION_CHAR_LINK_ALT:
      'Show industries starting with this letter',
    CP_100_INDUSTRY_LABEL: 'Industry',
    CP_100_KEYWORD_SEARCH_DESCRIPTION:
      '<strong>Keyword search</strong>: The keyword search accesses company names, postcodes, cities, and the information in the "Employees of this company have" category.',
    CP_100_KEYWORDS_LABEL: 'Keywords',
    CP_100_LATELY_BOUGHT_CPS_HEADLINE: 'New companies on XING',
    CP_100_LATELY_BOUGHT_CPS_HEADLINE_NEW: 'New employers on XING',
    CP_100_LATELY_BOUGHT_CPS_TEXT:
      'Check out companies that have just created a XING Company Profile:',
    CP_100_LOCATION: 'show on map',
    CP_100_LOCATION_COLHEADER: 'Location',
    CP_100_LOGGEDOUT_CREATE_HEADING:
      'For employers: Create your very own Employer Branding Profile.',
    CP_100_LOGGEDOUT_CREATE_TEXT:
      'Shape your own image as an employer and boost recognition levels and visibility to attract top talent to your company.',
    CP_100_LOGGEDOUT_EXISTING_PROFILES:
      'These are just a few of the 100,000 companies that use XING Company Profiles',
    CP_100_LOGGEDOUT_EXISTING_PROFILES_NEW:
      'More than 100,000 employers are on XING, including the following:',
    CP_100_LOGGEDOUT_EXISTING_PROFILES_TEXT:
      'Universities, education institutes, and companies of all sizes and industries use XING for employer branding, recruiting, and to boost their social media presence.',
    CP_100_LOGGEDOUT_EXISTING_PROFILES_TEXT_NEW:
      'Universities, education institutes, and employers of all sizes and industries use XING in their employer branding and recruiting work, and to boost their online presence.',
    CP_100_LOGGEDOUT_INTRO_TEXT_1:
      'On XING you can find out about employers:\n<ul class="check-icon-list">\n<li class="foundation-icon-shape-tick"><strong>Information and updates</strong> about the company\'s benefits, products and services</li>\n<li class="foundation-icon-shape-tick"><strong>Employee reviews:</strong> See how current and former employees rated the company.</li>\n<li class="foundation-icon-shape-tick"><strong>Career opportunities:</strong> Looking for a job? If so, just check out the vacancies this employer currently has to offer.</li>\n</ul>',
    CP_100_LOGGEDOUT_INTRO_TEXT_2:
      'Not a XING member yet? <a href="/signup">Sign up now</a> for free.',
    CP_100_LOGGEDOUT_TITLE: 'Work at a company where you feel at ease.',
    CP_100_MAINHEADLINE:
      'Employers on XING:<br>\nProducts, services, jobs and updates',
    CP_100_MAP_HEADER: '{company_name} is based here',
    CP_100_MERGE_TEASER_HEADER: 'Improving the quality of Company Profiles',
    CP_100_MERGE_TEASER_TEXT:
      'Company Profiles have been improved: Profiles with differing spellings have been merged to a single profile  using available public data about the company. {faq_merge_link}',
    CP_100_MERGE_TEASER_TEXT_LINK: 'See our FAQ for more information',
    CP_100_META_DESCRIPTION_ABOUT: '{company_short_description}',
    CP_100_META_DESCRIPTION_CONTACT:
      'Overview of contacts and contact options at {company_name}',
    CP_100_META_DESCRIPTION_DEFAULT:
      'Find out more about various employers and what they offer their employees.',
    CP_100_META_DESCRIPTION_EMPLOYEES:
      'List of all {company_name} employees on XING. {company_short_description}',
    CP_100_META_DESCRIPTION_FOLLOWERS:
      "All of {company_name}'s followers at a glance. {company_short_description}",
    CP_100_META_DESCRIPTION_HUBPAGE:
      'Find out what employers and companies have on offer by getting to know them better.',
    CP_100_META_DESCRIPTION_INDUSTRIES:
      'More than just the yellow pages: On XING you can find out various suppliers, service providers, customers, and employers.',
    CP_100_META_DESCRIPTION_INDUSTRY_DETAIL:
      'Get the latest news about {industry} employers and find out what they have to offer their employees.',
    CP_100_META_DESCRIPTION_JOBS:
      "Check out job vacancies your dream employer currently has on offer and see how you're connected to the company on XING via your contacts!",
    CP_100_META_DESCRIPTION_MOST_VISITED:
      "Which companies are trending? Here's an up-to-date list of the most-visited businesses.",
    CP_100_META_DESCRIPTION_NEW_COMPANIES:
      'Check out companies that have just created their Company Profile on XING.',
    CP_100_META_DESCRIPTION_RATING:
      'Read current employer reviews about {company_name}. {company_short_description}',
    CP_100_META_DESCRIPTION_SALES:
      "Show people that you're a great employer and reach out to more than 15 million XING members.",
    CP_100_META_DESCRIPTION_UPDATES:
      "Overview of {company_name}'s latest updates: Start following their updates now!",
    CP_100_META_TITLE_COMPANY_DIRECTORY: '{industry} companies',
    CP_100_META_TITLE_COMPANY_EMPLOYEES: '{company_name}: Employees',
    CP_100_META_TITLE_COMPANY_HOMEPAGE: '{company_name}',
    CP_100_META_TITLE_COMPANY_JOBS: 'Current vacancies at {company_name}',
    CP_100_META_TITLE_COMPANY_PAGE: '{company_name}: {tab_label}',
    CP_100_META_TITLE_COMPANY_RATING: 'Employer reviews for {company_name}',
    CP_100_META_TITLE_HUBPAGE:
      'Employers present their products, services, jobs and news',
    CP_100_META_TITLE_HUBPAGE_LI: 'Companies | XING',
    CP_100_META_TITLE_INDUSTRIES: 'Employers by industry',
    CP_100_META_TITLE_INDUSTRY_DETAIL: 'Employers in the {industry} industry',
    CP_100_META_TITLE_MOST_VISITED: 'Most-visited companies',
    CP_100_META_TITLE_NEW_COMPANIES: 'Newest company profiles',
    CP_100_META_TITLE_SALES_PAGE: 'Showcase yourself as an employer on XING.',
    CP_100_META_TITLE_SUFFIX: '| XING Companies',
    CP_100_MOST_CLICKED_COMPANIES: 'Most visited companies',
    CP_100_MOST_CLICKED_COMPANIES_HEADLINE: 'Most-visited companies on XING',
    CP_100_MOST_CLICKED_COMPANIES_NEW: 'Most-visited employers',
    CP_100_MOST_CLICKED_COMPANIES_TEXT: 'Trending in the past 24 hours',
    CP_100_MY_CITY_LABEL: 'Business address',
    CP_100_MY_COMPANIES_LINK: 'Your companies',
    CP_100_MY_COMPANIES_LINK_NEW: 'Your employers',
    CP_100_MY_COMPANIES_TITLE: 'My companies',
    CP_100_MY_EDITED_COMPANIES_TITLE: 'Managing',
    CP_100_MY_SUBSCRIPTIONS_TITLE: 'Company updates',
    CP_100_MYCP_FOLLOWED_COMPANIES_TITLE: "Companies I'm following",
    CP_100_MYCP_FOLLOWED_COMPANIES_TITLE_NEW: "Companies you're following",
    CP_100_MYCP_IWORKHERE_TITLE: 'Your companies',
    CP_100_MYCP_IWORKHERE_TITLE_NEW: 'Your employers',
    CP_100_MYCP_SUBSCRIPTION_HINT:
      '<p>You aren\'t following any company updates at the moment.</p>\n<p><strong>Tip:</strong> <a href="{find_companies_link}">Discover interesting companies</a> and follow their updates so you\'re always in the know!</p>',
    CP_100_MYXING_SUBSCRIPTIONS_TITLE:
      "Latest updates from companies I'm following",
    CP_100_NO_RESULTS_FOUND_INFO:
      'Sorry, no companies were found that matched your search. Why not try a different search term or refine your search with less specific criteria?',
    CP_100_NO_SEARCH_TERM_ENTERED: 'Please enter at least one search term.',
    CP_100_NOTICE_GENERAL_FEEDBACK:
      'The action has been executed successfully.',
    CP_100_OPEN_BRAND_MANAGER: 'Open BrandManager',
    CP_100_RECENTLY_FOLLOWED_LINK: 'Other followed companies',
    CP_100_RECENTLY_FOLLOWED_LINK_NEW: "Other employers you're following",
    CP_100_RECENTLY_FOLLOWED_TITLE: 'Following',
    CP_100_RECENTLY_FOLLOWED_TITLE_NEW: "Companies you're following",
    CP_100_RECOMMENDATION_REASON_CITY:
      '{company_name} is close to your workplace.',
    CP_100_RECOMMENDATION_REASON_COMPANY:
      '{company_name} could be of interest to you based on your current company.',
    CP_100_RECOMMENDATION_REASON_JOB_TITLE:
      '{company_name} could be of interest to you based on your profession.',
    CP_100_RECOMMENDATION_REASON_SCHOOL_NOTES:
      '{company_name} could be of interest to you based on your education.',
    CP_100_RECOMMENDATION_REASON_SHARED_CONTACTS:
      'Several of your contacts, e.g. {first_contact} and {second_contact}, are following the updates from {company_name}.',
    CP_100_RECOMMENDATION_REASON_SHARED_CONTACTS_NONE:
      'Several of your contacts are following the updates from {company_name}.',
    CP_100_RECOMMENDATION_REASON_SHARED_CONTACTS_ONE:
      '{first_contact} and other contacts of yours are now following the updates from {company_name}.',
    CP_100_RECOMMENDATION_REASON_UNIVERSITY:
      '{company_name} may be of interest to you because of where you studied.',
    CP_100_RECOMMENDATION_REASON_WHI:
      '{company_name} could be of interest to you based on your wants, skills, and interests.',
    CP_100_RECOMMENDATIONS_DELETE: 'Delete recommendation',
    CP_100_RECOMMENDATIONS_HEADING: 'These companies may be of interest to you',
    CP_100_RECOMMENDATIONS_HEADING_NEW: 'Check out the following employers:',
    CP_100_RELATED_COMPANY_MERGED_MAIL_BODY:
      "<p>The company {slave_company} was recently merged with {master_company}. Please check whether your connection to this company is still valid. If it isn't, we recommend that you delete this entry.</p>",
    CP_100_RELATED_COMPANY_MERGED_MAIL_SUBJECT:
      'Changes to your connections to other companies',
    CP_100_SALES_PAGE_FREE_PROFILE_PHONE:
      'For questions concerning the free profile, please call +49 40 419 131 784.',
    CP_100_SEARCH_COMPANIES_HEADLINE: 'Company search',
    CP_100_SEARCH_HIRING_COMPANIES_DESCRIPTION:
      '<strong>Search for hiring companies:</strong> Select "hiring companies" and \nenter at least a keyword or a company name or country and city.',
    CP_100_SEARCH_INLINE_HINT: 'e.g. Apple Inc.',
    CP_100_SEARCH_LABEL: 'Company search',
    CP_100_SEARCH_TIPS: 'Search tips',
    CP_100_SEARCH_WITH_ASTERISK_DESCRIPTION:
      '<strong>Search by word beginnings:</strong> You can search by word beginnings in all search \nfields.\nSimply enter the first three letters, for instance, of the keyword you’re looking for, \nfollowed by an asterisk (*).\nA search for <strong>"San*"</strong> in the "City (business)" field would include <strong>Santiago</strong>, <strong>San Jose</strong> and <strong>San Francisco</strong>, \nfor instance.\nThis search with an asterisk (*) cannot be combined with the similarity search.',
    CP_100_SEARCH_WITH_QUOTATION_MARKS_DESCRIPTION:
      '<strong>Searching with quotation marks:</strong> Use quotation marks to find a precise combination of words. For example, entering "Santa Fe Springs" will only find companies with these three words in exactly this order as an location.',
    CP_100_SHOW_GOOGLE_MAP: 'Get directions',
    CP_100_SIMILAR_LABEL: 'similar',
    CP_100_SIZE_COLHEADER: 'Size',
    CP_100_SIZE_LABEL: 'Size',
    CP_100_TAB_COMPANY_DIRECTORY_LINK: 'Companies',
    CP_100_TAB_INDUSTRY_DIRECTORY_LINK: 'Industries',
    CP_100_TEASER_CLAIME_COMPANY_HEADLINE:
      'Would you like to customise your Company Profile?',
    CP_100_TEASER_CLAIME_COMPANY_LINK: 'More information',
    CP_100_TEASER_CLAIME_COMPANY_TEXT: 'Draw attention to your company!',
    CP_100_TEASER_GIVE_FEEDBACK_HEADLINE: 'We value your opinion!',
    CP_100_TEASER_GIVE_FEEDBACK_ITEM_1:
      'Do you have ideas and suggestions for making Company Profiles even better?',
    CP_100_TEASER_GIVE_FEEDBACK_LINK: 'Send us your feedback!',
    CP_100_TEASER_HEADLINE_1: 'Company Profiles on XING',
    CP_100_TEASER_TEXT:
      '<p>Everything at a glance: Contacts, statistics, updates, and connection paths. What do Company Profiles look like?</p>\n<p><a href="https://www.xing.com/companies/about">More information</a></p>',
    CP_100_WARNING_NO_MY_COMPANY:
      'Your profile is not yet associated with a Company Profile. Please enter into your XING profile a company where you presently work.',
    CP_100_WARNING_NOT_EXISTING_COMPANY:
      "At present, Company Profiles are shown automatically when a certain number of XING members have entered a company name spelled in the same way into their profiles.<br />\nNo Company Profiles have been created yet for the company names you've entered into your profile.",
    CP_100_WARNING_PROFILE_NOT_CLAIMED_YET:
      "This Company Profile hasn't been activated yet. You can check out other great companies here:",
    CP_100_WARNING_PROFILE_NOT_VISIBLE_LOGGED_OUT:
      "This profile is either unavailable or only visible if you're logged on to XING.",
    CP_100_WARNING_UNPUBLISHED_COMPANY:
      "We're sorry, the company profile you have requested is currently unavailable.",
    CP_100_WIDGET_BUTTON1: 'Meet colleagues',
    CP_100_WIDGET_BUTTON2: 'Sign up now',
    CP_100_WIDGET_BUTTON3: 'Continue to XING',
    CP_100_WIDGET_FIND_OUT_WHO:
      'Find out whether any of your contacts work at this company.',
    CP_100_WIDGET_HEADER_NUMBER_EMPLOYEES:
      '{number_employees} employees at {company_link} are already XING members.',
    CP_100_WIDGET_HEADER1: 'Meet future colleagues',
    CP_100_WIDGET_HEADER2: 'Find existing and new contacts.',
    CP_100_WIDGET_HEADLINE_CONTACTS:
      'You have {contacts_number} contacts at {company_link}.',
    CP_100_WIDGET_HEADLINE_CONTACTS_INFO:
      '<a href="{contacts_url}" target="blank">{contacts_number} of your contacts</a> work at {company_link}.',
    CP_100_WIDGET_HEADLINE_NO_CONTACTS:
      '{employees_count} {company_link} employees are on XING, including:',
    CP_100_WIDGET_HEADLINE_NO_CONTENT: 'Join XING now',
    CP_100_WIDGET_HEADLINE_ONE_CONTACT:
      'You have one contact at {company_link}.',
    CP_100_WIDGET_HEADLINE_ONE_CONTACT_INFO:
      '<a href="{contacts_url}" target="blank">One of your contacts</a> works at {company_link}.',
    CP_100_WIDGET_LOG_IN: 'Log in',
    CP_100_WIDGET_MORE_EMPLOYEES_LINK:
      '{number_employees} more employees on XING',
    CP_100_WIDGET_NO_MEMBERSHIP: 'Not joined XING yet?',
    CP_100_WIDGET_PARAGRAPH_NO_COMPANY:
      'Register for free on XING now and you can connect with over {xing_members_count} million members.',
    CP_100_WIDGET_PARAGRAPH1:
      '{employees_count} XING members work at {company_link}.',
    CP_100_ZIP_CODE_LABEL: 'Postcode',
    CP_200_ABOUT_HTML_FONT:
      'The text has the font size 18 and the font color red.',
    CP_200_ABOUT_HTML_H2: 'Your heading',
    CP_200_ABOUT_HTML_INFO:
      'HTML tags permitted: {allowed_html}<br />Example of HTML in a heading:<br />{example_headline}<br />Example of color text:<br />{example_text}',
    CP_200_ABOUT_MAX_CHARS: 'Max. 6,000 characters',
    CP_200_ABOUT_TEXT_DESCRIPTION:
      'We recommend you add your legal notice here, either as a link to the "About this site" section of your website or by copying your entire legal notice to your profile.',
    CP_200_ABOUT_TEXT_DESCRIPTION_2:
      'Note on how a text is displayed: Line breaks will be kept, links and e-mail addresses can be clicked on. Other formatting is supported using HTML tags.',
    CP_200_ABOUT_TEXT_DESCRIPTION_3:
      "Please note that all text will be displayed in black in keeping with XING's design.",
    CP_200_ACTIONS_BOX_HEADING: 'Options',
    CP_200_ADD_ABOUT_TEXT_HEADLINE:
      "Here you can show people that you're a great employer.",
    CP_200_ADD_COMPANY_KEYWORDS_FIELD:
      'Add up to {num_keywords} keywords with a max. of {max_length} characters. Please separate with commas.',
    CP_200_ADD_CONTACT_PERSON: 'Add contact person',
    CP_200_ADD_CONTACT_PERSON_LIMIT_REMOVE:
      'Contact limit reached. If you want to add more contacts, you need to remove at least one from your list.',
    CP_200_ADD_CONTACT_PERSON_LIMIT_UPGRADE:
      "Sorry, but you've reached your contact limit. If you want to add more contacts, please take out an Employer Branding Profile.",
    CP_200_ADD_DESCRIPTION_FIELD: 'max. {max_length} characters',
    CP_200_ADD_DESCRIPTION_LABEL: 'Company description',
    CP_200_ADD_HEADER_GRAPHIC_DEFAULT:
      'Add an appealing graphic to attract more attention to your company. You can change the graphic as often as you like and use it to draw attention to any special offers or job vacancies you currently have.',
    CP_200_ADD_HEADER_GRAPHIC_DEFAULT_HEADLINE: 'Sample cover image',
    CP_200_ADD_HEADER_GRAPHIC_EMPLOYEE:
      "Boost your company's image as an employer and increase visibility among Europe's professional network. Upload a logo, or inform target groups about new products, innovations, or hot topics.",
    CP_200_ADD_HEADER_GRAPHIC_EMPLOYEE_HEADLINE:
      'Customise your Company Profile',
    CP_200_ADD_HEADER_GRAPHIC_HEADLINE: 'Upload cover image',
    CP_200_ADD_NEWS_HEADLINE: 'Post a new update',
    CP_200_ADD_NEWS_HEADLINE_FIELD:
      'Here you can enter a title for your update.',
    CP_200_ADD_NEWS_HEADLINE_LABEL: 'Headline',
    CP_200_ADD_NEWS_LINK_LABEL: 'Link',
    CP_200_ADD_NEWS_LINK_LINK: 'Add link',
    CP_200_ADD_NEWS_NEW_COMMENT_FIELD: 'Here you can comment on your update.',
    CP_200_ADD_NEWS_SUBHEADLINE: 'Here you can post company updates.',
    CP_200_ADD_NEWS_TEXT_FIELD:
      "Let people know what's new at your company. You can enter up to 1,200 characters here.",
    CP_200_ADD_NEWS_TEXT_FIELD_HINT: 'max. 1,200 characters',
    CP_200_ADD_NEWS_TEXT_HTML_LABEL: 'Text',
    CP_200_ADD_NEWS_TEXT_LABEL: 'Text*',
    CP_200_ADD_RSS_FEED_LABEL:
      'Add RSS link (e.g. http://www.ibm.com/feeds/sample.rss)',
    CP_200_ADD_TWITTER_FEED: 'Edit Twitter feeds',
    CP_200_ADD_TWITTER_FEED_LABEL:
      'Enter your Twitter username (without the @ symbol).',
    CP_200_ADD_TWITTER_FEED_TEXT_FIELD: 'Enter your Twitter username here',
    CP_200_ADD_UPDATE_HEADLINE_FIELD:
      'Here you can enter a title for your update.',
    CP_200_ADDRESS_CHANGE_CONFIRMATION:
      'We have now updated your billing address as well. Please send an e-mail to {email} if you have any other questions or would like to undo your change request.',
    CP_200_ADDRESS_CHANGE_ERROR:
      "Sorry, the system couldn't update your address. Please send your change request via e-mail to {email}.",
    CP_200_ADDRESS_CHANGE_HEADING: 'Update your billing address as well?',
    CP_200_ADDRESS_CHANGE_TEXT:
      'Would you also like to use this new address as your new billing address?',
    CP_200_ADDRESS_CHANGE_WARNING:
      'As requested, we did not update the billing address. Please send an e-mail to {email} if you have any other queries or would like to change your billing address.',
    CP_200_ADDRESS_LABEL: 'Street address and no.',
    CP_200_AFFILIATES_ASSOCIATE_TYPE: 'Affiliate',
    CP_200_AFFILIATES_CLIENT_TYPE: 'Client',
    CP_200_AFFILIATES_COMPANY_NAME_HINT:
      "Please use your company's official spelling.",
    CP_200_AFFILIATES_EXISTS: "You've already added this affiliate.",
    CP_200_AFFILIATES_FORM_HEADLINE: 'Edit affiliates',
    CP_200_AFFILIATES_FORM_INTRO_TEXT:
      'You can enter subsidiaries, customers, service providers, etc. here. They will need to have their own XING Company Profile before you can add them. Please only list companies that have provided their consent to do so.',
    CP_200_AFFILIATES_FRANCHISE_TYPE: 'Franchise',
    CP_200_AFFILIATES_HEADLINE: 'Affiliates',
    CP_200_AFFILIATES_INTRO_EDIT_TEXT:
      'Here you can enter subsidiaries, customers, service providers, etc. Each of these companies needs to have a XING Company Profile. Please only list companies that have provided their consent to do so.',
    CP_200_AFFILIATES_JOINT_VENTURE_TYPE: 'Shareholder',
    CP_200_AFFILIATES_MAX_NUMBER:
      "Sorry, but you can't enter more than 15 affiliates. Please delete an existing entry before adding a new one.",
    CP_200_AFFILIATES_NAME: 'Affiliate name',
    CP_200_AFFILIATES_NOT_EXISTS:
      "Sorry, but we couldn't find this affiliate on XING.",
    CP_200_AFFILIATES_PARENT_TYPE: 'Parent',
    CP_200_AFFILIATES_PARTNER_TYPE: 'Partner',
    CP_200_AFFILIATES_PLACEHOLDER:
      'Please enter your affiliates, customers, service providers, etc. here.',
    CP_200_AFFILIATES_PLACEHOLDER_BUTTON: 'Add affiliate',
    CP_200_AFFILIATES_PLACEHOLDER_TITLE: 'Add affiliate',
    CP_200_AFFILIATES_REGIONAL_BRANCH_TYPE: 'Branch',
    CP_200_AFFILIATES_SELECT_CATEGORY: 'Please choose the affiliation type.',
    CP_200_AFFILIATES_SERVICE_PROVIDER_TYPE: 'Service provider',
    CP_200_AFFILIATES_SUBSIDIARY_TYPE: 'Subsidiary',
    CP_200_AFFILIATES_TYPE: 'Affiliation type',
    CP_200_AGE_GROUP_ABOVE_65: '65 and above',
    CP_200_AGE_GROUP_FROM_20_TO_24: '20 to 24',
    CP_200_AGE_GROUP_FROM_25_TO_34: '25 to 34',
    CP_200_AGE_GROUP_FROM_35_TO_44: '35 to 44',
    CP_200_AGE_GROUP_FROM_45_TO_54: '45 to 54',
    CP_200_AGE_GROUP_FROM_55_TO_64: '55 to 64',
    CP_200_AGE_GROUP_UNDER_20: '20 and under',
    CP_200_AGES: 'Age groups',
    CP_200_ALL_OPTION_CONTACTS: 'All employees',
    CP_200_ALL_OPTION_FOLLOWERS: 'All followers',
    CP_200_ARTICLE_IS_BEING_PROCESSED:
      'Your update was received and will soon be available to your followers.',
    CP_200_AVAILABLE_TWITTER_FEEDS: 'You already added Twitter feeds',
    CP_200_AVAILABLE_TWITTER_FEEDS_INFO:
      'Tweets are updated every 30 minutes. If you add a new Twitter feed, it may take a little longer to import the first tweets. Thanks for your patience!',
    CP_200_BACK_TO_CP_LINK: 'Go to Company Profile',
    CP_200_BASIC_DATA_HEADLINE: 'Facts and figures',
    CP_200_BELONG_TO_COMPANY_CONFIRM_HEADLINE: 'Do you work at this company?',
    CP_200_BELONG_TO_COMPANY_DESCRIPTION:
      "<p>If you'd like to be listed here as an employee, please copy the company's full name You will now be redirected to your profile:</p>\n\n<p><strong>{company}</strong></p>\n\n<p>Once you've done that, enter the name as your current company in the professional experience section of your profile. You will then appear on the Company Profile as an employee.</p>\n\n<p>Click on \"Continue\" to go to your profile.</p>",
    CP_200_BELONG_TO_COMPANY_HEADLINE: 'Do you work at this company?',
    CP_200_BELONG_TO_COMPANY_LINK: 'I work here',
    CP_200_BELONG_TO_COMPANY_MANUAL_UPDATE:
      'To appear in the Company Profile, please go to your profile and check the "Display this job next to my name and at the top of my profile page" box next to your current position. This position and company will appear next to your profile picture, and you will appear in the Company Profile.',
    CP_200_BELONG_TO_COMPANY_TEXT:
      "Are you an employee of this company, yet your name does not appear in the Company Profile? It could be that the spelling you've chosen in your profile is different from the official spelling of the company. If you would like to correct this, first confirm that you're part of this company. Your profile will be automatically updated, and you will automatically appear as an employee of this company after 24 hours.",
    CP_200_BEST_MONTH: 'High score',
    CP_200_BEST_WEEK: 'High score',
    CP_200_BEST_YEAR: 'High score',
    CP_200_BUSINESS_CARD_COLLAPSE: 'less',
    CP_200_BUSINESS_CARD_CONTACT_DETAILS: 'Company contact details',
    CP_200_BUSINESS_CARD_CONTACT_US_LINK: 'Contact us',
    CP_200_BUSINESS_CARD_EXPAND: 'More',
    CP_200_BUTTON_PREVIEW: 'Show preview below',
    CP_200_CALL_COSTS_HINT: 'Please enter any applicable call costs here.',
    CP_200_CALL_COSTS_LABEL: 'Call costs',
    CP_200_CALLOUT_CONTACT_TAB_REMOVED:
      '<span class="new-sign bold">NEW</span> Here you can see the contacts at this company.',
    CP_200_CAREER_LEVEL_COLHEADER: 'Career level',
    CP_200_CAREER_LEVELS: 'Career levels',
    CP_200_CHANGE_LOGO: 'Change',
    CP_200_CLAIM_YOUR_CP_HEADING: 'Present yourself as an employer.',
    CP_200_CLAIM_YOUR_CP_LINK: 'Create profile now',
    CP_200_CLAIM_YOUR_CP_TEXT:
      "Show your potential candidates why they should work with you. It's a great way for you to quickly find the right people to fill your vacancies.",
    CP_200_CLAIMING_TEASER_HEADLINE: 'This is your Company Profile!',
    CP_200_CLAIMING_TEASER_LINK: 'Create Company Profile',
    CP_200_CLAIMING_TEASER_LINK_TITLE: 'Go to product overview',
    CP_200_CLAIMING_TEASER_TEXT:
      'This Company Profile, {company_name}, is still available &ndash; claim it now!',
    CP_200_COMPANIES: 'Companies',
    CP_200_COMPANIES_RECENTLY_ADDED_PAGE_TITLE: 'New companies on XING',
    CP_200_COMPANIES_RECENTLY_ADDED_WARNING:
      'A maximum of {num_companies} companies will be listed here. Are you looking for a certain company? If so, just use the <a href="/companies">Search</a> function.',
    CP_200_COMPANY_KEYWORDS_EDITOR_INFO:
      'Please enter keywords that describe what your company does. Keywords are used by the keyword search in the XING Companies section, so please use words with which you would like to be found.',
    CP_200_COMPANY_KEYWORDS_EDITOR_INFO_BOX:
      'These keywords help users to find your company in searches. You can use {num_keywords} keywords with max. 200 characters, separated by commas.',
    CP_200_COMPANY_KEYWORDS_HEADING: 'Products and services',
    CP_200_COMPANY_KEYWORDS_INFO:
      'These are the services or products this company offers. The words listed are keywords. You can click on them to find similar companies offering these services.',
    CP_200_COMPANY_UPDATES_INFO:
      'If you are interested in press releases, news about products and services, or special offers from a company, you can subscribe to their company updates which will then appear on your homepage. Keep up to date and subscribe to company updates by clicking on the "Follow now" button.',
    CP_200_COMPANY_UPDATES_TWEET: 'Tweet',
    CP_200_CONTACT_PERSON_DESC: 'Description',
    CP_200_CONTACT_PERSON_EDIT: 'Edit contact details',
    CP_200_CONTACT_PERSON_EDITORS_INTRO:
      '<strong>How to add contact persons:</strong> Select an employee and add a short description of why and when people should contact this person. Your description will be shown to page visitors.<br><br>\n\n<strong>Important:</strong> Please make sure you inform this person about their new role, that their XING profile is up to date, and that they allow every XING member to message them in their privacy settings.',
    CP_200_CONTACT_PERSON_ERR_ALREADY_CONTACT:
      'This employee is already a contact.',
    CP_200_CONTACT_PERSON_ERR_CHAR_LIMIT: 'max. 300 characters',
    CP_200_CONTACT_PERSON_ERR_NOT_IN_DATABASE:
      'Could not find user in list of employees. Please choose a person from the list or contact the person to get them to update their XING member profile.',
    CP_200_CONTACT_PERSON_INTRO:
      'The people listed here are contacts at this company. Feel free to select the right person for your concern and get in touch with them.',
    CP_200_CONTACT_PERSON_INTRO_DIRECT_CONTACTS:
      'Because you have {num_contacts} direct contacts in this company you might think about contacting these ones first. If you want to do so please find your direct contacts to this company on the {link_employee_tab} tab.',
    CP_200_CONTACT_PERSON_INTRO_DIRECT_CONTACTS_2:
      'Because you have {num_contacts} direct contacts in this company you might think about contacting these ones first. Would you like to contact these <a href="{link_employee_tab}">members</a> first?',
    CP_200_CONTACT_PERSON_MOVE_DOWN: 'Move down',
    CP_200_CONTACT_PERSON_MOVE_UP: 'Move up',
    CP_200_CONTACT_PERSON_NAME: 'Name',
    CP_200_CONTACT_PERSON_SELECT_LABEL: 'Job title',
    CP_200_CONTACTS_WORK_HERE: 'The following contacts work here:',
    CP_200_CP_COMMENTS_ENABLED_LABEL: 'People can comment on company updates',
    CP_200_CP_EMPLOYEER_MODULE_ENABLED_LABEL: 'Show "Ideal employer" module',
    CP_200_CP_EXECUTIVES_ENABLED_LABEL:
      'Indicate executives in the employees section',
    CP_200_CP_LOGGED_OUT_TAB_TITLE: 'Please log in for more information.',
    CP_200_CP_LOGGED_OUT_TEASER_BUTTON:
      'More information about Employer Branding Profiles',
    CP_200_CP_LOGGED_OUT_TEASER_INTRO:
      'Present your company professionally on XING and boost your online presence.',
    CP_200_CP_LOGGED_OUT_TEASER_LIST:
      '<h5>Your benefits:</h5>\n<ul class="bullet-list">\n  <li>Acquire new customers and deals</li>\n  <li>Hire and retain new employees</li>\n  <li>Keep the XING community up to date</li>\n</ul>',
    CP_200_CP_SETTINGS_HEADLINE: 'Company Profile Settings',
    CP_200_CP_SETTINGS_LABEL:
      'This Company Profile is visible to search engines and non-XING members',
    CP_200_CP_SETTINGS_LINK: 'Edit',
    CP_200_CP_SETTINGS_SUCCESS: 'Your Company Profile settings were saved.',
    CP_200_CP_UNDER_MAINTENANCE:
      "We're doing some maintenance work on our Company Profiles section at the moment. If you need to edit your profile, please try again later.",
    CP_200_CREATE_COMPANY_LINK: 'Create Company Profile',
    CP_200_CREATE_COMPANY_LINK_NEW: 'Create an employer profile',
    CP_200_CREATE_JOB_AD: 'Post job ad',
    CP_200_DATA_ORIGIN_INFO:
      'These statistics are automatically generated estimates based on data XING members entered in their profiles. The data has not been provided by the company itself and does not contain any information about employees who are not registered with XING.',
    CP_200_DELETE_UPDATE_CONFIRM:
      'Are you sure you want to delete this update?',
    CP_200_DETAILED_INFO: 'See detailed information about auto correct',
    CP_200_DOWNLOAD_DOCUMENT: 'Download document',
    CP_200_EDIT_ADDITIONAL_DATA_HEADLINE: 'Additional information',
    CP_200_EDIT_ADDRESS_DATA_HEADLINE: 'Address details',
    CP_200_EDIT_DESCRIPTION_HEADLINE: 'Description',
    CP_200_EDIT_NEWS_HEADLINE: 'Edit company update',
    CP_200_EDITOR_BAR_FOLLOWERS: 'Followers',
    CP_200_EDITOR_BAR_FREE: 'Manage editors',
    CP_200_EDITOR_BAR_SETTINGS: 'Settings',
    CP_200_EDITOR_BAR_SETTINGS_FREE: 'Settings / Manage editors',
    CP_200_EDITOR_BAR_STATISTICS: 'Statistics',
    CP_200_EDITOR_BAR_SUPPORT: 'Help',
    CP_200_EDITOR_BAR_VISITORS: 'Visitors',
    CP_200_EMAIL_LABEL: 'E-mail address',
    CP_200_EMPLOYEE: 'employee',
    CP_200_EMPLOYEE_CONNECTIONS_DESCRIPTION:
      'Employees of this company are connected with the following companies. Click on the company name to view each Company Profile. The number displayed shows how many employees are connected to the company.',
    CP_200_EMPLOYEE_CONNECTIONS_HEADER:
      '{from}-{to} of {total} employees who are connected to {company_name}',
    CP_200_EMPLOYEE_CONNECTIONS_HEADLINE: 'Employee network',
    CP_200_EMPLOYEE_CONNECTIONS_PRIVACY_INFO:
      "A maximum of 10 companies to which employees are connected will be displayed. XING always respects its members' privacy settings, so members will not appear if they applied any other setting to their contact list other than \"Make my contact list visible to 'all members'\".",
    CP_200_EMPLOYEE_LIST_CONTACTS_INFO:
      '{number_of_employees} employee of this company is your \ndirect contact.',
    CP_200_EMPLOYEE_LIST_CONTACTS_INFO_PLURAL:
      '{number_of_employees} employees of this company are your \ndirect contacts.',
    CP_200_EMPLOYEE_LIST_HEADER: '{from}-{to} of {total} employees on XING',
    CP_200_EMPLOYEE_LIST_SHOW_ALL_LINK: 'Show all employees of this company',
    CP_200_EMPLOYEE_STATISTICS_HEADLINE: 'Employee statistics',
    CP_200_EMPLOYEE_STATISTICS_HEADLINE_DESCRIPTION:
      'The statistical data here is automatically generated from member profiles on XING once a day. The data has not been provided by the respective company itself. Please <a href="{contact_link}">contact</a> us if you have any questions regarding this data.',
    CP_200_EMPLOYEES_ACTIVITIES_HEADLINE: 'How are employees active on XING?',
    CP_200_EMPLOYEES_HAVES_HEADLINE: 'Employees of this company have',
    CP_200_EMPLOYEES_HAVES_LINK_ALT: 'Start search',
    CP_200_EMPLOYEES_HAVES_TOP_10_LINK: 'Top 10',
    CP_200_EMPLOYEES_HAVES_TOP_15_LINK: 'Top 15',
    CP_200_EMPLOYEES_HAVES_TOP_5_LINK: 'Top 5',
    CP_200_EMPLOYEES_LABEL: 'Employees on XING',
    CP_200_EMPLOYEES_LIST_DELETED_MEMBER: '(not a XING member)',
    CP_200_EMPLOYEES_LIST_HEADLINE: 'The following employees are XING members:',
    CP_200_EMPLOYEES_LIST_HEADLINE_DESCRIPTION:
      'The list of employees has been compiled from members who have listed the company name in their profile.',
    CP_200_EMPLOYEES_LIST_PRIVACY_CHANGED:
      'This employee has changed his or her privacy settings.',
    CP_200_ERROR_ADD_NEWS_HEADLINE:
      'Your headline exceeds the maximum character count. Please enter a maximum of 100 characters.',
    CP_200_ERROR_ADD_NEWS_LINK: 'The URL you entered is not valid.',
    CP_200_ERROR_ADD_NEWS_MISSING_COMMENT_LINK:
      'Here you can comment on this link.',
    CP_200_ERROR_ADD_NEWS_MISSING_HEADLINE:
      'Please enter a title for your update.',
    CP_200_ERROR_ADD_NEWS_MISSING_INPUT: 'Please enter an update text above.',
    CP_200_ERROR_ADD_NEWS_MISSING_URL:
      'Please enter a link starting with "https://" or "http://"',
    CP_200_ERROR_ADD_NEWS_TEXT:
      'Your text exceeds the maximum character count. Please enter a maximum of 1,000 characters.',
    CP_200_EVENTS_LINK: 'Events of employees at this company',
    CP_200_EVENTS_LINK_TITLE:
      'All public events that are being organised or attended by employees at this company',
    CP_200_FAX_LABEL: 'Fax',
    CP_200_FEATURE_COMPANY_EMAIL_CONTENTS:
      "Hello XING Team,\n{separator}\nI would like to place my company prominently in the 'Featured Companies' scroll bar. Please \ncould you send \nme some information about it.\n{separator}\nThank you very much. \n{separator}\n{separator}\nRef: {reference}",
    CP_200_FEATURE_COMPANY_EMAIL_SUBJECT: 'Featured Companies',
    CP_200_FEATURE_COMPANY_HEADING: 'Feature your company here!',
    CP_200_FEATURE_COMPANY_INFO:
      'Give your company a top ranking! This will attract more interest to your Company Profile and \nthus increase visitor numbers. Just send an e-mail to <a \nhref="{email_link}">{email_address}</a> to find out more. <strong>(Your company must already have a XING Company Profile to do so)</strong>',
    CP_200_FOLLOW: 'Follow',
    CP_200_FOLLOW_LINK: 'Follow',
    CP_200_FOLLOW_LINK_ALT:
      'Updates you choose to follow will appear on your XING homepage. Please note: When you click on this button, this action will be shown to your direct contacts in their "What\'s new in your network" feed.',
    CP_200_FOLLOW_LINK_BACK: 'Follow',
    CP_200_FOLLOW_LINK_SHORT: 'Follow',
    CP_200_FOLLOW_NOT_POSSIBLE:
      'An error occurred: The company updates you selected cannot be subscribed to at the moment, as the company is not currently posting updates.',
    CP_200_FOLLOWER_LIST_CONTACTS_INFO:
      '{number_of_followers} of your contacts are following this company.',
    CP_200_FOLLOWER_LIST_CONTACTS_INFO_PLURAL:
      '{number_of_followers} followers of this company are your direct contacts.',
    CP_200_FOLLOWER_LIST_HEADER: '{from}-{to} of {total} followers',
    CP_200_FOLLOWERS_INFO:
      'Please note: There are more than {max_number} followers of this company. The {max_number} most recent followers are displayed here.',
    CP_200_FOLLOWERS_LIST_INFO:
      "These are all the XING members who subscribed to this company's updates. Click on a name to view a member's profile.",
    CP_200_FOLLOWERS_THIS_COMPANY:
      'These contacts are already following this company.',
    CP_200_FOLLOWING: 'Following',
    CP_200_FOLLOWING_SINCE_COLHEADER: 'following since',
    CP_200_FOUNDATION_YEAR_LABEL: 'Year of establishment',
    CP_200_FOUNDED_LABEL: 'Founded',
    CP_200_HEADER_GRAPHIC_ALT_TEXT: '{company_name}: cover image',
    CP_200_HEADER_GRAPHIC_TEASER_BUTTON: 'More information',
    CP_200_HEADER_GRAPHIC_TEASER_HEADING:
      'Draw even more attention to your company by personalizing this profile!',
    CP_200_HEADER_GRAPHIC_TEASER_LIST_ITEM_1:
      'Customised design with logo and company description',
    CP_200_HEADER_GRAPHIC_TEASER_LIST_ITEM_2:
      'Increase visibility both on XING and through search engines',
    CP_200_HELPIFY_HEADLINE: 'Noch Fragen?',
    CP_200_HELPIFY_LINK: 'Fragen und Antworten zu den Unternehmensprofilen',
    CP_200_HELPIFY_TEXT: 'Weitere Infos findest Du in den',
    CP_200_HOMEPAGE_LABEL: 'Company Homepage',
    CP_200_IMPORT_FEEDS_HEADLINE: 'Import content',
    CP_200_IMPORT_FEEDS_SUBHEADLINE:
      'Import your company tweets and blog posts!',
    CP_200_IMPORT_UPDATES_FROM_EXTERNAL_SERVICES: 'Import updates',
    CP_200_INACTIVE_TAB_ABOUT_TITLE:
      'This tab is available if the company has set a corresponding profile.',
    CP_200_INACTIVE_TAB_TITLE:
      'This tab is available after the company posts its first update.',
    CP_200_INDUSTRIES: 'Industries',
    CP_200_INDUSTRY_2ND_LEVEL_LABEL: 'Subcategory',
    CP_200_INDUSTRY_DIRECTORY_LARGEST_INDUSTRIES: 'Top 40',
    CP_200_INDUSTRY_LABEL: 'Industry',
    CP_200_INVALID_HTML_WARNING:
      'Incorrect or incomplete HTML tags were found. These tags were automatically removed. (Hint: If you wish to avoid automatic tag correction in the future, please ensure that all tags are XHTML compatible. In particular, remember to close individual tags such as the br tag using "/>", and do not forget closing tags.)',
    CP_200_JOB_OFFERS_LINK: "This company's job ads on XING",
    CP_200_JOB_OFFERS_LINK_TITLE:
      'View all job postings by employees of this company.',
    CP_200_JOB_POSTINGS_CAREER_LEVEL: 'Career level',
    CP_200_JOB_POSTINGS_COMPANY: 'Company',
    CP_200_JOB_POSTINGS_CONTACT: 'Contact',
    CP_200_JOB_POSTINGS_HEADLINE: 'New job ad',
    CP_200_JOB_POSTINGS_JOB_TYPE: 'Job type',
    CP_200_JOB_POSTINGS_LOCATION: 'Location',
    CP_200_JOB_STUDENT_LABEL: 'Student job',
    CP_200_JOBS_EMPTY_TEXT:
      'This employer doesn\'t have any vacancies on XING right now...<br>\nbut check out our <a href="/jobs" alt="job recommendations">job recommendations</a> and see if there\'s anything for you there.',
    CP_200_JOBS_LABEL: 'Job Offers',
    CP_200_JOBS_LOCATION_TITLE: 'Location',
    CP_200_JOBS_PAGINATION_RESULTS_NUMBER: '{from} - {to} of {total} results',
    CP_200_JOBS_SECTION_LABEL: 'Current jobs',
    CP_200_JOBS_TITLE: 'Position / project',
    CP_200_LAST_MONTH: 'Last month',
    CP_200_LAST_TWITTER_UPDATE: 'on {date}',
    CP_200_LAST_TWITTER_UPDATE_A_DAY_AGO: 'Yesterday',
    CP_200_LAST_TWITTER_UPDATE_ABOUT_AN_HOUR_AGO: '1 hour ago',
    CP_200_LAST_TWITTER_UPDATE_LESS_THAN_A_MINUTE: 'less than 1 minute ago',
    CP_200_LAST_TWITTER_UPDATE_NEVER:
      'No updates are available for this user yet.',
    CP_200_LAST_TWITTER_UPDATE_SOME_DAYS_AGO: '{days} days ago',
    CP_200_LAST_TWITTER_UPDATE_SOME_HOURS_AGO: '{hours} hours ago',
    CP_200_LAST_TWITTER_UPDATE_SOME_MINUTES_AGO: '{minutes} minutes ago',
    CP_200_LAST_WEEK: 'Last week',
    CP_200_LAST_YEAR: 'Last year',
    CP_200_LINK: 'Link',
    CP_200_LOCAL_TIME_LABEL: 'Local time',
    CP_200_LOGIN_TO_VIEW: 'Please log in.',
    CP_200_LOGO_ALT_TEXT: 'Logo of {company_name}',
    CP_200_MAKE_FAVORITE: 'Bookmark',
    CP_200_MESSAGE: 'Message',
    CP_200_MORE_FOLLOWERS_LINK: 'More followers',
    CP_200_MORE_VISITORS_LINK: 'more visitors',
    CP_200_NAME_COLHEADER: 'Name, Title, Company',
    CP_200_NETWORKPATH_DIRECT_CONTACTS_LINK:
      '{number_of_contacts} of your contacts work here.',
    CP_200_NETWORKPATH_HEADLINE: 'My direct contacts at this company',
    CP_200_NEW_COMPANIES: 'New companies',
    CP_200_NEWS_LIST_HEADER: '{from}-{to} of {total} company updates',
    CP_200_NEWS_UPDATE_VIA_TWITTER: 'via Twitter',
    CP_200_NEWS_UPDATE_VIA_TWITTER_LINK_TEXT: 'View tweet',
    CP_200_NO_ABOUT_TEXT: 'Page not yet created.',
    CP_200_NO_DATA_INFO: 'no data available',
    CP_200_NO_DESCRIPTION:
      'No description has been entered yet for this company.',
    CP_200_NO_HEADER_GRAPHIC: 'No company image',
    CP_200_NO_LOGO: 'No logo',
    CP_200_NO_NEWS_INFO: 'There are no company updates at the moment.',
    CP_200_NO_VISITORS:
      'Your Company Profile was not viewed in the last 30 days.',
    CP_200_NON_PUBLIC_PROFILE: 'Only available to XING members',
    CP_200_NOTICE_ABOUT_TEXT_SAVED: 'Your changes were saved.',
    CP_200_NOTICE_ALREADY_FOLLOWING:
      "You're already following this company. You can view this Company Profile's updates in the \"What's new in your network\" feed on your XING homepage.",
    CP_200_NOTICE_FOLLOW:
      "You're now following this company. To view updates for this Company Profile, just go to your XING homepage.",
    CP_200_NOTICE_UNFOLLOW: "You no longer follow this company's updates.",
    CP_200_NOTIFICATIONS_TIME_AGO: '{time_ago} ago',
    CP_200_ONE_FOLLOWER_THIS_COMPANY: '{name} is following this company.',
    CP_200_OPTION_CONTACTS_OF_CONTACTS: "Your contacts' contacts",
    CP_200_OPTION_DIRECT_CONTACTS: 'Direct contacts',
    CP_200_OPTION_NOT_CONTACTS: 'non-contacts',
    CP_200_OPTIONS_COLHEADER: 'Options',
    CP_200_PHONE_LABEL: 'Phone',
    CP_200_PRODUCT_OVERVIEW: 'Company Profiles on XING',
    CP_200_PROMOTE_CP_HEADLINE: 'Promote this Company Profile',
    CP_200_PROMOTE_CP_HIDE_CODE_LINK: 'Hide source code',
    CP_200_PROMOTE_CP_INSTRUCTIONS:
      'Copy the HTML source code and paste it into the code of your website or blog. Clicking the button will automatically take users to your Company Profile.',
    CP_200_PROMOTE_CP_SHOW_CODE_LINK: 'Show source code',
    CP_200_QUICKINVITE_ADD_MESSAGE: 'Add an invitation message',
    CP_200_QUICKINVITE_FIND_CONTACTS: 'Find contacts',
    CP_200_QUICKINVITE_HEADER: 'Invite your colleagues to XING',
    CP_200_QUICKINVITE_HEADER_2: 'Invite your e-mail contacts to XING',
    CP_200_QUICKINVITE_INPUT_TITLE: 'Separate e-mail addresses with commas.',
    CP_200_QUICKINVITE_SEND: 'Send invitation',
    CP_200_RATE_LINK: 'Rate employer',
    CP_200_RATE_NPO_LINK: 'Rate organisation',
    CP_200_RECOMMEND_LINK: 'Share this company',
    CP_200_RECOMMEND_LINK_ALT: 'Share this company with your contacts.',
    CP_200_RECOMMEND_NPO_LINK: 'Share this organisation',
    CP_200_RECOMMEND_UPDATE_TOOLTIP: 'Share',
    CP_200_REMOVE_TWITTER_FEED_CONFIRM:
      'Are you sure you want to remove all updates of this feed from the Company Updates?',
    CP_200_REPORT_COMPANY_CONFIRM:
      'Thanks for reporting. We received your message and will review it as soon as possible.',
    CP_200_REPORT_COMPANY_DESCRIPTION:
      "If you have reasons to believe that the information in this company profile is incorrect or untrue, please enter them here in as much detail as possible. \n<br /><br />\nPlease note: We review every reported profile we receive. Please understand, however, that we're unable to inform you about the current status of the profile reported and are not able to send an e-mail with the outcome of the reported profile.",
    CP_200_REPORT_COMPANY_LINK: 'Report this company profile',
    CP_200_REVENUE_LABEL: 'Revenues',
    CP_200_RSS_FEED_INVALID: 'Sorry, but this RSS link is invalid.',
    CP_200_RSS_FEED_NOT_UNIQUE: 'This RSS feed has already been saved.',
    CP_200_RSS_SERVICE_INFO:
      'Add your RSS links here. All new posts will then be automatically posted as updates to your Company Profile within 30 minutes.',
    CP_200_RSS_SUBHEADER: 'From your blogs and websites via RSS',
    CP_200_SALES_CONSULTATION_BODY:
      'PLUS profile customers can add up to 15 subsidiaries, customers, service providers, etc. to their Company Profile.',
    CP_200_SALES_CONSULTATION_TITLE: 'Affiliates',
    CP_200_SALES_PAGE_ALL_PRICES: 'Pricing',
    CP_200_SALES_PAGE_ARGUMENT_ONE_HEADLINE:
      'Shape your own image as an employer.',
    CP_200_SALES_PAGE_ARGUMENT_ONE_POINT_A:
      'Use images, videos and presentations as a fun way to inform people interested in your business.',
    CP_200_SALES_PAGE_ARGUMENT_ONE_TEXT:
      'What sets you apart from the crowd as an employer? Your modern offices? Flexitime? Daycare? List your employee benefits in your Employer Branding Profile to show why people should come and work for you!',
    CP_200_SALES_PAGE_ARGUMENT_THREE_HEADLINE:
      'Hire and retain good employees.',
    CP_200_SALES_PAGE_ARGUMENT_THREE_POINT_A:
      'An excellent employer reputation and increased online visibility will help to reduce your recruiting costs and the time needed to find the right people.',
    CP_200_SALES_PAGE_ARGUMENT_THREE_POINT_B:
      "You'll also increase your job ads' reach: If you post a job ad on XING it will also be automatically posted on your Employer Branding Profile.",
    CP_200_SALES_PAGE_ARGUMENT_THREE_TEXT:
      'Mit Deinem Employer Branding-Profil bekommst Du einen professionellen und glaubwürdigen Auftritt als attraktiver Arbeitgeber. Nutze diesen Wettbewerbsvorteil jetzt konsequent:',
    CP_200_SALES_PAGE_ARGUMENT_TWO_HEADLINE:
      'Boost your recognition and visibility levels.',
    CP_200_SALES_PAGE_ARGUMENT_TWO_POINT_B:
      "With ads: We advertise your company on the sites of competitors who don't have an Employer Branding Profile yet to maximize impact among your intended target group.",
    CP_200_SALES_PAGE_ARGUMENT_TWO_TEXT:
      'Die beste Werbung für Sie als Arbeitgeber ist die Empfehlung durch die eigenen Mitarbeiter. Gewinnen Sie Ihre Mitarbeiter deshalb als Botschafter! So nutzen Sie Ihr Employer Branding-Profil dafür:',
    CP_200_SALES_PAGE_CALL_TO_ACTION_HEADLINE: 'Take the initiative now!',
    CP_200_SALES_PAGE_CALL_TO_ACTION_PHONE: '&nbsp;',
    CP_200_SALES_PAGE_EXAMPLE_COMPANY_TEXT:
      'Examples: These companies are already here.',
    CP_200_SALES_PAGE_EXAMPLE_LINK_TEXT: '{company_name} on:',
    CP_200_SALES_PAGE_FEATURE_DROPDOWN: 'Benefits overview',
    CP_200_SALES_PAGE_FREE_BUBBLE: 'Free',
    CP_200_SALES_PAGE_FREE_HEADLINE: 'For minimalists: The free profile',
    CP_200_SALES_PAGE_FREE_LINK: 'Create free profile',
    CP_200_SALES_PAGE_FREE_TEXT:
      "Don't have any budget left over for employer branding? No problem! Just create a free profile on XING that offers you some of the basic Employer Branding Profile features.",
    CP_200_SALES_PAGE_MAIN_BUTTON:
      'Request information about Employer Branding Profile',
    CP_200_SALES_PAGE_OVERALL_SUBLINE:
      'Attract top employees and boost loyalty levels',
    CP_200_SALES_PAGE_PRO_BUBBLE: 'From<br>€<strong>395</strong><br> per month',
    CP_200_SALES_PAGE_SECUNDARY_BUTTON: 'Create a free profile',
    CP_200_SELF_AFFILIATION: "You can't use your own company's name.",
    CP_200_SENDING_SALES_REQUEST_ADDRESS:
      'Company headquarters postcode & city',
    CP_200_SENDING_SALES_REQUEST_COMMENT: 'Your message',
    CP_200_SENDING_SALES_REQUEST_COMPANY_NAME: 'Company name',
    CP_200_SENDING_SALES_REQUEST_COMPANY_SIZE: 'Employees',
    CP_200_SENDING_SALES_REQUEST_EMAIL: 'E-mail',
    CP_200_SENDING_SALES_REQUEST_EMAIL_HINT: 'Your e-mail address',
    CP_200_SENDING_SALES_REQUEST_FAMILY_NAME: 'Last name',
    CP_200_SENDING_SALES_REQUEST_GENDER_ERROR: 'Please select a title.',
    CP_200_SENDING_SALES_REQUEST_MADAM: 'Ms.',
    CP_200_SENDING_SALES_REQUEST_NAME: 'First name',
    CP_200_SENDING_SALES_REQUEST_PHONE: 'Your phone number',
    CP_200_SENDING_SALES_REQUEST_PHONE_HINT: 'Your phone no.',
    CP_200_SENDING_SALES_REQUEST_SEND: 'Send an enquiry',
    CP_200_SENDING_SALES_REQUEST_SIR: 'Mr.',
    CP_200_SENDING_SALES_REQUEST_SUBLINE:
      'Please describe your issue in as much detail as possible so we can help you out as best we can.',
    CP_200_SENDING_SALES_REQUEST_SUCCESS_HEADLINE: 'Thanks for your enquiry!',
    CP_200_SENDING_SALES_REQUEST_SUCESS_TEXT:
      "We'll get back to you within one working day.",
    CP_200_SENDING_SALES_REQUEST_TITLE: 'Title',
    CP_200_SHARE_NEWS_LABEL: 'Share',
    CP_200_SHOW_ABOUT_TEXT_HINT:
      'Your "{about_page}" page is not visible to others. Please click on "{publish}" to make the page visible to all members.',
    CP_200_SHOW_ABOUT_TEXT_LABEL: 'This page can be viewed by others.',
    CP_200_SHOW_ALL_INDUSTRIES: 'Overview of industries',
    CP_200_SHOW_ALL_MOST_VISITED_COMPANIES: 'More companies',
    CP_200_SHOW_ALL_MOST_VISITED_COMPANIES_NEW:
      'More frequently visited employers',
    CP_200_SHOW_ALL_RECENTLY_ADDED_COMPANIES: 'More new Company Profiles',
    CP_200_SHOW_ALL_RECENTLY_ADDED_COMPANIES_NEW: 'More new employers',
    CP_200_SHOW_ALL_RECOMMENDED_COMPANIES: 'Other interesting Company Profiles',
    CP_200_SHOW_ALL_RECOMMENDED_COMPANIES_NEW: 'Other interesting employers',
    CP_200_SHOW_COMPANY_UPDATE_HINT:
      'Your Company update is not visible to others. Please click on "{publish}" to make the page visible to all members.',
    CP_200_SHOW_GOOGLE_MAP: 'Open in Google Maps',
    CP_200_SHOW_LABEL: 'Show',
    CP_200_SHOW_USERS_FILTER: 'Show:',
    CP_200_SIZE_LABEL: 'Employees',
    CP_200_STATISTICS_AGE_STRUCTURE_HIGH_RANGE: 'Over {age}',
    CP_200_STATISTICS_AGE_STRUCTURE_LABEL_YEARS: 'years',
    CP_200_STATISTICS_AGE_STRUCTURE_LABEL_YEARS_ABBR: 'yrs.',
    CP_200_STATISTICS_AGE_STRUCTURE_LOW_RANGE: 'Under {age}',
    CP_200_STATISTICS_AGE_STRUCTURE_MEDIUM_RANGE:
      'Between {from_age} and {to_age}',
    CP_200_STATISTICS_BEST_MONTH_TAG: 'Record',
    CP_200_STATISTICS_CAREER_LEVEL_ENTRY_LEVEL: 'Entry Level',
    CP_200_STATISTICS_CAREER_LEVEL_EXECUTIVE: 'Executives',
    CP_200_STATISTICS_CAREER_LEVEL_MANAGER: 'Manager',
    CP_200_STATISTICS_CAREER_LEVEL_PROFESSIONAL: 'Professional/Experienced',
    CP_200_STATISTICS_CAREER_LEVEL_SENIOR_EXECUTIVE: 'Senior Executive',
    CP_200_STATISTICS_CAREER_LEVEL_STUDENT: 'Student/Intern',
    CP_200_STATISTICS_CATEGORY_AGE_STRUCTURE: 'Age structure',
    CP_200_STATISTICS_CATEGORY_CAREER_LEVEL: 'Career level',
    CP_200_STATISTICS_CATEGORY_EMPLOYEE_SINCE: 'Employee for',
    CP_200_STATISTICS_CATEGORY_LANGUAGE_SKILLS: 'Language skills',
    CP_200_STATISTICS_EMPLOYEE_SINCE_LESS_THAN_A_YEAR: 'less than a year',
    CP_200_STATISTICS_EMPLOYEE_SINCE_ONE_TO_THREE_YEARS: 'one to three years',
    CP_200_STATISTICS_EMPLOYEE_SINCE_OVER_FIVE_YEARS: 'over five years',
    CP_200_STATISTICS_EMPLOYEE_SINCE_THREE_TO_FIVE_YEARS: 'three to five years',
    CP_200_STATISTICS_FOLLOWERS_TAB: 'Followers',
    CP_200_STATISTICS_LANGUAGES_OTHER: 'Other languages',
    CP_200_STATISTICS_LAST_MONTH_TAG: 'Last month',
    CP_200_STATISTICS_LAST_QUARTER_TAG: 'Last quarter',
    CP_200_STATISTICS_LAST_WEEK_TAG: 'Last week',
    CP_200_STATISTICS_LAST_YEAR_TAG: 'Last year',
    CP_200_STATISTICS_NO_INFO: 'No information available',
    CP_200_STATISTICS_PAGE_HEADER:
      "Facts & figures:<br>\nWho's interested in you as an employer?",
    CP_200_STATISTICS_PAGE_TITLE: '{company_name}: Statistics',
    CP_200_STATISTICS_POPULARITY_CHANGE_INFO_MONTH:
      'Compared to previous month',
    CP_200_STATISTICS_POPULARITY_CHANGE_INFO_WEEK: 'Compared to previous week',
    CP_200_STATISTICS_POPULARITY_CHANGE_INFO_YEAR: 'Compared to previous year',
    CP_200_STATISTICS_POPULARITY_HEADER:
      'Visitors: How popular are you among candidates?',
    CP_200_STATISTICS_POPULARITY_HEADER_INFO_HTML:
      "<p>Multiple visits to your company profile by the same person within the space of an hour will not be included in your profile's visitor statistics.</p>\n<p>Visitor figures have been collected since August 2011.</p>\n<p>The number of followers only includes new followers who aren't employed at your company.</p>",
    CP_200_STATISTICS_PROFILE_HEADER:
      'Profile analysis: Who are your visitors and followers?',
    CP_200_STATISTICS_PROFILE_HEADER_INFO_HTML:
      'Includes profile visitors and people who started following you within the last 30 days (excluding people who work at the same company).',
    CP_200_STATISTICS_SUBTAB_DAY: 'Day',
    CP_200_STATISTICS_SUBTAB_MONTH: 'Month',
    CP_200_STATISTICS_SUBTAB_QUARTER: 'Quarter',
    CP_200_STATISTICS_SUBTAB_WEEK: 'Week',
    CP_200_STATISTICS_SUBTAB_YEAR: 'Year',
    CP_200_STATISTICS_THIS_MONTH_TAG: 'This month',
    CP_200_STATISTICS_THIS_QUARTER_TAG: 'This quarter',
    CP_200_STATISTICS_THIS_WEEK_TAG: 'This week',
    CP_200_STATISTICS_THIS_YEAR_TAG: 'This year',
    CP_200_STATISTICS_TODAY_TAG: 'Today',
    CP_200_STATISTICS_TRAFFIC_BESTOFFERS: 'Top Deals',
    CP_200_STATISTICS_TRAFFIC_BROWSE: 'Browse',
    CP_200_STATISTICS_TRAFFIC_COMPANIES: 'Companies',
    CP_200_STATISTICS_TRAFFIC_EVENTS: 'Events',
    CP_200_STATISTICS_TRAFFIC_GROUPS: 'Groups',
    CP_200_STATISTICS_TRAFFIC_HEADER:
      'Traffic analysis: Find out how people are finding your profile',
    CP_200_STATISTICS_TRAFFIC_HEADER_INFO_HTML:
      '<p>Traffic analysis shows how people came to visit your Company Profile (in the last 30 days) and more:</p>\n\n<p><strong>Search engines:</strong> Which search terms were used to find your Company Profile on Google, Bing, Yahoo!, etc.?</p>\n\n<p><strong>XING:</strong> Where were users on the XING platform when they came across your Company Profile?</p>\n\n<p><strong>Website links:</strong> Which websites with a link to your Company Profile lead to the most visits?</p>\n\n<p><strong>Social networks:</strong> How many people visit your Company Profile after using Facebook, Twitter, etc.?</p>',
    CP_200_STATISTICS_TRAFFIC_JOBS: 'Jobs & Careers',
    CP_200_STATISTICS_TRAFFIC_PROFILE: 'Member profiles',
    CP_200_STATISTICS_TRAFFIC_RECOMMENDATIONS: 'Recommended companies',
    CP_200_STATISTICS_TRAFFIC_SEARCH: 'Search',
    CP_200_STATISTICS_TRAFFIC_STARTPAGE: 'Homepage',
    CP_200_STATISTICS_VISITORS_TAB: 'Visitors',
    CP_200_STATISTICS_VOLUNTEERS_TAB: 'Volunteers',
    CP_200_STATISTICS_YESTERDAY_TAG: 'Yesterday',
    CP_200_STATS_ENTIRE_OVERVIEW: 'Go to overall statistics',
    CP_200_STATS_MONTHLY_FOLLOWERS: 'New followers this month:',
    CP_200_STATS_MONTHLY_VISITORS: 'Visitors this month:',
    CP_200_STATS_PAGE_HEADLINE: 'Statistics for this page',
    CP_200_SUBNAV_ABOUT_US_LINK: 'About us',
    CP_200_TAB_ABOUT: 'About us',
    CP_200_TAB_ABOUT_LINK: 'About this company',
    CP_200_TAB_COMPANY_REVIEWS: 'Reviews',
    CP_200_TAB_COMPANY_UPDATES: 'Updates',
    CP_200_TAB_COMPANY_UPDATES_LINK: 'Company updates ({number_of_articles})',
    CP_200_TAB_CONTACT_US_LINK: 'Contact',
    CP_200_TAB_CORPORATION_DETAILS_LINK: 'Overview',
    CP_200_TAB_EMPLOYEES_LINK: 'Employees ({number_of_employees})',
    CP_200_TAB_FOLLOWERS: 'Followers',
    CP_200_TAB_FOLLOWERS_LINK: 'Followers ({number_of_followers})',
    CP_200_TAB_JOBS_LINK: 'Jobs',
    CP_200_TAB_JOBS_LINK_WITH_COUNTER: 'Jobs ({number_of_jobs})',
    CP_200_TAB_OVERVIEW_LINK: 'Overview',
    CP_200_TAB_PRODUCTS_AND_SERVICES: 'Products and services',
    CP_200_TAB_VISITORS: 'Visitors to your Company Profile in the last 30 days',
    CP_200_TEASER_ABOUT_COMPANY_PAGES_1:
      '<h4>More about Company Profiles</h4>\n<p>Find out about companies with the Company Profiles on XING!<br /><br />\nNow you can search for specific companies, view employee statistics and find \nthe right contact person.<br /><br />\nThe information displayed is an automatically generated estimate, based on \nuser generated profile data. The data has not been provided by the\ncompany itself. Accordingly, the estimate does not include information on \nemployees who have not yet signed up on XING services.<br />\n\nXING Company Profiles are continuously being improved and expanded, based on your \nideas and your feedback.<br /><br />\n<a href="/help/help-and-faqs-2/the-features-of-xing-53/company-profiles-420">XING Company \nProfiles FAQ</a>\n</p>',
    CP_200_TEASER_ABOUT_COMPANY_PAGES_2:
      '<p>XING Company Profiles are a work in progress, based on your feedback and ideas.<br /><br />\n<a href="/app/help?op=explanations;category_id=411">Find out more about XING Company Profiles</a></p>',
    CP_200_TEASER_ABOUT_COMPANY_PAGES_SHOW_ALL_LINK_TITLE:
      'Click here to learn more about Company Profiles.',
    CP_200_TEASER_CUSTOMER_FEEDBACK:
      '<h4>We need your feedback!</h4>\n<p>Hi, I’m Stefan Gross-Selbeck, CEO at XING. We need your help in making our new Company Profiles even more useful.<br />\n<a href="{link}">Send us your feedback!</a></p>',
    CP_200_TEXTUPDATE_NOT_POSSIBLE:
      'An error occurred: Your Company Profile cannot be edited at this time, as the membership term has expired. If you have any questions, please contact a <a href="/app/help?categories=4&op=start&subject=44&tab=contact" title="Customer Care">Customer Care representative</a>.',
    CP_200_THIS_MONTH: 'This month',
    CP_200_THIS_WEEK: 'This week',
    CP_200_THIS_YEAR: 'This year',
    CP_200_TITLE_COLHEADER: 'Title',
    CP_200_TWITTER_FEED: 'Last update: {last_update}',
    CP_200_TWITTER_SERVICE_INFO:
      "We'll check your Twitter account for new tweets every 30 minutes and then automatically post them here as updates. This may take a little longer the first time you do this.",
    CP_200_TWITTER_SUBHEADER: 'From your Twitter accounts',
    CP_200_TWITTER_VALIDATION_ERROR:
      "That's a great name, but unfortunately you can only use letters, numbers and underscores in your Twitter name.",
    CP_200_TYPE_LABEL: 'Type',
    CP_200_UNFOLLOW_LINK: 'Unfollow',
    CP_200_UNFOLLOW_LINK_ALT: 'Unfollow',
    CP_200_UNFOLLOW_LINK_SHORT: 'Unfollow',
    CP_200_UNKNOWN_AGE: 'Age unknown',
    CP_200_UPLOAD_HEADER_GRAPHIC_LINK: 'Upload cover image',
    CP_200_UPLOAD_LOGO: 'Upload logo',
    CP_200_USER_VIEW_TEXT_LIGHTBOX:
      "This is the visitors' view of your profile. Please go back to the editor view to edit your profile.",
    CP_200_USER_VIEW_TITLE_LIGHTBOX:
      'This is what your profile looks like to visitors.',
    CP_200_VALIDATION_ERROR_KEYWORD_LIMIT_EXCEEDED:
      'Please enter a maximum of %d keywords.',
    CP_200_VISITORS_TO_YOUR_COMPANY: 'Visitors',
    CP_200_VOUCHER_HEADLINE: 'XING Premium Vouchers',
    CP_200_VOUCHER_TEXT:
      'Perfect for a special occasion, as an incentive or simply a small gesture of thanks: You can now give the gift of XING Premium Membership in the form of <a href="http://voucher.xing.com/?dpt=mcmhh&ttp=teaser&plf=own&pid=cpts&xtr=36" >XING Vouchers</a>.',
    CP_200_WARNING_STATISTICS_NOT_ENABLED:
      'Statistics features are available with an Employer Branding Profile. Interested? Please send an e-mail to <a href="mailto:employer-brandig@xing.com">employer-branding@xing.com</a>.',
    CP_200_WARNING_UNFOLLOW_UNCLAIMED:
      "Please note: You will no longer receive updates from this company.<br />\nIt is not possible to re-subscribe to this company's updates at present, as the company is not currently providing updates.",
    CP_202_SHOW_EVENTS_FILTER: 'Show:',
    CP_204_LIKE_LIGHTBOX_HEADLINE: 'The following members like this update:',
    CP_204_LIKE_LINK_ALT: 'Like this update and share it with your network.',
    CP_204_LIKE_LINK_TEXT: 'Like',
    CP_204_LIKE_TOOLTIP: '{number} member likes this update.',
    CP_204_LIKE_TOOLTIP_PLURAL: '{number} members like this update.',
    CP_204_UNLIKE_LINK_ALT: 'You liked this update and can unlike it here.',
    CP_204_UNLIKE_LINK_TEXT: 'Unlike',
    CP_205_EMPLOYEES_LINK_PLURAL: 'employees',
    CP_205_FOLLOWERS_LINK: 'follower',
    CP_205_FOLLOWERS_LINK_PLURAL: 'followers',
    CP_205_UPDATES_LINK: 'update',
    CP_205_UPDATES_LINK_PLURAL: 'updates',
    CP_300_ABOUT_CP_BASIC_DESCRIPTION:
      'XING automatically generates Company Profiles based on the XING profiles of employees. Companies can then edit these profiles for free and add information to customize them. When this happens, the automatically generated profile is then upgraded to a BASIC Profile. These profiles offer you:\n<ul class="bullet-list">\n<li>an overview of a company’s key information, e.g., no. of employees or interesting employee statistics</li>\n<li>a quick list of employees who you can get in touch with in just a few clicks of your mouse</li>\n<li>an overview of the company’s job ads on XING</li>\n</ul>',
    CP_300_ABOUT_CP_BASIC_H2:
      'Automatically generated and BASIC Company Profiles',
    CP_300_ABOUT_CP_H1: 'Discover Company Profiles on XING',
    CP_300_ABOUT_CP_INFOBOX_H3:
      'Get the latest news by following Company Profiles!',
    CP_300_ABOUT_CP_INTRO:
      "XING Company Profiles helps you to find the right contact and provide you with quick access to key company information such as contacts, statistics and updates. And to top it all off, you can subscribe to a company's updates to automatically receive the latest company news!",
    CP_300_ABOUT_CP_LINK_TO_PDF: 'More information about Company Profiles',
    CP_300_ABOUT_CP_LINK_TO_VIDEO: 'Watch video',
    CP_300_ABOUT_CP_PLUS_DESCRIPTION:
      'PLUS Company Profiles are updated by the companies themselves which regularly send their latest news to members who subscribe. The following features are also available to you as a user:\n<ul class="bullet-list">\n<li>You can subscribe to Company updates, e.g. of your service providers or companies from your industry which then appear on your XING homepage</li>\n<li>You can connect to interesting companies or your dream employers</li>\n<li>You can find out about a company\'s latest news, their current job vacancies, and special offers</li>\n</ul>',
    CP_300_ABOUT_CP_PLUS_H2: 'PLUS Company Profile',
    CP_300_ABOUT_CP_STANDARD_DESCRIPTION:
      'Companies also update their STANDARD Company Profiles on a regular basis. With STANDARD Company Profiles you can:\n<ul class="bullet-list">\n<li>find out more information about a company, e.g. products, services and corporate culture</li>\n<li>find the right contact for your business</li>\n<li>view your direct connection paths to a company</li>\n</ul>',
    CP_300_ABOUT_CP_STANDARD_H2: 'STANDARD Company Profile',
    CP_300_ABOUT_CP_TEASER_HEADING: 'Find companies on XING',
    CP_300_ABOUT_CP_TEASER_LINK: 'Browse or search all companies',
    CP_300_ABOUT_CP_TEASER_NO_CP_HEADING: 'Create a Company Profile',
    CP_300_ABOUT_CP_TEASER_NO_CP_LINK: 'Create Company Profile now',
    CP_300_ABOUT_CP_TEASER_NO_CP_TEXT:
      'Don\'t have a Company Profile yet? No problem! Create a <strong>free</strong> Company Profile on XING to professionally showcase your references and products or services. <a href="/companies/contract/select_package">More Information</a>.',
    CP_300_ABOUT_CP_TEASER_PAID_CP_HEADING: 'Your Company Profile',
    CP_300_ABOUT_CP_TEASER_PAID_CP_LINK: 'Go to your Company Profile',
    CP_300_ABOUT_CP_TEASER_PAID_CP_TEXT:
      'Your company already has a XING Company Profile.',
    CP_300_ABOUT_CP_TEASER_TEXT:
      'Are you looking for a business partner, service provider, or are you interested in a specific company?',
    CP_300_ABOUT_CP_TEASER_UNBOUGHT_CP_HEADING:
      'Draw attention to your company!',
    CP_300_ABOUT_CP_TEASER_UNBOUGHT_CP_LINK: 'Show more information',
    CP_300_ABOUT_CP_TEASER_UNBOUGHT_CP_TEXT:
      'Customize your Company Profile as a marketing and sales channel, as a way of presenting the company as an attractive employer, and as a means of communication with clients, former employees, and applicants.',
    CP_300_BUTTON_SUBMIT_FILE: 'Upload file',
    CP_300_CALLOUT_BASIC_BODY:
      'With an Employer Branding Profile you can add to up to 30 modules. Interested? Just send an e-mail to <a href="mailto:employer-branding@xing.com">employer-branding@xing.com</a>.',
    CP_300_CALLOUT_BASIC_HEADER:
      "You're now using all 2 modules available for your images and PDFs.",
    CP_300_CALLOUT_EMPLOYER_BRANDING_BODY:
      '<strong>Tip:</strong> You can update the content of your boxes with new content anytime.',
    CP_300_CALLOUT_EMPLOYER_BRANDING_HEADER:
      "You're now using all 30 available boxes for pictures, PDFs, videos and presentations.",
    CP_300_CALLOUT_IMPORT_FEEDS:
      '<span class="new-sign bold">NEW</span> Company updates automatically imported via RSS feed!',
    CP_300_CALLOUT_PLUS_BODY:
      'Tip: You can update and replace the content in these modules at any time.',
    CP_300_CALLOUT_PLUS_HEADER:
      "You're now using all 30 modules available for your images, PDFs, videos, and presentations.",
    CP_300_CALLOUT_PRO_BODY:
      '<strong>Tip:</strong> You can edit and update this content at any time.',
    CP_300_CALLOUT_PRO_HEADER:
      "You're now using all 30 available modules for your images, PDF files, videos, and presentations.",
    CP_300_CALLOUT_STANDARD_BODY:
      'With an Employer Branding Profile you can add to up to 30 modules as well as videos here. Interested? Just send an e-mail to <a href="mailto:employer-branding@xing.com">employer-branding@xing.com</a>.',
    CP_300_CALLOUT_STANDARD_HEADER:
      "You're now using all 10 modules available for your images and PDFs.",
    CP_300_COMPANIES_EXIST:
      'There are already Company Profiles for the companies listed on your profile as an employer. Please edit the company or employer name you entered on <a href="{profile_url}">your profile</a>.',
    CP_300_CONTACT_PERSON_HR_CHECKBOX: 'Show as contact in jobs tab',
    CP_300_CONTACT_PERSON_PLACEHOLDER_DESCRIPTION:
      "Get in touch with me if you're interested in any of our vacancies.",
    CP_300_CONTACT_PERSON_PLACEHOLDER_FIRST_NAME: 'Jane',
    CP_300_CONTACT_PERSON_PLACEHOLDER_LAST_NAME: 'Doe',
    CP_300_CONTACT_PERSON_PLACEHOLDER_TITLE: 'HR manager',
    CP_300_CONTACTS_HR_INFO:
      'You can select more contact people for the jobs tab. All of the contact people will then appear in the employee tab.',
    CP_300_CONTACTS_PLACEHOLDER_TEXT:
      'Please enter the name of the contact person at the company. You can also choose to display this information in the jobs tab.',
    CP_300_CREATE_MINIMAL_VERSION_BUTTON: 'Create Company Profile now',
    CP_300_CREATE_MINIMAL_VERSION_H2:
      'What are the benefits of a Company Profile?',
    CP_300_CREATE_MINIMAL_VERSION_HEADLINE:
      'No Company Profile exists for "{company_name}"',
    CP_300_CREATE_MINIMAL_VERSION_INFO_1_HEADING:
      'Please check the spelling of your company name',
    CP_300_CREATE_MINIMAL_VERSION_INFO_1_TEXT:
      'Maybe your company has already been created under a similar name (e.g. \'Company name Inc.\' rather than \'Company name\'). Please check whether a Company Profile has already been created by carrying out a <a href="/companies">company search</a>. Then you can adapt the spelling of your company name in your <a href="{userprofile}">member profile</a> or ask your colleagues to do the same.',
    CP_300_CREATE_MINIMAL_VERSION_INFO_2_HEADING:
      'Invite your colleagues to join XING',
    CP_300_CREATE_MINIMAL_VERSION_INFO_2_TEXT:
      'As soon as there are 5 XING member profiles with an identical company name, a Company Profile will be created automatically. <a href="/app/invite">Invite colleagues now</a>',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_HEADING: 'Request a Company Profile',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_LIST_ITEM_1:
      'At least two XING members need to have entered their company name spelled identically in their profile to be able to request a Company Profile.',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_LIST_ITEM_2:
      'Automatically generated Company Profiles cannot be edited. If you want to customize your profile, you need to upgrade after your profile has been generated.',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_TEXT:
      'If a Company Profile was not set up despite having fulfilled these two points, you can request a Company Profile here. Please note the following:',
    CP_300_CREATE_MINIMAL_VERSION_LIST_ITEM_1:
      'Your company is listed in Company Profiles on XING',
    CP_300_CREATE_MINIMAL_VERSION_LIST_ITEM_2:
      'An up-to-date employee list so people following your company can easily find the right contact',
    CP_300_CREATE_MINIMAL_VERSION_TEXT:
      '<p>There is no Company Profile for the company "{company_name}" you\'ve indicated as your current position. Company Profiles are automatically generated as soon as 5 XING members have an identical company name listed in their profile. </p>',
    CP_300_DELETE_CONFIRMATION: 'Really delete?',
    CP_300_DELETE_ERROR: 'Sorry, something went wrong. Please try again.',
    CP_300_EDIT_COMPANY_PROMPT:
      'You can edit your company name in <a href="{profile_url}">your profile</a>. As a freelancer you can enter your name and service offering, e.g. John Smith - Web Design, here.',
    CP_300_ERROR_EMPTY_URL: 'Please add a link to your video or presentation.',
    CP_300_ERROR_INVALID_URL:
      'Sorry, but this link is invalid. Please check it again.',
    CP_300_ERROR_SOMETHING_WENT_WRONG:
      'Sorry, something  went wrong. Please try again.',
    CP_300_FILE_DESCRIPTION_LABEL:
      'Add an optional description for this image/PDF (max. 200 characters).',
    CP_300_GALLERY_ADD_ITEM_INFO: "Boost your Company Profile's appeal!",
    CP_300_JOBS_PLACEHOLDER_CITY: 'Hamburg',
    CP_300_JOBS_PLACEHOLDER_COMPANY: 'Surface* Media',
    CP_300_JOBS_PLACEHOLDER_TEXT:
      'Looking for skilled employees? Search XING now:',
    CP_300_JOBS_PLACEHOLDER_TITLE_1: 'HR trainee',
    CP_300_JOBS_PLACEHOLDER_TITLE_2: 'Marketing manager',
    CP_300_NOTICE_CREATE_MINIMAL_VERSION:
      "We've created the company profile. As soon as two or more XING member profiles match the company, we'll release it live within 24 hours.",
    CP_300_PENDING_FUNCTION_NOT_AVAILABLE:
      'This feature will be available once your company profile has been activated.',
    CP_300_REMOTE_DESCRIPTION_LABEL:
      'Feel free to add a description (max. 200 characters).',
    CP_300_SALES_PAGE_FEATURE_1:
      'Detailed employer information and company logo',
    CP_300_SALES_PAGE_FEATURE_10: 'Various report and statistics features',
    CP_300_SALES_PAGE_FEATURE_11:
      'Automatically generated list of employees on XING',
    CP_300_SALES_PAGE_FEATURE_13: 'Post company updates',
    CP_300_SALES_PAGE_FEATURE_14:
      'Freely definable keywords that make it easier to find your profile on XING',
    CP_300_SALES_PAGE_FEATURE_15:
      'Single contact person for both platforms (incl. editorial support, reports, advice, etc.)',
    CP_300_SALES_PAGE_FEATURE_2: 'Genuine employer reviews and services',
    CP_300_SALES_PAGE_FEATURE_3: 'Add videos, images, presentations, etc.',
    CP_300_SALES_PAGE_FEATURE_4:
      'Points of contact and information for applicants',
    CP_300_SALES_PAGE_FEATURE_5:
      'Ads for your business on competitor profiles (industry targeting)',
    CP_300_SALES_PAGE_FEATURE_7: 'Use of the employer quality seals',
    CP_300_SALES_PAGE_FEATURE_8:
      'Your reserved job ads are listed on your Employer Branding Profile',
    CP_300_SALES_PAGE_FEATURE_9: 'Subsidiaries and partners listed on XING',
    CP_300_SALES_PAGE_FEATURE_FREE: 'Free profile',
    CP_300_SALES_PAGE_FEATURE_FREE_1: 'Free employer profile on XING',
    CP_300_SALES_PAGE_FEATURE_FREE_2: 'Company logo and description',
    CP_300_SALES_PAGE_FEATURE_FREE_3:
      'Prominent placement of your XING job offers',
    CP_300_SALES_PAGE_FEATURE_FREE_4:
      'Automatically generated list of employees',
    CP_300_SALES_PAGE_FEATURE_FREE_5: 'Post company updates',
    CP_300_SALES_PAGE_FEATURE_FUNCTIONS: 'Benefits',
    CP_300_SALES_PAGE_FEATURE_PROFILE: 'Employer Branding Profile',
    CP_300_SALES_PAGE_PRICES_EMPLOYEES_HEADLINE: 'Employees',
    CP_300_SALES_PAGE_PRICES_NUMBER_1: '1 - 199',
    CP_300_SALES_PAGE_PRICES_NUMBER_2: '200 - 499',
    CP_300_SALES_PAGE_PRICES_NUMBER_3: '500 - 999',
    CP_300_SALES_PAGE_PRICES_NUMBER_4: '1,000 - 4,999',
    CP_300_SALES_PAGE_PRICES_NUMBER_5: '> 5,000',
    CP_300_SALES_PAGE_PRICES_PRICE_1: 'EUR 395',
    CP_300_SALES_PAGE_PRICES_PRICE_2: 'EUR 495',
    CP_300_SALES_PAGE_PRICES_PRICE_3: 'EUR 695',
    CP_300_SALES_PAGE_PRICES_PRICE_4: 'EUR 895',
    CP_300_SALES_PAGE_PRICES_PRICE_5: 'EUR 1,095',
    CP_300_SALES_PAGE_PRICES_TABLE: 'Monthly price',
    CP_300_SALES_VANITY_URL:
      'Personalized link (e.g. "www.xing.com/company/your-company")',
    CP_300_SETTINGS_CHANGE_EDITOR: 'Change editor',
    CP_300_SETTINGS_CONTACT_CHOOSER_INTRO_INFO:
      'Please enter an employee name.',
    CP_300_SETTINGS_CONTACT_CHOOSER_NOT_FOUND:
      "We couldn't find any employees with that name. Please check the spelling again.",
    CP_300_SETTINGS_EDITOR_HEADING: 'Editor management',
    CP_300_SETTINGS_EDITOR_INFO: 'BASIC profiles can appoint 1 editor.',
    CP_300_SETTINGS_EDITOR_PROMPT_HEADING: 'Really reassign the editor?',
    CP_300_SETTINGS_EDITOR_PROMPT_TEXT:
      "<strong>N.B.</strong>: If you reassign the main editor you won't be able to undo it as you'll no longer have the necessary rights.",
    CP_300_SETTINGS_EDITOR_SIDEINFO:
      "<strong>N.B.</strong>: If you reassign the main editor you won't be able to undo it as you'll no longer have the necessary rights.",
    CP_300_SETTINGS_ERROR_PERMITTED:
      'You can use lower-case letters, numbers and dashes.',
    CP_300_SETTINGS_ERROR_UNIQUE:
      'Unfortunately this URL has already been assigned. Please try a different one.',
    CP_300_SETTINGS_GENERAL_HEADER: 'General settings',
    CP_300_SETTINGS_LEGAL:
      '<strong>Note:</strong> By changing the link to your company profile, you accept <a href="{link}">our Terms and Conditions</a> and, above all, you declare that you are using your company\'s name and that you are not infringing copyrights.',
    CP_300_SETTINGS_PAGE_HEADER: "Your company profile's settings",
    CP_300_SETTINGS_PERMITTED_INFO:
      'You can use lower-case letters (excluding diacritics), numbers and dashes.',
    CP_300_SETTINGS_URL_CALLOUT:
      '<strong>Tip:</strong> Now you can change the link to your company profile!',
    CP_300_SETTINGS_URL_CHANGE:
      'In order to change the link to your company profile again please send an e-mail to <a href="mailto:companyprofiles@xing.com">companyprofiles@xing.com</a>.',
    CP_300_SETTINGS_URL_CONFIRM_HEADER: 'Watch for typos in your link!',
    CP_300_SETTINGS_URL_CONFIRM_TEXT:
      '<p>After clicking on &quot;Save&quot;, the link to your company profile will appear as follows:</p>\n\n<p><strong>{new_url}</strong></p>\n\n<p>Therefore, we strongly recommend you check the link for spelling mistakes before clicking on save.</p>',
    CP_300_SETTINGS_URL_CURRENT:
      "Here's the link to your Company Profile:<br>\n<strong>{company_url}</strong>",
    CP_300_SETTINGS_URL_EDIT: 'Change',
    CP_300_SETTINGS_URL_HEADER: 'Your XING link',
    CP_300_SETTINGS_URL_INFO:
      "Here's the link to your Company Profile:<br>\n<strong>{company_url}</strong><br><br>\nYou can change it once if you need to.",
    CP_300_SETTINGS_URL_PENDING:
      "Your Company Profile hasn't been activated yet. Once we've done that for you, you can request your personal link.",
    CP_300_SETTINGS_URL_RESET: 'Reset URL',
    CP_300_UPGRADE_TEASER_BENEFITS:
      '<h4>The benefits for you:</h4>\n<ul class="bullet-list">\n  <li><span>Customised design</span></li>\n  <li><span>Company logo plus description</span></li>\n  <li><span>Company updates</span></li>\n  <li><span>Viewable subscriber list</span></li>\n</ul>',
    CP_300_UPGRADE_TEASER_HEADLINE:
      'Use XING to draw attention to your company',
    CP_300_UPGRADE_TEASER_LINK_TO_PDF: 'More information',
    CP_300_UPGRADE_TEASER_LIST:
      '<p>Get a professionally designed Company Profile in just 3 steps:</p>\n<ol>\n  <li>Create Company Profile now</li>\n  <li>Upgrade the Company Profile</li>\n  <li>Have the Company Profile designed professionally</li>\n</ol>',
    CP_300_UPLOAD_DISABLED_LOCAL_TIP:
      'This feature will be available once your profile has been activated.',
    CP_300_UPLOAD_DISABLED_REMOTE_TIP:
      'With an Employer Branding Profile you can also add videos and presentations.',
    CP_300_UPLOAD_FILE_BUTTON: 'Select file',
    CP_300_UPLOAD_FILE_ERROR_FORMAT:
      'Please select a PDF or image file in one of the following formats: JPG, PNG, BMP or GIF.',
    CP_300_UPLOAD_FILE_LABEL: 'Select file',
    CP_300_UPLOAD_FILE_NOTE:
      'You can upload PDFs or images (JPG, PNG, BMP, GIF) up to 5 MB in size per file.',
    CP_300_UPLOAD_FILE_TAB: 'Upload image/PDF',
    CP_300_UPLOAD_IMAGE_ERROR_FORMAT:
      'Please select an image in JPG, PNG, BMP or GIF format.',
    CP_300_UPLOAD_LINK_TAB: 'Link video or presentation',
    CP_300_UPLOAD_PDF_ERROR_FORMAT: 'Please select a PDF file.',
    CP_300_UPLOAD_URL_NOTE: 'You can add content from the following providers:',
    CP_300_URL_DESCRIPTION_LABEL:
      'Add a link to your video or presentation here.',
    CP_300_VAT_NUMBER_LABEL: 'Your VAT ID',
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_BODY:
      "This means you can't edit any images here right now. But head over to the About us section as you can edit your images there instead.",
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_CANCEL: 'Cancel',
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_GO_TO_ABOUT_US:
      'Go to "About us"',
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_HEADLINE:
      'This section is currently being worked on.',
    CP_3562_UPLOAD_RESTRICTIONS_IDEAL_SIZE:
      'Colour model: RGB (no CMYK), ideal size: ',
    CP_3582_ALL_COMPANIES_ARE_CLAIMED_ERROR_BODY:
      'Check it out here: {company_link}',
    CP_3582_ALL_COMPANIES_ARE_CLAIMED_ERROR_BODY_LINK:
      '{company} as an employer',
    CP_3582_ALL_COMPANIES_ARE_CLAIMED_ERROR_TITLE:
      'This employer profile already exists.',
    CP_3582_USER_HAS_NO_CURRENT_POSITION_ERROR_BODY:
      "If so, please add your current position {profile_link}. If not, you can't create an employer profile for {company}.",
    CP_3582_USER_HAS_NO_CURRENT_POSITION_ERROR_BODY_LINK: 'to your profile',
    CP_3582_USER_HAS_NO_CURRENT_POSITION_ERROR_TITLE:
      'Do you work for this company?',
    CP_3582_USER_IS_STUDENT_ERROR_BODY:
      'If so, you can’t create an employer profile. If not, {profile_link}.',
    CP_3582_USER_IS_STUDENT_ERROR_BODY_LINK: 'please update your status',
    CP_3582_USER_IS_STUDENT_ERROR_TITLE: 'Still studying?',
    CP_400_ADV_1_DESCRIPTION:
      'Get your company noticed! Individualize your Company Profile, and reach over 21 million business professionals around the world.',
    CP_400_ADV_1_HEADLINE:
      '<strong>Your marketing and PR instrument</strong> – the XING profile for your company',
    CP_400_ADV_2_DESCRIPTION:
      'XING can help you deliver your Company Profile to the right people. Over 21 million XING members mean over 21 million opportunities for partnerships, cooperation agreements, assignments, and more.',
    CP_400_ADV_2_HEADLINE:
      '<strong>Sales 2.0</strong> – innovative and growing',
    CP_400_ADV_3_DESCRIPTION:
      'Gain a reputation as a top employer, and win over qualified expert candidates. Inform potential applicants about career opportunities in your company.',
    CP_400_ADV_3_HEADLINE:
      '<strong>Recruiting tool & employer branding</strong> - Find and hire top talents',
    CP_400_ADV_4_DESCRIPTION:
      'Share information about new products, innovations, or hot topics. Update subscribers receive company updates on their XING homepage, and stay informed.',
    CP_400_ADV_4_HEADLINE:
      '<strong>Customer retention</strong> – Keep your target group up to date',
    CP_400_ADV_HEADLINE: 'The advantages of a XING Company Profile',
    CP_400_ALL_COMPANIES_CLAIMED_MESSAGE:
      'Company Profiles were already created for the companies listed on your member profile as an employer.',
    CP_400_AVAILABLE_CPS: 'Company Profiles available for your company:',
    CP_400_BASIC_PACKAGE_UPSELL_MESSAGE:
      '{company_name} currently has a BASIC package. Would you like to upgrade to a STANDARD or PLUS package? If so, then please contact {email_address}',
    CP_400_BENEFITS:
      "<dt>Marketing & PR:</dt> \n<dd>Your Company Profile helps you to showcase your business, but only if it's appealing to visitors.</dd>\n<dt>Recruiting & Employer Branding:</dt> \n<dd>Improve your employer branding and let XING members know about career opportunities at your company.</dd>\n<dt>Sales 2.0:</dt> \n<dd>More than 21 million members means more than 21 million opportunities to find new business, cooperation partners, contracts, and more.</dd>\n<dt>Long-term customer loyalty:</dt> \n<dd>Post regular updates about products and services for people to follow. This also helps them to identify with the company and gain their loyalty.</dd>",
    CP_400_BENEFITS_HEADER:
      "Not sure about creating a Company Profile? Here's why you should:",
    CP_400_BILLING_ADDRESS_LEGEND: 'Invoice recipient',
    CP_400_BTN_CHOOSE: 'Select',
    CP_400_CANCELLATION_EMAIL_BODY:
      '<p>Thank you for your message, {firstname}.</p>\n\n<p>We regret your decision to cancel your company profile on XING.</p>\n\n<p>We have saved your cancellation request in our system, so that the contract will not be extended when the current term has expired. From {end_date} your company profile will be downgraded to "Basic". All information contained in "About this company", the list of employees, as well as your logo, list of subscribers and any company updates will remain unchanged.</p>\n\n<p>Obviously, you can reconsider your cancellation at any time by sending an e-mail to {cp_support_email}.</p>\n\n<p>Kind regards,\n<br />The XING Company Profiles team</p>',
    CP_400_CANCELLATION_EMAIL_SUBJECT: 'We have received your cancellation',
    CP_400_CHANGE_COMPANY_LINK: 'Change company',
    CP_400_CLAIMING_FORM_ADD_ADDRESS_TEXT:
      "Please enter your address here, making sure that you don't forget to add your company's legal form.",
    CP_400_CLAIMING_FORM_BILLING_ADDRESS: 'Billing details',
    CP_400_CLAIMING_FORM_CHANGE_COMPANY_LABEL: 'Company',
    CP_400_CLAIMING_FORM_CHOOSE_COMPANY:
      'The following companies are listed as an employer in your user profile. Please select the company you want to create a Company Profile for.',
    CP_400_CLAIMING_FORM_CHOSEN_PACKAGE: 'Selected product',
    CP_400_CLAIMING_FORM_CONTACT_ADDRESS: 'Enter your contact address',
    CP_400_CLAIMING_FORM_DESCRIPTION:
      '{company_profile}, {duration} - {package_name}',
    CP_400_CLAIMING_FORM_HEADLINE: 'Create Company Profile',
    CP_400_CLAIMING_FORM_HINT_1:
      'Please note: The invoice will be addressed to your company and not you personally, but your name will appear in the body of the invoice. <strong>Please make sure you enter the full company name including organisation type (e.g. Ltd., PLC)</strong>',
    CP_400_CLAIMING_FORM_HINT_2: 'The invoice is written in English.',
    CP_400_CLAIMING_FORM_PAYMENT_COMMENT:
      'You will be invoiced for the total amount, and the invoice will be sent to the address indicated above.',
    CP_400_CLAIMING_FORM_PRICE: 'Net price',
    CP_400_CLAIMING_FORM_PRICE_FREE: 'Price',
    CP_400_CLAIMING_FORM_STEP1_TEXT: 'Enter billing details',
    CP_400_CLAIMING_FORM_STEP2_TEXT: 'Double check your info',
    CP_400_CLAIMING_FORM_TANC:
      'I {full_user_name} hereby pledge that I am authorized to edit the {company_name} Company Profile. I understand that the XING General Terms & Conditions apply to all contents posted, as do the T&C for XING Company Profiles, and agree to adhere to both policies.',
    CP_400_CLAIMING_HEADLINE: 'Your professional corporate presence on XING',
    CP_400_CLAIMING_PENDING_MESSAGE:
      "Your request will now be sent to XING for authorisation. We'll check to make sure you're permitted to maintain this Company Profile. As a rule, you'll hear from us very quickly, and will receive an e-mail notification no later than 48 hours from now.",
    CP_400_COMPANY_ALREADY_CLAIMED_MESSAGE:
      "We're sorry, your request could not be completed. Another XING member has recently claimed this Company Profile. Please check back in a few days to see who has acquired editing rights for the profile.",
    CP_400_COMPANY_INVOICE_CONTACT_NAME: 'Contact person',
    CP_400_COMPANY_LABEL: 'Company',
    CP_400_COMPANY_NAME: 'Company (profile name)',
    CP_400_COMPANY_PROFILE: 'Company Profile',
    CP_400_CONFIRM_NAME_GO_TO_PROFILE: 'Edit your company name on your profile',
    CP_400_CONFIRM_NAME_PROCEED: 'Confirm company name',
    CP_400_CONFIRM_NAME_TEXT_1:
      'Please use your full company name, e.g. "Macrosoft Inc.".<br>\nAs a freelancer you can link your job to your name, e.g. "SAP consultant John Doe".',
    CP_400_CONFIRM_NAME_TEXT_2:
      'According to your profile, your company name is:',
    CP_400_CONFIRM_NAME_TIPS: '&nbsp;',
    CP_400_CONFIRM_NAME_TITLE: 'Have you entered your company name correctly?',
    CP_400_CONTACT_ADDRESS_LEGEND: 'Contact address',
    CP_400_CONTACT_EMAIL: 'E-mail',
    CP_400_CONTACT_HEADLINE: 'Any questions?',
    CP_400_CONTACT_LABEL: 'Your first and last name',
    CP_400_CONTACT_LINK: 'Contact us!',
    CP_400_CONTACT_TEL: 'Tel:',
    CP_400_CONTACT_WEB: 'Web:',
    CP_400_CP_BASIC_TITLE: 'Basic',
    CP_400_CP_EXAMPLES_HEADLINE: 'Examples of Company Profiles',
    CP_400_CP_EXAMPLES_TEXT:
      'Get inspired: See how other companies design their profiles.',
    CP_400_CP_PLUS_TITLE: 'Plus',
    CP_400_CP_STANDARD_TITLE: 'Standard',
    CP_400_CP_TITLE: 'Company Profile',
    CP_400_CREATE_CP_COMPANY_NAME_ERROR_MESSAGE:
      "For security reasons, the company name can't be a web address (URL). Please provide a different name.",
    CP_400_CREATE_CP_WELCOME_MESSAGE_BASIC_WARNING:
      'Please note that we grant editor rights to colleagues of yours if they decide to upgrade the Company Profile to a higher package. In this case you have to contact the new editor who can add you as a co-editor.',
    CP_400_CREATE_CP_WELCOME_MESSAGE_CUSTOMIZE_LINK:
      'Customise your Company Profile now',
    CP_400_CREATE_CP_WELCOME_MESSAGE_HEADING:
      'Welcome to your Company Profile!',
    CP_400_CREATE_CP_WELCOME_MESSAGE_PDF_LINK:
      'Please refer to our Company Profiles quick guide for more information.',
    CP_400_CREATE_CP_WELCOME_MESSAGE_TEXT:
      "Your Company Profile was successfully created. Your profile will be activated and accessible to other XING members in about 48 hours' time as we check every single Company Profile request.",
    CP_400_CREATE_CP_WELCOME_MESSAGE_TIPS:
      '<h4>Tips for your new profile:</h4>\n<ul class="bullet-list"><li>Upload your company logo</li>\n<li>Customize your short description</li>\n<li>Check your data for accuracy.</li>\n</ul>',
    CP_400_DETAILS_PDF_LINK: 'More details about Company Profile packages',
    CP_400_ERROR_ACCEPT_TANDC:
      'Please accept the Terms and Conditions to continue.',
    CP_400_ERROR_DURING_UPLOAD:
      'Sorry, an error occurred while uploading the file.',
    CP_400_FEATURED_COMPANIES_HEADLINE: 'Featured employers',
    CP_400_HEADLINE: 'Your professional Company Profile on XING',
    CP_400_INTRO:
      'With a custom-designed Company Profile on XING, you can reach managers, job candidates and decision makers where they network every day. Communicate with clients, former employees, and applicants, and present your company to over 12 million XING members.',
    CP_400_LINK_FAQ: 'Company Profiles FAQ',
    CP_400_LINK_FAQ_HREF:
      '/help/help-and-faqs-2/the-features-of-xing-53/company-profiles-420',
    CP_400_LINK_TANDC: 'Terms and Conditions for XING Company Profiles',
    CP_400_MEDIADATA_PDF_LINK: 'XING user structure',
    CP_400_MONTHLY: 'a month',
    CP_400_MORE_INFO: 'More information about Company Profiles',
    CP_400_MORE_INFO_HEADLINE: 'More information',
    CP_400_MORE_INFO_PDF:
      "We've put all the details and benefits into a PDF file for you.",
    CP_400_MORE_INFO_PDF_LINK: 'XING Company Profiles: Product Overview',
    CP_400_MORE_INFO_TEXT:
      'Would you like to bundle your Company Profile with an ad on XING?<br/>\nWould you like a personal consultation?<br/>\nDo you have other questions?',
    CP_400_MORE_INFO_VIDEO: 'Check out the Company Profiles video',
    CP_400_MORE_INFO_VIDEO_LINK: 'XING Company Profiles: The Video',
    CP_400_NO_COMPANY_MESSAGE:
      'You are not assigned to a company at the moment. Please update your <a href="{profile_link}">profile</a> and add your current employer under “Professional experience".',
    CP_400_OFFER_HEADLINE: 'XING March special offer',
    CP_400_OTHER_PRODUCTS_HEADLINE:
      'Companies with a Company Profile also use the following products',
    CP_400_PACKAGE_BASIC_ADVANTAGES:
      '<ul class="bullet-list">\n<li>"About us" page together with your company’s logo</li>\n<li>Upload images and PDFs</li>\n<li>Option to post company updates</li>\n</ul>',
    CP_400_PACKAGE_BASIC_CLAIM: 'The free version to get you started',
    CP_400_PACKAGE_BASIC_SHOW_EXAMPLE: 'Example of a BASIC profile',
    CP_400_PACKAGE_BASIC_TITLE: 'BASIC',
    CP_400_PACKAGE_BUY_CP: 'Request now',
    CP_400_PACKAGE_COMPARISION_AD_FREE: 'No ads',
    CP_400_PACKAGE_COMPARISON_BENEFITS_1: 'Visibility',
    CP_400_PACKAGE_COMPARISON_BENEFITS_2: 'Interactivity',
    CP_400_PACKAGE_COMPARISON_BENEFITS_3: 'Connectivity',
    CP_400_PACKAGE_COMPARISON_BENEFITS_4: 'Design options',
    CP_400_PACKAGE_COMPARISON_BENEFITS_HEADING: 'Benefits',
    CP_400_PACKAGE_COMPARISON_COMPANY_UPDATES:
      'Unternehmens-Neuigkeiten schreiben',
    CP_400_PACKAGE_COMPARISON_FEATURE_1: 'Company logo and description',
    CP_400_PACKAGE_COMPARISON_FEATURE_10: 'Access to list of followers',
    CP_400_PACKAGE_COMPARISON_FEATURE_11: 'Max. number of profile editors',
    CP_400_PACKAGE_COMPARISON_FEATURE_12: 'Post company updates',
    CP_400_PACKAGE_COMPARISON_FEATURE_14: 'Add videos and presentations',
    CP_400_PACKAGE_COMPARISON_FEATURE_2:
      'Prominent placement of your XING job offers',
    CP_400_PACKAGE_COMPARISON_FEATURE_3:
      'Automatically generated list of employees',
    CP_400_PACKAGE_COMPARISON_FEATURE_4:
      'Can be found by Google, Bing, etc. (optional)',
    CP_400_PACKAGE_COMPARISON_FEATURE_5:
      'Max. no. of contacts in contact section',
    CP_400_PACKAGE_COMPARISON_FEATURE_6:
      'Max. number of keywords to boost findability',
    CP_400_PACKAGE_COMPARISON_FEATURE_7: 'Linkable cover image',
    CP_400_PACKAGE_COMPARISON_FEATURE_8:
      'Access to visitor and follower statistics',
    CP_400_PACKAGE_COMPARISON_FEATURE_9:
      'Max. number of images/PDFs that can be uploaded',
    CP_400_PACKAGE_COMPARISON_FEATURE_CROSS: 'No',
    CP_400_PACKAGE_COMPARISON_FEATURE_TICK: 'Yes',
    CP_400_PACKAGE_COMPARISON_FEATURES_HEADING: 'Features',
    CP_400_PACKAGE_COMPARISON_HEADING: 'The right package for your company',
    CP_400_PACKAGE_COMPARISON_INFO:
      'This functionality is optional and can be deactivated if required.',
    CP_400_PACKAGE_COMPARISON_NUM_CHARS: '{num} characters',
    CP_400_PACKAGE_COMPARISON_PROFILE_VISITORS:
      'See who visited your Company Profile',
    CP_400_PACKAGE_COMPARISON_STATISTICS: 'Besucher- und Follower-Statistik',
    CP_400_PACKAGE_COMPARISON_SUBHEADING:
      'The benefits of the three different product packages at a glance:',
    CP_400_PACKAGE_COMPARISON_TWEETS_IMPORT:
      'Automatischer Import von Unternehmens-Tweets',
    CP_400_PACKAGE_COMPARISON_XING_SEARCH_RESULTS_VISIBILITY:
      'Highlighted entry in search results',
    CP_400_PACKAGE_CREATE_CP: 'Create now',
    CP_400_PACKAGE_DETAILS_LINK: 'Compare details',
    CP_400_PACKAGE_FREE: 'Free',
    CP_400_PACKAGE_HEADER_HEADING:
      'Your XING Company Profile:<br>\nShowcase your products, services and jobs',
    CP_400_PACKAGE_HEADER_INTRO:
      '<p>Draw even more attention to your company and reach out to over 21 million XING members. Whether you\'re a SME or business with operations worldwide, you can use an employer profile to boost your company\'s image as an attractive employer.</p>\n\n<p><a href="{pdf_link}">More information about employer profiles (PDF)</a></p>',
    CP_400_PACKAGE_HEADER_INTRO_SHORT:
      "Draw even more attention to your company and reach out to over 21 million XING members. Whether you're an SME or a multinational, you can use an employer profile to boost your company's image as an attractive employer.",
    CP_400_PACKAGE_INVOICE_INFORMATION:
      'You will receive an invoice for the annual fee by mail.',
    CP_400_PACKAGE_M: 'Plus',
    CP_400_PACKAGE_M_ADV_1: 'Including all STANDARD features',
    CP_400_PACKAGE_M_ADV_2: 'Customised design',
    CP_400_PACKAGE_M_ADV_3: 'Unlimited company updates',
    CP_400_PACKAGE_M_ADV_4: 'Company updates by subscription',
    CP_400_PACKAGE_M_ADV_5: 'Public follower lists',
    CP_400_PACKAGE_M_CLAIM: 'Your innovative presence',
    CP_400_PACKAGE_PLUS: 'Plus',
    CP_400_PACKAGE_PLUS_ADVANTAGES:
      '<ul class="bullet-list">\n<li>All of the STANDARD benefits</li>\n<li>Linkable cover image that can be changed as often as you like</li>\n<li>See who visited your Company Profile</li>\n<li>Visitor and follower statistics as well as traffic and profile analysis</li>\n<li>Add videos and presentations</li>\n</ul>',
    CP_400_PACKAGE_PLUS_CLAIM: 'With exclusive visitor and follower statistics',
    CP_400_PACKAGE_PLUS_SHOW_EXAMPLE: 'Example of a PLUS profile',
    CP_400_PACKAGE_PLUS_TITLE: 'PLUS',
    CP_400_PACKAGE_S: 'Standard',
    CP_400_PACKAGE_S_ADV_1: 'With detailed company description and logo',
    CP_400_PACKAGE_S_ADV_2: 'Link to your ads on XING Jobs',
    CP_400_PACKAGE_S_ADV_3: 'Current employee list',
    CP_400_PACKAGE_S_ADV_4:
      'Profile can be found by search engines – this increases visibility and reach',
    CP_400_PACKAGE_S_CLAIM: 'Your company on XING',
    CP_400_PACKAGE_STANDARD: 'Standard',
    CP_400_PACKAGE_STANDARD_ADVANTAGES:
      '<ul class="bullet-list">\n<li>All of the BASIC benefits</li>\n<li>Improved visibility thanks to freely definable keywords</li>\n<li>"Contact" page listing people to get in touch with at the company</li>\n<li>Up to 5 profile editors</li>\n</ul>',
    CP_400_PACKAGE_STANDARD_CLAIM:
      'Increase your company’s visibility on XING and the Internet!',
    CP_400_PACKAGE_STANDARD_SHOW_EXAMPLE: 'Example of a STANDARD profile',
    CP_400_PACKAGE_STANDARD_TITLE: 'STANDARD',
    CP_400_PACKAGE_UPSELL_CP: 'Upgrade now',
    CP_400_PACKAGE_UPSELL_HEADING: 'First-class status for your company',
    CP_400_PACKAGE_UPSELL_INTRO:
      '<p>Draw even more attention to your company and reach out to over 20 million potential clients, business partners and candidates - with a <strong>STANDARD</strong> or <strong>PLUS</strong> Company Profile!</p>\n<ul class="bullet-list">\n<li>Increased reach</li>\n<li>Personalized design options</li>\n<li>Interaction with your target group</li>\n</ul>\n<p><a href="{pdf_link}">More information about Company Profiles (PDF)</a></p>',
    CP_400_PACKAGES_FOOTNOTE:
      'The minimum term is 12 months, and will be extended by the same term.',
    CP_400_PACKAGES_FOOTNOTE_2: 'The prices shown here are net prices.',
    CP_400_PACKAGES_FOOTNOTE_3:
      "The profile's search engine visibility can be deactivated if required.",
    CP_400_PACKAGES_FOOTNOTE_4:
      'Invoices will be in euros and include the full package \nprice.',
    CP_400_PACKAGES_FOOTNOTE_SPECIAL_OFFER:
      '<b>Info:</b> The reduced price offer only applies to the minimum term of 12 months. After the 12-month term expires the contract will renew automatically for another 12 months at a price of €24.90 per month.',
    CP_400_PACKAGES_FOOTNOTE_UPSELL:
      'Subject to a minimum term of 12 months. After the 12-month term expires the contract will renew automatically for another 12 months at a price of €24.90/€129.00 per month.',
    CP_400_PACKAGES_UPSELL_VALID_UNTIL: 'Offer valid until November 15, 2010',
    CP_400_PAYING_EDITOR_LINK:
      'This Company Profile is managed by <a href="{userprofile}">{full_user_name}</a>',
    CP_400_PAYMENT_METHOD_LEGEND: 'Method of payment',
    CP_400_PLEASE_CHECK_YOUR_DATA: 'Please double check your data.',
    CP_400_PLUS_PACKAGE_UPSELL_MESSAGE:
      '{company_name} already has a PLUS package.',
    CP_400_PRICE: '{currency}{price}',
    CP_400_PRICE_MONTHLY: '{price} a month',
    CP_400_PRICE_YEARLY: '{price} p.a.',
    CP_400_QUICK_GUIDE_PDF_LINK: 'XING Company Profiles: Quick Guide',
    CP_400_REJECTION_EDITOR_LEFT_COMPANY_EMAIL_SUBJECT:
      'Please request your Company Profile again.',
    CP_400_SPRING_SPECIAL_OFFER_TEXT:
      'Save over 40% now with our summer special offer!',
    CP_400_STANDARD_PACKAGE_UPSELL_MESSAGE:
      '{company_name} currently has a STANDARD package. Would you like to upgrade to a PLUS package? If so, then please contact {email_address}',
    CP_400_START_VIDEO: 'Start video',
    CP_400_SUPPORT_DETAILS:
      'We\'ve put together a list of the <a href="https://xing.force.com/success/s/topic/0TOb000000058WgGAI/employer-branding-profil" target="_blank">main answers to Company Profiles</a> (in German) for you. Please also feel free to contact us on +49 40 41 91 31 784 or by sending an e-mail to <a href="mailto:companyprofiles@xing.com">companyprofiles@xing.com</a>.',
    CP_400_SUPPORT_HEADER: 'Any questions?',
    CP_400_TESTIMONIAL_HEADLINE: 'Stand out from the crowd',
    CP_400_TESTIMONIAL_QUOTE:
      'Our XING Company Profile helps to boost our image as an attractive employer and reach out to potential candidates.',
    CP_400_UPSELL_CONFIRM_LINK1: 'More solutions for your company',
    CP_400_UPSELL_CONFIRM_LINK2: 'Back to XING homepage',
    CP_400_UPSELL_CONFIRM_TEXT:
      'Thanks for your order! We will upgrade your Company Profile within the next 24 hours and send you an e-mail confirmation once this has taken place.',
    CP_400_UPSELL_FOOTNOTE:
      'Upgrade by September 30, 2010, and the Company Profile’s main editor will receive 6 (if upgraded to a STANDARD profile) or 12 (if upgraded to a PLUS profile) free Premium months.',
    CP_400_UPSELL_FORM_HEADLINE: 'Upgrade Company Profile',
    CP_400_UPSELL_FORM_STEP2_TEXT: 'Confirmation',
    CP_400_UPSELL_PLUS_SPECIAL_OFFER_TEXT:
      '+ 12 months Premium Membership for free',
    CP_400_UPSELL_REFERENCE_COMPANIES:
      'Companies that already have a "Standard" or "Plus" profile on XING',
    CP_400_UPSELL_STANDARD_SPECIAL_OFFER_TEXT:
      '+ 6 months Premium Membership for free',
    CP_400_VIDEO_HEADLINE: 'Company Profile video',
    CP_400_WARNING_REVOKED_CONTRACT:
      'At present, this Company Profile cannot be edited. Please try again later.',
    CP_400_WHO_CAN_DESCRIPTION:
      'Every company employee registered on XING has the opportunity to buy usage rights for a Company Profile. Before a purchase is made, XING will confirm that the person is authorized to act on behalf of the company. After authorization by XING, the Company Profile can be edited (within 2 weekdays).',
    CP_400_WHO_CAN_HEADLINE: 'Purchase details',
    CP_401_PACKAGE_DURATION: '{number}-month subscription',
    CP_401_PACKAGE_M: 'PLUS Company Profile',
    CP_401_PACKAGE_S: 'STANDARD Company Profile',
    CP_401_PACKAGE_XS: 'BASIC Company Profile',
    CP_401_TANDC_LABEL:
      'I am authorised to claim this Company Profile and accept the <a id="tandc-link" href="/legal/api/pages/terms_and_conditions/employer-branding-profil.html" target="_blank">{link_text}</a>.',
    CP_405_ADDITIONAL_ADDRESS_LABEL: 'Address (continued)',
    CP_405_FOR_QUERIES_ONLY_INFO: '(For clarification only)',
    CP_405_NO_VAT_NUMBER_LABEL: "I don't have a VAT number.",
    CP_405_PERSON_OF_CONTACT_LABEL: 'Contact person',
    CP_405_SELECTED_PRODUCT_LABEL: 'Selected product',
    CP_405_VAT_NUMBER_LABEL: 'VAT ID number',
    CP_410_ACCEPTED_EDITOR_MAIL_SUBJECT: 'Company Profile Activated',
    CP_410_CONTRACT_REJECTED_EDITOR_LEFT_COMPANY_MAIL_TEXT:
      '<p>{salutation},</p>\n\n <p>You recently requested a Company Profile for {company_name}. Unfortunately we had to decline your request because you edited the company name in your personal profile. We therefore ask you to submit another request with the following company name:</p>\n\n<p><a href="https://www.xing.com/companies/contract/select_package">https://www.xing.com/companies/contract/select_package</a></p>\n\n <p>If you have any other queries, please call us on +49 40 41 91 31 784 or send an e-mail to {cp_support_email}.</p>\n\n <p>Thanks for your understanding in this matter.</p>\n\n <p>Kind regards,\n <br />The XING team\n </p>',
    CP_410_NEW_WORKFLOW_CONTRACT_MAIL_SUBJECT:
      'Nearly done: Activate your XING employer profile now',
    CP_410_NEW_WORKFLOW_SUCCESS_PUBLICATION_SUBJECT:
      'Your XING employer profile is now live!',
    CP_ABOUT_APPLICATION_PROCESS: 'Information about the application process',
    CP_ABOUT_US_PLACEHOLDER:
      "Here you can describe your company: What do you have to offer? What is your company's mission and vision? Why is your company a great place to work?",
    CP_ABOUT_US_PLACEHOLDER_TITLE: 'Present yourself!',
    CP_ABOUT_US_TITLE: 'About us',
    CP_ACTION_PUBLISH: 'Publish',
    CP_ADD_IDEAL_EMPLOYER_FAILURE:
      "Unfortunately that didn't work. Please try again.",
    CP_ADD_IDEAL_EMPLOYER_SUCCESS: 'Added as an ideal employer',
    CP_ANDROID_EMPTY_SEARCH_DESCRIPTION:
      'Please check how you spelled the company name.',
    CP_ANDROID_EMPTY_SEARCH_HEADLINE: 'No results for that',
    'CP_APPLICANTS_RATED_APPLICATION_PROCESS_INNER.one': '{count} applicant',
    'CP_APPLICANTS_RATED_APPLICATION_PROCESS_INNER.other': '{count} applicants',
    'CP_APPLICANTS_RATED_APPLICATION_PROCESS_INNER.zero': 'Nobody',
    CP_APPLICATION_PROCESS_LEARN_MORE:
      'Learn more about the application process',
    CP_APPLICATION_PROCESS_TITLE: 'Application process',
    CP_BADGE_NEW: 'NEW',
    CP_BEST_COMPANIES_BY_CITY_TITLE: 'Employers with excellent ratings in',
    CP_BRANDMANAGER: 'BrandManager',
    CP_CANNOT_CHANGE_LAST_ADMIN:
      "You can't delete the last remaining admin. Please appoint another admin before deleting your account.",
    CP_CANNOT_CHANGE_ROLE: "Unfortunately that role can't be changed.",
    CP_CANNOT_DELETE_LAST_EDITOR:
      'The last editor of the company profile cannot be removed.',
    CP_CANNOT_TRANSFER_OWNERSHIP_TO_SAME_USER:
      'Please transfer ownership to someone else.',
    CP_CARD_CONTACT_INFO: 'Contact details',
    CP_CLAIM_COMPANY_LINK: 'Is this your company?',
    CP_COMPANY_ABOUT_META_DESCRIPTION:
      'Find out what benefits {company_name} offers its employees.',
    CP_COMPANY_ABOUT_PAGE_TITLE: '{company_name} as an employer',
    CP_COMPANY_EMPLOYEES_META_DESCRIPTION:
      'Overview of all XING members who work at {company_name}',
    CP_COMPANY_EMPLOYEES_PAGE_TITLE: '{company_name} employees',
    CP_COMPANY_FACTS: 'Company summary',
    CP_COMPANY_FOLLOWERS_META_DESCRIPTION:
      "See who's following {company_name}.",
    CP_COMPANY_FOLLOWERS_PAGE_TITLE: "{company_name}'s followers",
    CP_COMPANY_JOBS_META_DESCRIPTION:
      "Looking for a job? Check out {company_name}'s vacancies here.",
    CP_COMPANY_JOBS_PAGE_TITLE: 'Vacancies at {company_name}',
    CP_COMPANY_LOGO_LABEL: 'Company logo',
    CP_COMPANY_LOGO_MANDATORY: 'Please add your company logo.',
    CP_COMPANY_NOT_FOUND: "Unfortunately we couldn't find that company.",
    CP_COMPANY_PRODUCTS_AND_SERVICES_META_DESCRIPTION:
      "Overview of {company_name}'s products and services.",
    CP_COMPANY_PRODUCTS_AND_SERVICES_PAGE_TITLE:
      "{company_name}'s products and services",
    CP_COMPANY_REVIEWS_META_DESCRIPTION:
      'How do {company_name} employees rate their company? Find out more here.',
    CP_COMPANY_REVIEWS_PAGE_TITLE: '{company_name}: Employee reviews',
    CP_COMPANY_UPDATES_META_DESCRIPTION:
      "What's new at {company_name}? Find out more here.",
    CP_COMPANY_UPDATES_PAGE_TITLE: "{company_name}'s updates",
    CP_CONTACT_DELETE_CONFIRM:
      'Do you really want to remove this person as a contact?',
    CP_CONTACT_INFO_PLACEHOLDER:
      'Here you can add your various contact details.',
    CP_CONTACT_INFO_PLACEHOLDER_TITLE: 'Add contact details',
    CP_CONTACT_INFO_TITLE: 'Contact',
    CP_CONTACT_OPTIONS: 'Contact options',
    CP_CONTACT_OPTIONS_ERROR: 'Please select at least one form of contact.',
    CP_CONTACT_PEOPLE_TITLE: 'Contact person',
    CP_CONTACT_PERSON_XING_MESSAGE: 'XING message',
    CP_CONTACTS_DESCRIPTION_PLACEHOLDER:
      'Here you can add a short description (max. {chars} characters) listing the scenarios where you should get in touch with this person (e.g. job applications).',
    CP_CONTACTS_FOLLOWING_COMPANY: 'Contacts following this company:',
    CP_CONTACTS_NAME_HINT:
      'Please let this person know that you\'re now the official contact person for your company. Official contacts should also select the "All members" option in the message receipt settings.',
    CP_CONTACTS_PLACEHOLDER:
      'Here you can appoint colleagues as official contacts for certain scenarios.',
    CP_CONTACTS_PLACEHOLDER_TITLE: 'Contacts',
    CP_CONTACTS_TITLE: 'Contacts',
    CP_CONTRACT_DOES_NOT_ALLOW_RSS_FEEDS:
      "Unfortunately, RSS feeds aren't included in your contract.",
    CP_CONTRACT_DOES_NOT_ALLOW_TWITTER_FEEDS:
      "Unfortunately, Twitter feeds aren't included in your contract.",
    CP_CREATE_FREE_PROFILE: 'Create free employer profile',
    CP_DIRECT_TRAFFIC_LABEL: 'Direkt',
    CP_DIRECT_TRAFFIC_SUBTITLE: 'Direkt',
    CP_DOES_NOT_HAVE_VALID_CONTRACT:
      "Unfortunately, this company doesn't have a valid contract.",
    CP_DRAFT_COMPANY_BUTTON_FINISH: 'Continue editing',
    CP_DRAFT_COMPANY_FLAG_WARNING: 'Draft',
    CP_DRAFT_COMPANY_WAITING_APPROVAL: 'Pending approval',
    CP_DUPLICATED_UPDATE:
      'You already posted an update with this content. Try posting some new content instead.',
    CP_EBP_ADD_PDF: 'Add PDF',
    CP_EBP_ADD_PDF_REQUIREMENTS: 'The maximum PDF size is 5 MB.',
    CP_EBP_ADD_PICTURE: 'Add image',
    CP_EBP_ADD_PICTURE_REQUIREMENTS:
      'Max. image size: 5 MB (JPG, PNG, BMP, GIF)',
    CP_EBP_ADD_PRESENTATION: 'Add presentation',
    CP_EBP_ADD_VIDEO: 'Add video',
    CP_EBP_ASSET_CAPTION_PLACEHOLDER:
      'Here you can add a caption of up to 200 characters.',
    CP_EBP_ASSET_CAPTION_TITLE: 'Caption',
    CP_EBP_BENEFITS_CONFIRMED: 'confirmed benefits',
    CP_EBP_COMPANY_PUBLISHED_BANNER: 'Your employer profile is now online!',
    CP_EBP_CROP_HELP:
      'Move the dotted line to select, enlarge and crop the image.',
    CP_EBP_EMPLOYEES_COUNT: 'on XING',
    CP_EBP_GALLERY_ADD: 'Add something',
    CP_EBP_GALLERY_ADD_MAXIMUM_TOOLTIP: "You've used up all of your modules.",
    CP_EBP_GALLERY_EMPTY_PDF: 'PDF',
    CP_EBP_GALLERY_EMPTY_PDF_TEXT:
      'Here you can upload PDF files including interesting articles, employee reviews, etc.',
    CP_EBP_GALLERY_EMPTY_PICTURE: 'Image',
    CP_EBP_GALLERY_EMPTY_PICTURE_TEXT:
      'Here you can upload images to inform people interested in your business.',
    CP_EBP_GALLERY_EMPTY_PRESENTATION: 'Presentation',
    CP_EBP_GALLERY_EMPTY_PRESENTATION_TEXT:
      'Uploaded a corporate presentation on SlideShare? Add it here as well!',
    CP_EBP_GALLERY_EMPTY_VIDEO: 'Video',
    CP_EBP_GALLERY_EMPTY_VIDEO_TEXT:
      'Here you can embed corporate videos you already uploaded to YouTube or Vimeo.',
    CP_EBP_JOB_VACANCIES: 'Jobs',
    CP_EBP_NPO_LABEL: 'Non-profit organisation',
    CP_EBP_PRESENTATION_EMBED: 'Embed presentation',
    CP_EBP_PRESENTATION_EMBED_HINT: 'You can embed SlideShare presentations.',
    CP_EBP_PRESENTATION_EMBED_PLACEHOLDER:
      'Here you can add a link to the presentation.',
    CP_EBP_SELECT_ASSET: 'What would you like to add?',
    CP_EBP_SELECT_ASSET_MAX: 'You can add up to {max} images, videos, etc.',
    CP_EBP_UPLOAD_TEXT: 'Upload image or video',
    CP_EBP_VIDEO_CAPTION_PLACEHOLDER:
      'Here you can add a caption with up to 200 characters.',
    CP_EBP_VIDEO_EMBED: 'Embed video',
    CP_EBP_VIDEO_EMBED_HINT: 'You can embed YouTube and Vimeo videos.',
    CP_EBP_VIDEO_EMBED_PLACEHOLDER: 'Add a link to your video here.',
    CP_EDITOR_NOT_FOUND: "Unfortunately we couldn't find this editor.",
    CP_EMPLOYEE_ANONYMOUS: 'Anonymous',
    CP_EMPLOYEES_LIST_ALPHABETICAL: 'Employees in alphabetical order',
    CP_EMPLOYEES_LIST_HEADLINE: 'The following employees are XING members:',
    CP_EMPTY_STATE_MANAGED_BUTTON: 'Create company profile now',
    CP_EMPTY_STATE_MANAGED_HEADER: 'Attract top talent faster',
    CP_EMPTY_STATE_MANAGED_SUBHEADER:
      'Create a XING company profile and share your culture and values to boost your employer branding.',
    CP_ERROR_ON_SEARCH: 'Sorry, something  went wrong. Give it another go!',
    CP_EXECUTIVES_DESCRIPTION:
      'These are top-level managers verified by XING. They therefore carry the XING Executive badge.',
    CP_EXECUTIVES_DESCRIPTION_LINK: 'Learn more about XING Executives',
    CP_EXECUTIVES_TITLE: 'Top executives',
    CP_FACTS_PLACEHOLDER:
      "Here you can enter your company's facts and figures.",
    CP_FACTS_PLACEHOLDER_TITLE: 'Add company details',
    CP_FOLLOW_COMPANY_FAILURE:
      "Unfortunately that didn't work. Please try again.",
    CP_FOLLOW_COMPANY_SUCCESS: "You're following this employer.",
    CP_FOLLOWED_EMPTY_STATE_BUTTON: 'Show more',
    CP_FOLLOWED_EMPTY_STATE_HEADER: "Follow employers you're interested in",
    CP_FOLLOWED_EMPTY_STATE_SUBHEADER:
      'Following companies is a great way to get their latest news and find out about any new job vacancies they posted. Here are some companies for you to check out:',
    CP_FOLLOWING_COMPANIES: 'Following',
    CP_GENERIC_COMMENT_LENGTH_ERROR: 'You can enter up to {max} characters.',
    CP_HEADLINE_PRODUCT_INFORMATIONS: 'Product information',
    CP_HIRING: 'Hiring',
    CP_IDEAL_EMPLOYER_BANNER_ADD_BTN: 'Add as ideal employer',
    CP_IDEAL_EMPLOYER_BANNER_HEADLINE: 'Would you like to work here?',
    CP_IDEAL_EMPLOYER_BANNER_REMOVE_BTN: 'Remove as ideal employer',
    CP_IDEAL_EMPLOYER_BANNER_TEXT:
      "Let this employer know you're interested in working here and open to receiving suitable vacancies. Don't worry, your contacts won't know about it.",
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_CALLOUT:
      'View all Premium benefits',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_DETAILS:
      'Go Premium to add up to 30 ideal employers and <a href="{link}"><strong>enjoy a wide range of additional Premium benefits!</strong></a>',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_GO_PREMIUM:
      'Go Premium to add up to 30 ideal employers and {benefitsLink}',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_GO_PREMIUM_INNER:
      'enjoy a wide range of additional Premium benefits!',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_HEADLINE:
      'You reached the maximum of ideal employers.',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_SUBHEADLINE:
      'Go Premium to add more ideal employers',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_TEXT:
      'Unfortunately, you have reached the limit of 3 ideal employers. You can manage your current ideal employers in Settings whenever you like.',
    CP_IDEAL_EMPLOYER_LIGHTBOX_CANCEL_BUTTON: 'Cancel',
    CP_IDEAL_EMPLOYER_LIGHTBOX_EDIT_BUTTON: 'Edit ideal employers',
    CP_IDEAL_EMPLOYER_LIGHTBOX_EDIT_BUTTON_MOBILE: 'Manage ideal employers',
    CP_IDEAL_EMPLOYER_LIST: 'Your ideal employers',
    CP_IDEAL_EMPLOYER_PREMIUM_LIMIT_LIGHTBOX_CONTENT:
      "Unfortunately you've reached the limit of 30 ideal employers. You can edit your ideal employers whenever you like in your settings.",
    CP_IDEAL_EMPLOYER_PREMIUM_LIMIT_LIGHTBOX_HEADLINE:
      'You reached your ideal employer limit.',
    CP_INDUSTRIES_DESCRIPTION:
      'These are our XING pages, categorised by industries',
    CP_INDUSTRIES_SECTION_SUBLINE: 'Browse companies within their industry',
    CP_INDUSTRIES_SECTION_TITLE: 'Companies by industry',
    CP_INSIGHTS_SECTION_SUBLINE:
      'Read about companies in articles curated by the XING News team.',
    CP_INSIGHTS_SECTION_TITLE: 'Company insights',
    CP_INVALID_ROLE: "Unfortunately that role doesn't exist.",
    CP_JOB_BOOKMARK_FAILURE:
      "Unfortunately that didn't work. Please try again.",
    CP_JOB_BOOKMARK_SUCCESS: 'Job saved',
    CP_JOB_FILTER_DISCIPLINE: 'Discipline',
    CP_JOB_FILTER_LEVEL: 'Career level',
    CP_JOB_FILTER_LOCATION: 'Locations',
    CP_JOB_SEARCH_PLACEHOLDER: 'Enter a job title or keyword',
    CP_JOB_SEARCH_SUBMIT: 'Search',
    CP_JOBBOX_BUTTON: 'View saved jobs',
    CP_JOBS_APPLICATION_PROCESS_HEADLIN: 'Application process rating',
    CP_JOBS_APPLICATION_PROCESS_HEADLINE: 'Application process rating',
    CP_JOBS_APPLICATION_PROCESS_RATING_0:
      'Rated by <b>{num_ratings}</b> applicants.',
    CP_JOBS_APPLICATION_PROCESS_RATING_1:
      'The response to my application was satisfactory.',
    CP_JOBS_APPLICATION_PROCESS_RATING_10:
      'I received a positive or negative response in good time.',
    CP_JOBS_APPLICATION_PROCESS_RATING_11:
      'I was able to collect feedback about the rejection reason.',
    CP_JOBS_APPLICATION_PROCESS_RATING_2:
      'I received a swift response to my application.',
    CP_JOBS_APPLICATION_PROCESS_RATING_3: 'I knew what to expect.',
    CP_JOBS_APPLICATION_PROCESS_RATING_4:
      'The interview was well prepared and conducted professionally.',
    CP_JOBS_APPLICATION_PROCESS_RATING_5:
      'I was provided with a lot of information about the vacancy.',
    CP_JOBS_APPLICATION_PROCESS_RATING_6:
      'The interview was friendly and relaxed.',
    CP_JOBS_APPLICATION_PROCESS_RATING_7: 'I was treated with respect.',
    CP_JOBS_APPLICATION_PROCESS_RATING_8:
      'My questions were dealt with in a satisfactory manner.',
    CP_JOBS_APPLICATION_PROCESS_RATING_9:
      'The next steps were explained to me.',
    CP_JOBS_EMPTY_ACTION: 'View job recommendations',
    CP_JOBS_EMPTY_EDITOR_ACTION: 'Create job ad',
    CP_JOBS_EMPTY_EDITOR_HEADLINE:
      "Here's where XING members see your job ads.",
    CP_JOBS_EMPTY_EDITOR_TEXT:
      'Looking for the right job? Check out our recommendations:',
    CP_JOBS_EMPTY_HEADLINE:
      "This employer doesn't have any vacancies right now.",
    CP_JOBS_EMPTY_TEXT:
      'Looking for the right job? Check out our recommendations:',
    CP_JOBS_ERROR_ACTION: 'Try again',
    CP_JOBS_ERROR_HEADLINE: 'Nothing here?',
    CP_JOBS_ERROR_TEXT:
      'Something appears to have gone wrong. Please give it another go:',
    CP_JOBS_NO_RESULTS_ACTION: 'Reset filters',
    CP_JOBS_NO_RESULTS_HEADLINE:
      "We didn't find any jobs for these search criteria.",
    CP_JOBS_NO_RESULTS_TEXT:
      "Please reset your filters to see all of this company's current vacancies.",
    CP_JOBS_PLACEHOLDER_TEXT: "Then you've come to the right place!",
    CP_JOBS_PLACEHOLDER_TITLE: 'Looking for new staff?',
    CP_JOBS_SEARCH_JOBS_TITLE: 'Current jobs',
    'CP_LANDING_FOLLOWED_COMPANIES_DESCRIPTION.one':
      "You're following one employer.",
    'CP_LANDING_FOLLOWED_COMPANIES_DESCRIPTION.other':
      "You're following {count} employers.",
    'CP_LANDING_FOLLOWED_COMPANIES_DESCRIPTION.zero':
      "Follow the employers you're interested in!",
    CP_LANDING_FOLLOWED_COMPANIES_HEADLINE: 'Your employer news',
    CP_LANDING_FOR_EMPLOYERS_TEASER: 'For employers',
    'CP_LANDING_IDEAL_EMPLOYERS_DESCRIPTION.one':
      "You've let an employer know you're interested in working there.",
    'CP_LANDING_IDEAL_EMPLOYERS_DESCRIPTION.other':
      "You've let {count} employers know you're interested in working there.",
    'CP_LANDING_IDEAL_EMPLOYERS_DESCRIPTION.zero':
      "Tip: Let your ideal employers know you're interested in working there.",
    CP_LANDING_IDEAL_EMPLOYERS_HEADLINE: 'Your ideal employers',
    CP_LANDING_LOGGED_OUT_EMPLOYEE_REVIEWS:
      '<strong>Employee reviews:</strong> See how current and former employees rated the company.',
    CP_LANDING_LOGGED_OUT_HEADLINE: 'Find an employer you enjoy working for.',
    CP_LANDING_LOGGED_OUT_INFORMATION_AND_UPDATES:
      "<strong>Information and updates</strong> about the company's benefits, products and services",
    CP_LANDING_LOGGED_OUT_INTRO_CAREER_OPORTUNITIES:
      '<strong>Career opportunities:</strong> Looking for a job? If so, just check out the vacancies this employer currently has to offer.',
    CP_LANDING_MANAGE_COMPANIES_HEADLINE: 'Your employer profiles',
    CP_LANDING_MOBILE_BANNER:
      'To create a company profile, visit XING BrandManager, or manage team permissions, <strong>please switch to a larger screen.</strong>',
    CP_LANDING_PAGE_RECOMMENDED_LINK: 'Recommended',
    CP_LANDING_SEARCH_HEADLINE: 'Find an employer',
    CP_LANDING_SEARCH_PLACEHOLDER: 'Enter a company name here',
    CP_LATEST_UPDATE_ADVERTISMENT: 'Last update',
    CP_LATEST_VACANCY_ADVERTISMENT: 'Last job ad',
    CP_LINKS_TRAFFIC_LABEL: 'Website links',
    CP_LINKS_TRAFFIC_SUBTITLE: 'Websites',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION:
      'Check out all the employers from the {industry} industry. You’ll find out which companies are hiring, which XING members work there, what the company culture is like, and what benefits are available for employees.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_120000:
      'Count on success by networking with renowned banks, fintech companies and investment firms. Want to open up a career in numbers? Start in the finance industry.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_160000:
      'Discover what the consulting industry has to offer. Get exclusive insights into leading consulting firms that thrive on solutions and strategic thinking.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_170000:
      'Set your creative genius free by working with companies and agencies that live for new ideas, analytical thinking and inventive marketing strategies.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_20000:
      'Find companies and innovative startups who’ll take your ideas under their wing to revolutionise the world of commerce.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_210000:
      'Connect with people and patients as part of the healthcare industry. Meet employers who value a good working environment and are keen to help you develop on a personal level.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_30000:
      'Shift your career into gear by learning all about the pioneers and trailblazers of the automotive industry. See how they’re shaping the future of mobility and how you might fit into it.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_40000:
      'Align the cogs of your destiny by delving into the world of mechanical engineering. Sink your teeth into challenging projects developing innovative production technologies.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_90000:
      'Find IT companies who can help you expand your skills. Looking for innovation and technical excellence? You’ve come to the right place.',
    CP_LO_INDUSTRY_COMPANIES_HEADER: 'All companies in the {industry} industry',
    CP_LO_INDUSTRY_COMPANIES_LIST_TITLE: 'Companies in the {section} industry',
    CP_LO_INDUSTRY_COMPANIES_META_DESCRIPTION:
      "Find fun jobs, employers that suit you and companies that'll help you get ahead | Start your job search on XING",
    CP_LO_INDUSTRY_COMPANIES_META_TITLE:
      'Employers on XING | Jobs and News | Culture and Salary',
    CP_LO_INDUSTRY_COMPANIES_SEGMENTS_TITLE: 'Select an industry',
    CP_LOGGEDOUT_METADESCRIPTION:
      'Check out employers from various industries and see their employee benefits, current vacancies, and updates.',
    CP_MANAGED_COMPANIES_HEADER: 'Companies you manage',
    'CP_MATCHING_JOB_ADS.one': '{count} job ad found',
    'CP_MATCHING_JOB_ADS.other': '{count} job ads found',
    'CP_MATCHING_JOB_ADS.zero': 'No job ads found',
    CP_MAXIMUM_FILE_SIZE_IMAGE_UPDATES:
      'The maximum file size for images is 10 MB (JPG, JPEG or PNG), and the ideal aspect ratio is 16:10 (e.g. 720 x 450 pixels).',
    CP_MAXIMUM_FILE_SIZE_TITLE_IMAGE_UPDATES: 'Images',
    CP_MAXIMUM_FILE_SIZE_TITLE_VIDEO_UPDATES: 'Videos',
    CP_MAXIMUM_FILE_SIZE_UPDATES_INFO_HINT: 'Image and video format',
    CP_MAXIMUM_FILE_SIZE_VIDEO_UPDATES:
      'You can use videos of up to 5 GB in the following formats: 3gp, avi, flv, m4v, mkv, mov, mp4, mpeg, mpg, mts, vob, webm, wmv ',
    CP_MORE_ABOUT_COMPANY: 'More information about this employer',
    CP_MORE_DETAILS: 'More employer details',
    CP_MOST_VISITED_COMPANIES_CAPTION:
      'Take a look at who has recently sparked the <span>interest of users</span>',
    CP_MOST_VISITED_COMPANIES_SUBLINE: 'Trending in the last 24 hours',
    CP_MOST_VISITED_COMPANIES_TITLE: 'Most-visited employers on XING',
    CP_MY_COMPANIES_HOME: 'Home',
    CP_NEW_EMPLOYERS: 'New XING Pages',
    CP_NEWSFEED_COMMENT: 'Comment',
    CP_NEWSFEED_COMMENT_FAKE: 'Enter your comment here....',
    CP_NEWSFEED_COMMENT_LENGTH_ERROR:
      'You can enter up to 600 characters here.',
    CP_NEWSFEED_LIKE: 'Like',
    CP_NEWSFEED_LIKE_MORE: '{likers} likes this.',
    CP_NEWSFEED_LIKE_MORE_MYSELF: 'You and {other_likers} like this.',
    CP_NEWSFEED_LIKE_ONE: '{liker} likes this.',
    CP_NEWSFEED_LIKE_ONE_MYSELF: 'You like this.',
    CP_NEWSFEED_LIKE_OTHER: '1 other member',
    CP_NEWSFEED_LIKE_OTHERS: '{no_of_likers} other members',
    CP_NEWSFEED_LIKE_PEOPLE: '{no_of_likers} members',
    CP_NEWSFEED_REMOVE: 'Remove',
    CP_NEWSFEED_SHOW_ALL_COMMENTS: 'Show all #{count} comments',
    CP_NEWSFEED_SHOW_LESS_COMMENTS: '<span>Less</span>',
    CP_NEWSFEED_UNDO_LIKE: 'Undo?',
    CP_NEWSFEED_UNLIKE: 'Unlike',
    CP_NO_MORE_EDITORS_ALLOWED: "Unfortunately you can't add any more editors.",
    CP_NUM_JOB_OFFERS: '{num} job ads',
    CP_OPEN_PRESENTATION_HINT: 'Open presentation in a separate tab',
    CP_OPEN_VIDEO_HINT: 'Open video in a separate tab',
    CP_OPTIONS_DELETE: 'Delete',
    CP_OPTIONS_EDIT: 'Edit',
    CP_OTHER_COMPANIES_FOLLOW: 'Other companies you’re following',
    CP_OTHER_COMPANIES_MANAGE: 'More companies you manage',
    CP_OTHER_INTERESTING_COMPANIES: 'Other interesting companies',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BOX.CREATE':
      'Don’t see your company here? Create a free Company Profile now!',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BOX.FINALIZE':
      'Almost done! Just a few more details and your free Company Profile is ready to go.',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BOX.MANAGE':
      'Here you can manage and edit your Company Profile',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BUTTON.CREATE': 'Create Company Profile',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BUTTON.FINALIZE': 'Edit Company Profile',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BUTTON.MANAGE': 'Manage Company Profile',
    CP_OVERVIEW_RECOMMENDATIONS_DESCRIPTION:
      'Find employers fitting your profile and job preferences',
    CP_OVERVIEW_RECOMMENDATIONS_LOAD_MORE_CTA: 'Show more',
    CP_OVERVIEW_RECOMMENDATIONS_TITLE: 'Recommended employers',
    CP_PAGE_CREATION_GENERIC_ERROR:
      'Looks like the server got tired of the hamster wheel. Please try again.',
    CP_PAGE_CREATION_INDUSTRY_ID_INVALID:
      'Please select one of the industries provided.',
    CP_PAGE_CREATION_NAME_ALREADY_USED:
      'A XING Page with that name already exists. Maybe someone else already created your page?',
    CP_PAGE_CREATION_NAME_INVALID_CHARACTERS:
      'Please only use letters and numbers here, not special characters.',
    CP_PAGE_CREATION_NAME_ONLY_NUMBERS:
      "Your name shouldn't just consist of numbers. Please add letters as well.",
    CP_PAGE_CREATION_NAME_TOO_LONG:
      'Sorry, this text is a bit long. Please reduce it to 80 characters.',
    CP_PAGE_CREATION_NAME_TOO_SHORT:
      'Sorry, that name is too short. Please use more than two characters.',
    CP_PAGE_CREATION_PARAMETER_REQUIRED: 'Required field',
    CP_PAGE_CREATION_SIZE_ID_INVALID:
      'Please select one of the employees options provided.',
    CP_PAGINATION_LEFT: 'Previous page',
    CP_PAGINATION_RIGHT: 'Next page',
    CP_PDF_DOWNLOAD_INFO_TEXT:
      'These PDF files provide you with key information and instructions on using Company Profiles:',
    CP_PMBX_CLAIMER_SINCE: 'Editor since',
    CP_PMBX_CLAIMERS_TITLE: "Employer profiles where you're an editor",
    CP_PMBX_COMPANY_NAME: 'Company name',
    CP_PMBX_CONTACT_DESCRIPTION: 'Description',
    CP_PMBX_CONTACT_EMAIL: 'E-mail',
    CP_PMBX_CONTACT_PHONE: 'Phone',
    CP_PMBX_CONTACT_SINCE: 'Contact since',
    CP_PMBX_CONTACTS_TITLE:
      "Employer profiles where you're listed as the contact person",
    CP_PMBX_EMPLOYMENTS_TITLE:
      "Employer profiles where you're listed as an employee",
    CP_PMBX_FEED_URL: 'Link (URL) to XML feed',
    CP_PMBX_FEEDS_TITLE: 'Your entries from XML feeds for employer profiles',
    CP_PMBX_FOLLOWERS_TITLE: "Employer profiles you're following",
    CP_PMBX_FOLLOWING_SINCE: 'Follower since',
    CP_PMBX_NO_DATA_REASON:
      'We have no data about you in the employer profiles section.',
    CP_PMBX_TEMPORARY_CLAIMER_CREATED_AT: 'Created on',
    CP_PMBX_TEMPORARY_CLAIMER_EXPIRED_AT: 'Expired on',
    CP_PMBX_TEMPORARY_CLAIMER_SUBTITLE:
      'Companies for which you were a temporary claimer',
    CP_PMBX_TITLE: 'Employer profiles',
    CP_PMBX_UPDATE_HEADLINE: 'Headline',
    CP_PMBX_UPDATE_POSTED_ON: 'Posted on',
    CP_PMBX_UPDATES_BODY: 'Text',
    CP_PMBX_UPDATES_IMAGE: 'Image',
    CP_PMBX_UPDATES_TITLE: 'Company updates you posted',
    CP_POSITION_IN_USE_ERROR:
      'This module has just been changed. Press reload the page to see the changes.',
    CP_PRODUCTS_AND_SERVICES_TITLE: 'Products and services',
    CP_PRODUCTS_GALLERY_PLACEHOLDER:
      'Add images, videos and PDF files to showcase your portfolio.',
    CP_PRODUCTS_GALLERY_PLACEHOLDER_TITLE:
      'Show your customers what you have to offer.',
    CP_PRODUCTS_PLACEHOLDER: 'Describe your products and services here.',
    CP_PRODUCTS_PLACEHOLDER_TITLE:
      'Tell your customers about what you have to offer.',
    CP_QUOTE_PLACEHOLDER: 'What makes you stand out as an employer?',
    CP_RECENTLY_CLAIMED_COMPANIES_CAPTION:
      'See which companies <span>recently joined</span> the platform',
    CP_RECENTLY_CLAIMED_COMPANIES_TITLE: 'These employers are now on XING',
    CP_RECOMMENDED_COMPANIES_HEADER:
      'See what companies offer their employees and find out if you know someone who works there:',
    CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US:
      'XING recommends the following companies:',
    CP_RECOMMENDS_ADVERTISMENT: 'XING recommends:',
    CP_RECOVER_PROFILE_ACTION_BUTTON: 'Request approval',
    CP_RECOVER_PROFILE_BODY:
      "This is where your company showcases itself as an employer on XING. Unfortunately there's no editor for this profile right now, but you can request to be approved as an editor.",
    CP_RECOVER_PROFILE_HEADLINE:
      "This is your company's profile - but it doesn't have an editor!",
    CP_REDIRECT_PERMISSIONS_DIALOG_BUTTON: 'Got it',
    CP_REDIRECT_PERMISSIONS_DIALOG_MESSAGE:
      'Please contact your admin so they can give you access to edit this company profile. ',
    CP_REDIRECT_PERMISSIONS_DIALOG_TITLE: 'You can’t edit this profile.',
    CP_REMOVE_IDEAL_EMPLOYER_FAILURE:
      "Unfortunately that didn't work. Please try again.",
    CP_REMOVE_IDEAL_EMPLOYER_SUCCESS: 'No longer an ideal employer',
    CP_REMOVE_JOB_BOOKMARK_FAILURE:
      "Unfortunately that didn't work. Please try again.",
    CP_REMOVE_JOB_BOOKMARK_SUCCESS: 'Job removed',
    CP_REQUEST_APPROVAL: 'Request approval',
    CP_REQUEST_EBP_PUBLICATION_BANNER_CONTENT:
      "Please check out the e-mail we sent to <span>{email_address}</span> which contains some useful tips on how to customise your Employer Branding Profile. Once you've completed all the mandatory fields, you can go ahead and publish your Employer Branding Profile. ",
    CP_REQUEST_EBP_PUBLICATION_BANNER_HEADLINE:
      'Breathe life into your Employer Branding Profile.',
    CP_REQUEST_PUBLICATION_BANNER_CONTENT:
      'Please fill in your employer profile along with the mandatory fields. We recommend you also add your corporate logo to convey a professional image. <span>Click on "request approval"</span> to confirm your entries are correct and submit your request. We\'ll then review your profile and approve it within 72 hours. \n\nWe also e-mailed some useful tips to <span>{email_address}</span>.',
    CP_REQUEST_PUBLICATION_BANNER_HEADLINE:
      "Welcome! You're just a few steps away from your employer profile.",
    CP_REQUEST_PUBLICATION_SENT_CONTENT:
      "Your XING employer profile has been submitted for approval. We'll send a notification within 72 hours to <span>{email_address}</span> once your profile has been approved and is visible to all XING members. ",
    CP_REQUEST_PUBLICATION_SENT_HEADLINE: 'Thanks! Your request has been sent.',
    CP_REQUESTER_NOT_AUTHORIZED:
      "Unfortunately the requester doesn't have permission for that.",
    CP_REVIEWS_BADGES_OPEN_LINK_TITLE:
      'More information about the Open Company quality seal',
    CP_REVIEWS_BADGES_TOP_LINK_TITLE:
      'More information about the Top Company quality seal',
    CP_REVIEWS_BADGES_WIDGET_TITLE: 'Awards',
    CP_REVIEWS_BENEFITS_1: 'Flexitime',
    CP_REVIEWS_BENEFITS_10: 'Training',
    CP_REVIEWS_BENEFITS_11: 'Car park',
    CP_REVIEWS_BENEFITS_12: 'Convenient transport links',
    CP_REVIEWS_BENEFITS_13: 'Staff discounts',
    CP_REVIEWS_BENEFITS_14: 'Company car',
    CP_REVIEWS_BENEFITS_15: 'Mobile device',
    CP_REVIEWS_BENEFITS_16: 'Profit-sharing',
    CP_REVIEWS_BENEFITS_17: 'Staff events',
    CP_REVIEWS_BENEFITS_18: 'Private Internet use',
    CP_REVIEWS_BENEFITS_19: 'Dogs welcome',
    CP_REVIEWS_BENEFITS_2: 'Remote work',
    CP_REVIEWS_BENEFITS_3: 'Canteen',
    CP_REVIEWS_BENEFITS_4: 'Restaurant tickets',
    CP_REVIEWS_BENEFITS_5: 'Childcare',
    CP_REVIEWS_BENEFITS_6: 'Company pension',
    CP_REVIEWS_BENEFITS_7: 'Accessibility',
    CP_REVIEWS_BENEFITS_8: 'Health in the workplace',
    CP_REVIEWS_BENEFITS_9: 'Company doctor',
    CP_REVIEWS_BENEFITS_HEADLINE: 'Employee benefits',
    CP_REVIEWS_BENEFITS_NO_TITLE: '{rating_avg} out of 5',
    CP_REVIEWS_BENEFITS_PLACEHOLDER_BUTTON: 'Rate employer',
    CP_REVIEWS_BENEFITS_PLACEHOLDER_TEXT:
      'No one has entered any employee benefits yet. Change that now by adding a review!',
    CP_REVIEWS_BENEFITS_TOOLTIP: 'Confirmed by {employees} employees',
    CP_REVIEWS_RATINGS_1: 'Leadership style',
    CP_REVIEWS_RATINGS_10: 'Work-life balance',
    CP_REVIEWS_RATINGS_11: 'Image',
    CP_REVIEWS_RATINGS_12: 'Treatment of colleagues over 45',
    CP_REVIEWS_RATINGS_13: 'Environmental and social awareness',
    CP_REVIEWS_RATINGS_2: 'Collegiality',
    CP_REVIEWS_RATINGS_3: 'Interesting duties',
    CP_REVIEWS_RATINGS_4: 'Working environment',
    CP_REVIEWS_RATINGS_5: 'Internal communication',
    CP_REVIEWS_RATINGS_6: 'Equality',
    CP_REVIEWS_RATINGS_7: 'Career and training',
    CP_REVIEWS_RATINGS_8: 'Salary and benefits',
    CP_REVIEWS_RATINGS_9: 'Offices and equipment',
    CP_REVIEWS_RATINGS_HEADING: 'Employer rating',
    CP_REVIEWS_RATINGS_STANDARD: 'Industry average: <b>{rating}</b>',
    CP_REVIEWS_REPORTS_CURRENT_JOB:
      'Is currently a {title} in the {department} department',
    CP_REVIEWS_REPORTS_PAST_JOB:
      'Was a {title} in the {department} department until {date}',
    CP_REVIEWS_REPORTS_REPORT_LINK: 'See more',
    CP_REVIEWS_REPORTS_STATEMENT_LINK: 'Employer response',
    CP_REVIEWS_REVIEW_ORDER_BY: 'Sortieren:',
    CP_REVIEWS_REVIEWS_CRITICAL_ONES: 'Negative first',
    CP_REVIEWS_REVIEWS_HEADING: 'Employee reviews',
    CP_REVIEWS_REVIEWS_NEWEST: 'Latest first',
    CP_REVIEWS_REVIEWS_NO_TITLE: '{rating_avg} out of 5',
    CP_REVIEWS_REVIEWS_POSITIVE_ONES: 'Positive first',
    CP_ROLLOUT_BANNER_DRAFT_CONTENT:
      'Fill in the remaining fields to ensure a smooth transition from your old employer profile to your new one.',
    CP_ROLLOUT_BANNER_DRAFT_HEADER: 'Complete your new employer profile',
    CP_ROLLOUT_BANNER_DRAFT_REDIRECT: 'Complete employer profile',
    CP_ROLLOUT_BANNER_LEGEND_INFO:
      "Please note that you won't be able to switch back to the old design",
    CP_ROLLOUT_BANNER_MOBILE:
      '<p><strong>We’ve revamped our employer profiles!</strong> Please use a larger screen to switch to the new design.</p>',
    CP_ROLLOUT_BANNER_SWITCH_NEW_DESIGN: 'Switch to the new design',
    CP_ROLLOUT_INFOTEXT_FIRST:
      "Soon, all employer profiles will be switched to the new design.<br /><br /> This is your chance to review and customise your content now. That way you'll get everything ready for the switch.",
    CP_ROLLOUT_INFOTEXT_SECOND:
      'Enable your target group to contact you directly via your employer profile.',
    CP_ROLLOUT_INFOTEXT_THIRD:
      'Boost brand recognition with more customisation options.',
    CP_ROLLOUT_POPUP_BUTTON: 'Open in draft mode',
    CP_ROLLOUT_POPUP_FOOTER_NOTE:
      "We'll migrate all your existing data for you.",
    CP_ROLLOUT_POPUP_HEADER: "We've revamped the employer profiles!",
    CP_ROLLOUT_POPUP_HEADER_BANNER:
      'Get your employer profile ready for the new design!',
    CP_ROLLOUT_POPUP_INFOTEXT_PRINCIPAL:
      'Are you ready for all the benefits your new employer profile has to offer?',
    CP_SALES_PAGE_COMMUNICATION_TITLE: 'Interact with your target group.',
    CP_SALES_PAGE_EBP_INFO_TITLE: 'The Employer Branding Profile for pros',
    CP_SALES_PAGE_EBP_PRICE: 'From {price} per month',
    CP_SALES_PAGE_EBP_TEXT:
      "<p>What makes you a good employer? Modern offices? Flexible working hours? Daycare services?</p>\n<p>Present your employee benefits in your <strong>Employer Branding Profile</strong> to show why you're a great place to work.</p>",
    CP_SALES_PAGE_EBP_TITLE: 'Show what your business has to offer',
    CP_SALES_PAGE_FREE_TEXT:
      "<p>Don't have a budget for employer branding at the moment? No problem! For now you can create a <strong>free profile</strong> that gives you some of the basic features of our Employer Branding Profile.</p>",
    CP_SALES_PAGE_FREE_TITLE: 'The free profile for minimalists',
    CP_SALES_PAGE_HEADER_NEW: "Show why you're a great employer",
    CP_SALES_PAGE_HEADER_SCREENSHOT: "Show why you're a great employer.",
    CP_SALES_PAGE_HEADER_SCREENSHOT_BOTTOM: 'List your employee benefits.',
    CP_SALES_PAGE_MORE_TEXT:
      'You can also download a PDF file containing an overview of the Employer Branding Profile:',
    CP_SALES_PAGE_STAGE_SCREENSHOT_1:
      'Provide insights into daily working life.',
    CP_SALES_PAGE_STAGE_SCREENSHOT_2: "See your company's ratings.",
    CP_SALES_PAGE_STAGE_SCREENSHOT_3:
      'Provide well-presented and appealing facts and figures.',
    CP_SALES_PAGE_STAGE_SUBTITLE:
      'Use videos, images and text to show why people like working at your company.',
    CP_SALES_PAGE_STAGE_TITLE: 'Bring your business to life.',
    CP_SALES_PAGE_STEPS_MODULE_1: 'Request an Employer Branding Profile',
    CP_SALES_PAGE_STEPS_MODULE_3: 'Present yourself as an attractive employer',
    CP_SALES_PAGE_STEPS_MODULE_TITLE: 'How it works:',
    CP_SALES_PAGE_SUBHEADER: 'The Employer Branding Profile for your business',
    CP_SALES_PAGE_VISIBILITY_TITLE: 'Make your business more visible online.',
    CP_SEARCH_ENGINES_TRAFFIC_LABEL: 'Search engines',
    CP_SEARCH_ENGINES_TRAFFIC_SUBTITLE: 'Search terms',
    CP_SEE_ALL_INDUSTRIES: 'See all industries',
    CP_SHOW_ALL: 'Show all',
    CP_SHOW_MORE_COMPANIES: 'Show more companies',
    CP_SOCIAL_TRAFFIC_LABEL: 'Social networks',
    CP_SOCIAL_TRAFFIC_SUBTITLE: 'Social networks',
    CP_STATISTICS_ALL_FACTS_FIGURES: 'All facts & figures',
    CP_TEAMPERMISSIONS: 'Manage team',
    CP_TEMPORARY_CLAIMER_BUTTON_ENABLE: 'Enable company',
    CP_TEMPORARY_CLAIMER_BUTTON_OPEN: 'Open in BrandManager',
    CP_TEMPORARY_CLAIMER_CHECKBOX:
      'I hereby confirm that I have read the following information thoroughly: ',
    CP_TEMPORARY_CLAIMER_CREATED:
      '{company_name} was activated for you for the next 30 minutes.',
    CP_TEMPORARY_CLAIMER_CREATION_FAILED: "Well, that didn't work: {message}",
    CP_TEMPORARY_CLAIMER_CREATION_FAILED_TOS: 'Please accept the Terms of Use.',
    CP_TEMPORARY_CLAIMER_HEADLINE: 'Enable access for customer presentation',
    CP_TEMPORARY_CLAIMER_INFO:
      'You are the administrator for the selected company profile "{company_name}" for 30 minutes. All changes you make are visible live on the company profile and can be tracked.',
    CP_TEMPORARY_CLAIMER_SUBHEADLINE:
      'Make yourself the company editor for "{company_name}" to present the XING BrandManager to a customer.',
    'CP_TOP_COMPANIES_CARD_BUTTON.one': 'View {value} job',
    'CP_TOP_COMPANIES_CARD_BUTTON.other': 'View {value} jobs',
    CP_TOP_COMPANIES_SECTION_SUBTITLE:
      'Popular employers looking to fill their vacancies on XING',
    CP_TOP_COMPANIES_SECTION_TITLE: 'Top companies hiring now',
    CP_TOTAL_COMPANIES: '{total} companies',
    CP_UNFOLLOW_COMPANY_FAILURE:
      "Unfortunately that's didn't work. Please try again.",
    CP_UNFOLLOW_COMPANY_SUCCESS: 'You unfollowed this employer.',
    CP_UNKNOWN_XING_USER: "Unfortunately we didn't recognise that member.",
    CP_UPDATES_PROMOTE_ARTICLE: 'Promote news',
    CP_UPDATES_SHOW_STATISTICS: 'Show statistics',
    CP_UPDATES_UPLOADING_ASSET_DESCRIPTION:
      'Uploading your file. Just a second please.',
    CP_UPDATES_UPLOADING_IMAGE: 'Uploading image...',
    CP_UPLOAD_IMAGE_ERROR: "Sorry, that didn't work. Please try again.",
    CP_UPLOAD_RESTRICTIONS:
      '<span class="{block}">JPG, GIF, BMP, PNG, max. <strong>{weight} MB</strong></span>\nRGB (no CMYK), ideal size: <strong>{dimensions}</strong>',
    CP_UPLOAD_VIDEO_ERROR:
      "Sorry, your video couldn't be uploaded. Please try again.",
    CP_UPSELL_HINT:
      'This information is only available to Company Profile editors.',
    CP_UPSELL_LINK_TITLE:
      'More information about the Employer Branding Profile',
    CP_USER_IS_NOT_PAYING_EDITOR:
      "This person isn't the paying editor of this XING Page.",
    CP_VIDEO_UPDATE_PLACEHOLDER_BODY:
      "This may take a little while – maybe a good time to grab some coffee? And when you're back, simply reload this page to check if it's done.",
    CP_VIDEO_UPDATE_PLACEHOLDER_TITLE: "We're processing your video now...",
    CP_VISIT_COMPANY_ADVERTISMENT: 'Go to Company Profile',
    CP_WANT_TO_CONNECT: 'Work for this employer:',
    CP_WORKING_HERE: 'Contacts who work here:',
    CP_XING_TRAFFIC_LABEL: 'XING',
    CP_XING_TRAFFIC_SUBTITLE: 'XING sections',
    CP_XTP_IDEAL_EMPLOYER_CONFIRM_LANDING_BODY:
      "This will be kept confidential and we won't let any third parties know about your interest.",
    CP_XTP_IDEAL_EMPLOYER_CONFIRM_LANDING_HEADER:
      'Thanks for adding {company_name} as an ideal employer.',
    CP_XTP_SURVEY_LANDING_CONTENT:
      'The ideal employer feature is new to XING. You can help improve it by answering a few quick questions. Thanks in advance for your feedback.',
    CP_XTP_SURVEY_LANDING_CTA: 'Go to survey',
    CP_XTP_SURVEY_LANDING_FEEDBACK_BODY:
      "We've let {company_name}'s HR department know you're interested in working there.",
    CP_XTP_SURVEY_LANDING_FEEDBACK_HEADER:
      'Thanks for adding {company_name} as an ideal employer.',
    CP_XTP_SURVEY_LANDING_HEADLINE: 'We value your opinion!',
    CP_XTP_SURVEY_LANDING_SEARCH_HEADER: 'Good things come to people who wait.',
    CP_XTP_SURVEY_LANDING_SEARCH_PLACEHOLDER: 'Enter position or keyword',
    CP_XTP_SURVEY_LANDING_SEARCH_SUBHEADER: 'A dream job, for example.',
    CP_XTP_SURVEY_LANDING_UNSUBSCRIBE_CONTENT:
      'Browse more great employers now in <a href="{jobs_link}">XING Jobs</a>.',
    CP_XTP_SURVEY_LANDING_UNSUBSCRIBE_HEADLINE:
      'Your ideal employer setting has been deleted.',
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_COPY:
      "<p>for your interest in {company_name} as an ideal employer.</p>\n<p>We've let {company_name}'s HR department know you're interested in working there.</p>\n <p>Please note: The ideal employer feature is new to XING. You can help improve it by answering a few quick questions. Thanks in advance for your feedback.</p>",
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_CTA1: 'Go to survey',
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_CTA2: 'Back',
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_HEADLINE: 'Thanks',
    CREATE_ACCOUNT_HINT: 'Here you can manage your XING account.',
    CROSSPOST_SHARE_ERROR:
      'Sorry, but you already shared this post in 3 other groups.',
    DATA_PROTECTION: 'Edit shared personal info',
    DAY_NAMES: 'Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday',
    DAY_NAMES_SHORT: 'Mo,Tu,We,Th,Fr,Sa,Su',
    DEGREE: 'Degree',
    DESC_POS: 'Describe your position',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM: 'Turn off',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE: 'Turn off mentions?',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT:
      "Your name won't link to your XING profile.",
    DONT_REMIND: "Please don't remind me again",
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES: 'A company',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS: 'An event',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS: 'A group',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS: 'A job',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS: 'A person',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS: 'An article',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS: 'A topic',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS:
      'Discover the many {keyword} jobs on offer',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT:
      'Discover {keyword} jobs',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_INCREMENTAL_SEARCH: 'Search suggestions',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_NAVIGATION_SUGGESTIONS:
      'What are you looking for?',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_QUERY_SUGGESTION: 'Search suggestions',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_INTERACTIONS:
      'Profiles you recently visited',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_SEARCHES:
      'Your recent job searches',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECOMMENDATION: 'Recommendations',
    DUPLICATE_SHARE_ERROR:
      'You already shared this so your contacts are in the loop.',
    EBP_HEADERGRAPHIC_LINK: 'Cover image link',
    EBP_HEADERGRAPHIC_LINK_PLACEHOLDER:
      'Here you can add a link for your header image.',
    EBP_UPLOAD_HEADERGRAPHIC: 'Upload cover image',
    EDIT_JOB_COMPANY: 'Edit position at &quot;{-company}&quot;',
    EDIT_JOB_HEADER: 'Edit position at &quot;{-company}&quot;',
    EDIT_MOTIVATIONS: 'Edit motivations',
    EDIT_SCHOOL: 'Edit studies at &quot;{-name}&quot;',
    EDIT_SCHOOL_HEADER: 'Edit the university/college "{-name}"',
    EDIT_WIDGET_EMAILS_LABEL_ADDITIONAL: 'Other',
    EDIT_WIDGET_EMAILS_LABEL_BUSINESS: 'Business',
    EDIT_WIDGET_EMAILS_LABEL_PRIVATE: 'Private',
    EDIT_WIDGET_UNSAVED_CHANGES: 'unsaved change(s)',
    EDUCATION: 'Educational background',
    EMAIL_PREFS: 'E-mail settings',
    EMAILS_ACTIVATE: 'Activate for notifications',
    EMAILS_ACTIVATED_BODY:
      'Your e-mail address <strong>&quot;{-email_for_flash}&quot;</strong> has been successfully activated.',
    EMAILS_ACTIVATED_HEADER: 'Activation successful',
    EMAILS_ACTIVATION_EMAIL_BODY:
      'Your notification e-mail address has not yet been changed to <strong>&quot;{-email_for_flash}&quot;</strong> as it hasn’t yet been confirmed. We have already sent a confirmation e-mail to this address. Please open the e-mail and click on the confirmation link. As soon as the new address has been successfully confirmed it will be activated as your notification address.<br/>\nThis procedure is for your own security and prevents spam.',
    EMAILS_ACTIVATION_EMAIL_HEADER: "You've got mail",
    EMAILS_ACTIVE: 'active notification address',
    EMAILS_ADDITONAL_INFO:
      '<strong>Please note:</strong> Your additional e-mail addresses are not visible to other XING members. You can nevertheless use any of them as your notification address. Your additional e-mail addresses are also screened when other members carry out an address book comparison, meaning that you can be found more easily on XING.',
    EMAILS_CHANGE_ACTIVE_BODY:
      'We have sent you an e-mail with a confirmation link for you to change you active notification address to <strong>&quot;{-email_for_flash}&quot;</strong>. The change will be implemented as soon as you click on this link!',
    EMAILS_CONFIRM: 'Confirm',
    EMAILS_CONFIRMATION_EMAIL_BODY:
      'We sent an e-mail to <strong>&quot;{-email_for_flash}&quot;</strong>. Please click on the link in this e-mail to confirm your new e-mail address.',
    EMAILS_CONFIRMED: 'confirmed',
    EMAILS_CONFIRMED_BODY:
      'Your e-mail address <strong>&quot;{-email_for_flash}&quot;</strong> has been confirmed.',
    EMAILS_DELIVERY_EMAIL_INFO:
      '<strong>Please note</strong>: According to your e-mail provider, there could also be a noticeable delay (several minutes) between sending and delivery of our confirmation e-mail. Unfortunately, XING has no influence on this practice.',
    EMAILS_NOT_VISIBLE: 'not visible to others',
    EMAILS_UNCONFIRMED: 'unconfirmed',
    ENTER_BIRTHDAY_HINT:
      'Enter the date of your birthday - and let your contacts congratulate you.',
    ENTER_COMPANY: 'Please enter the name of the company.',
    ENTER_PREV_COMPANIES_HINT:
      'Enter information on your former companies and be found by past coworkers and business partners.',
    ENTER_SCHOOL_NAME: 'Please enter the name of the university or college.',
    ENTER_TITLE: 'Please enter a job title.',
    ENTER_UNIVERSITY_HINT:
      'Enter information on your university or college and get back in touch with old friends on XING.',
    ENTER_URL: 'Please enter a valid URL.',
    'EP_COMPANY_SOCIAL_PROOF.one': '{username} works here.',
    'EP_COMPANY_SOCIAL_PROOF.other':
      '{numberOfContacts} of your contacts work here.',
    EP_ROLLOUT_BANNER_MOBILE:
      "<p><strong>You're almost there!</strong> Please use a larger screen to switch to the new design.</p>",
    ERROR_DUPLICATE_SERVICE: 'You can only enter one account for each service.',
    ERROR_ENDDATE_INVALID: 'Please enter a correct end date.',
    ERROR_INDUSTRY: 'Please select an industry.',
    ERROR_INVALID_COMPANY: 'Please select a company.',
    ERROR_INVALID_SCHOOL: 'Please select a university or college.',
    ERROR_INVALID_SERVICE: 'Please select a service.',
    ERROR_INVALID_STATUS: 'Please select your status.',
    ERROR_SOMETHING_WENT_WRONG: 'Something went wrong. Please try again later.',
    ERROR_STATUS_CHANGE_COMPANY_MISS:
      'To change your status, please enter details of at least one job.',
    ERROR_STATUS_CHANGE_SCHOOL_MISS:
      'Please enter at least one university name and field of study to change your status.',
    ERROR_STATUS_CHANGE_SUBJECT_MISS:
      'To change your status, please enter a field of study along with your university.',
    ERROR_WIDGET_SAVE: 'Error while saving',
    ERROR_WIDGET_SAVE_MSG:
      'Your changes could not be saved, as the information has already changed. Please click on "{\'BUTTON_OK}" to confirm, and edit the data once again.',
    EV_000_MORE_EVENTS_LINK: 'more events',
    EV_000_WIDGET_COMPANY_HEADLINE: 'Upcoming events from {company}',
    EV_400_EVENT_ENDDATE_LABEL: 'Ends:',
    EV_400_EVENT_STARTDATE_LABEL: 'Starts:',
    EXECUTIVES_CV_COMPETENCES_HEADER: 'Managerial responsibility',
    FAX: 'Fax',
    FOOTER_LANGUAGES: 'Language',
    FRAME_HEADER_SEARCH: 'Search',
    FRAME_HEADER_UPSELL_DISCOUNT: 'Save {percentage}%',
    FRAME_HEADER_UPSELL_PREMIUM: 'Go Premium',
    FRAME_HEADER_UPSELL_PROJOBS: 'Check out ProJobs',
    FRAME_NAVIGATION_DISCO: 'Discover',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE:
      'What do you think about the new XING app?',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE: 'Your feedback',
    FRAME_NAVIGATION_JOBS: 'Jobs',
    FRAME_NAVIGATION_ME_HUB: 'You',
    FRAME_NAVIGATION_NETWORKING_ICON_TEXT: 'Networking',
    FRAME_NAVIGATION_PROJOBS_UPSELL: 'Go ProJobs',
    FRAME_NAVIGATION_SUPI: 'Home',
    FRAME_NAVIGATION_UPSELL_HEADLINE: 'Upgrades for you',
    FRAME_NAVIGATION_YOUR_PREMIUM: 'Your Premium',
    FRAME_NAVIGATION_YOUR_PROJOBS: 'Your ProJobs',
    FROM: 'From',
    GIVE_WORK_DETAILS_HINT:
      'Include detailed information about your current company and area of work.',
    GOOGLE_TRANSLATION_BUTTON: 'Translate',
    GOOGLE_TRANSLATION_ERROR: 'Text could not be translated.',
    GOOGLE_TRANSLATION_ERROR_NO_TEXT: 'No text to be translated',
    GOOGLE_TRANSLATION_LABEL: 'powered by Google',
    GOOGLE_TRANSLATION_SELECT_FROM: 'Select language combination:',
    GOOGLE_TRANSLATION_SELECT_TO: 'in',
    GROUP_NEWSLETTER: 'Group newsletters',
    GROUP_VISIBILITY: 'Visibility of groups',
    HEADER_SKIP_NAVIGATION: 'Skip navigation',
    IM: 'Instant messaging',
    IM_PROFILES_EMPTY:
      'Enter your instant messaging usernames (e.g. Skype or MSN messenger) here. At a later stage you can decide which contacts can see this.',
    IM_PROFILES_SERVICE: 'Web service',
    IM_PROFILES_USERNAME: 'Username',
    IMAGE_SIZE_ERROR_BODY: "Please make sure your file doesn't exceed 10 MB.",
    IMAGE_SIZE_ERROR_CHOOSE_ANOTHER: 'Please select a different file.',
    IMAGE_SIZE_ERROR_HEADLINE: 'Unfortunately this file is too large.',
    INDIVIDUAL_GROUP_VISIBILITY: 'Visibility of new groups',
    INDUSTRY: 'Industry',
    INDUSTRY_10000: 'Architecture and planning',
    INDUSTRY_100000: 'Telecommunications',
    INDUSTRY_10100: 'Civil engineering',
    INDUSTRY_10200: 'Construction',
    INDUSTRY_10300: 'Building materials',
    INDUSTRY_10400: 'Architecture',
    INDUSTRY_10500: 'Gardening and landscaping',
    INDUSTRY_110000: 'Media and publishing',
    INDUSTRY_110100: 'Information services',
    INDUSTRY_110200: 'Broadcast media',
    INDUSTRY_110300: 'Publishing',
    INDUSTRY_110400: 'Film and music',
    INDUSTRY_110500: 'Journalism',
    INDUSTRY_110600: 'Translation and interpreting',
    INDUSTRY_110700: 'Copywriting and proofreading',
    INDUSTRY_120000: 'Banking and financial services',
    INDUSTRY_120100: 'Financial services',
    INDUSTRY_120200: 'Banking',
    INDUSTRY_120300: 'Investment banking',
    INDUSTRY_120400: 'Venture capital and private equity',
    INDUSTRY_130000: 'Insurance',
    INDUSTRY_140000: 'Real estate',
    INDUSTRY_140100: 'Facility management',
    INDUSTRY_140200: 'Real estate management',
    INDUSTRY_140300: 'Real estate',
    INDUSTRY_150000: 'Auditing, tax and law',
    INDUSTRY_150100: 'Legal services',
    INDUSTRY_150200: 'Auditing',
    INDUSTRY_150300: 'Tax consulting',
    INDUSTRY_160000: 'Consulting',
    INDUSTRY_170000: 'Marketing, PR and design',
    INDUSTRY_170100: 'Marketing and advertising',
    INDUSTRY_170200: 'Market research and opinion polling',
    INDUSTRY_170300: 'Graphic design',
    INDUSTRY_170400: 'Trade fairs, exhibitions and conventions',
    INDUSTRY_170500: 'PR',
    INDUSTRY_180000: 'HR services',
    INDUSTRY_180100: 'HR services and consulting',
    INDUSTRY_180200: 'Outsourcing and offshoring',
    INDUSTRY_190000: 'Civil service, associations and institutions',
    INDUSTRY_190100: 'Non-profit organisations and charities',
    INDUSTRY_190200: 'Religious institutions',
    INDUSTRY_190300: 'Public administration',
    INDUSTRY_190400: 'Politics, unions and associations',
    INDUSTRY_190500: 'Defence, judiciary and police',
    INDUSTRY_190600: 'International affairs',
    INDUSTRY_20000: 'Consumer goods and trade',
    INDUSTRY_200000: 'Education and science',
    INDUSTRY_200100: 'Research',
    INDUSTRY_200200: 'Schools and childcare',
    INDUSTRY_200300: 'Academia',
    INDUSTRY_200400: 'Childcare',
    INDUSTRY_200500: 'Coaching and training',
    INDUSTRY_200600: 'E-learning',
    INDUSTRY_20100: 'Food',
    INDUSTRY_20200: 'Beverage',
    INDUSTRY_20300: 'Tobacco products',
    INDUSTRY_20400: 'Fashion and textiles',
    INDUSTRY_20500: 'Luxury goods and jewellery',
    INDUSTRY_20600: 'Furniture and wood products',
    INDUSTRY_20700: 'Stationery',
    INDUSTRY_20800: 'Cosmetics and toiletries',
    INDUSTRY_20900: 'Glass and ceramics',
    INDUSTRY_21000: 'Import and export',
    INDUSTRY_210000: 'Health and social',
    INDUSTRY_210100: 'Hospitals',
    INDUSTRY_210200: 'Veterinary',
    INDUSTRY_210300: 'Medical practices',
    INDUSTRY_210400: 'Alternative medicine',
    INDUSTRY_210500: 'Psychology and psychotherapy',
    INDUSTRY_210600: 'Medical services',
    INDUSTRY_210700: 'Nursing sector',
    INDUSTRY_210800: 'Welfare',
    INDUSTRY_21100: 'Wholesale',
    INDUSTRY_21200: 'Retail',
    INDUSTRY_220000: 'Art, culture and sport',
    INDUSTRY_220100: 'Performing arts',
    INDUSTRY_220200: 'Photography',
    INDUSTRY_220300: 'Music',
    INDUSTRY_220400: 'Arts and crafts',
    INDUSTRY_220500: 'Museums and cultural establishments',
    INDUSTRY_220600: 'Libraries',
    INDUSTRY_220700: 'Sports clubs, sports centres and gyms',
    INDUSTRY_220800: 'Athletes, organisers and associations',
    INDUSTRY_230000: 'Other industries',
    INDUSTRY_230100: 'Gambling and betting',
    INDUSTRY_230200: 'Agriculture',
    INDUSTRY_230300: 'Forestry and hunting',
    INDUSTRY_230400: 'Fishery',
    INDUSTRY_230500: 'Other services',
    INDUSTRY_230600: 'Mining and metals',
    INDUSTRY_230700: 'Geology',
    INDUSTRY_230800: 'Security and investigation',
    INDUSTRY_30000: 'Automotive and vehicle manufacturing',
    INDUSTRY_30100: 'Automotive, motorcycles and bicycles',
    INDUSTRY_30200: 'Shipbuilding',
    INDUSTRY_30300: 'Railway locomotive and rolling stock manufacturing',
    INDUSTRY_30400: 'Traffic engineering',
    INDUSTRY_30500: 'Aerospace',
    INDUSTRY_30600: 'Vehicle rental',
    INDUSTRY_40000: 'Industry and mechanical engineering',
    INDUSTRY_40100: 'Instrumentation and control engineering',
    INDUSTRY_40200: 'Semiconductors and electronic components',
    INDUSTRY_40300: 'Printing',
    INDUSTRY_40400: 'Composites',
    INDUSTRY_40500: 'Chemicals',
    INDUSTRY_40600: 'Mineral oil processing',
    INDUSTRY_40700: 'Metal and metalworking',
    INDUSTRY_40800: 'Biotechnology and nanotechnology',
    INDUSTRY_40900: 'Plastic and rubber goods',
    INDUSTRY_41000: 'Armaments',
    INDUSTRY_41100: 'Mechanical and industrial engineering',
    INDUSTRY_41200: 'Electrical engineering',
    INDUSTRY_41300: 'Optical instruments and photographic equipment',
    INDUSTRY_50000: 'Pharmaceutical and medical technology',
    INDUSTRY_50100: 'Medical technology',
    INDUSTRY_50200: 'Pharmaceutical and medicinal products',
    INDUSTRY_60000: 'Energy, water and environment',
    INDUSTRY_60100: 'Renewable energy',
    INDUSTRY_60200: 'Energy',
    INDUSTRY_60300: 'Water supply and sanitation',
    INDUSTRY_60400: 'Waste and recycling',
    INDUSTRY_60500: 'Environmental protection',
    INDUSTRY_70000: 'Transport and logistics',
    INDUSTRY_70100: 'Public transport',
    INDUSTRY_70200: 'Rail',
    INDUSTRY_70300: 'Shipping',
    INDUSTRY_70400: 'Aviation',
    INDUSTRY_70500: 'Storage',
    INDUSTRY_70600: 'Post and forwarding',
    INDUSTRY_80000: 'Tourism and food service',
    INDUSTRY_80100: 'Hotel',
    INDUSTRY_80200: 'Restaurant and food service',
    INDUSTRY_80300: 'Travel agencies',
    INDUSTRY_80400: 'Leisure facilities',
    INDUSTRY_90000: 'Internet and IT',
    INDUSTRY_90100: 'Software',
    INDUSTRY_90200: 'IT service provider',
    INDUSTRY_90300: 'IT security',
    INDUSTRY_90400: 'Computer networking',
    INDUSTRY_90500: 'Computer hardware',
    INDUSTRY_90600: 'Consumer electronics',
    INDUSTRY_90700: 'Internet and online media',
    INDUSTRY_90800: 'Computer games',
    INDUSTRY_CARD_TOTAL_COMPANIES: '{totalCompanies} companies',
    'INDUSTRY_CARD_TOTAL_COMPANIES.one': '1 company',
    'INDUSTRY_CARD_TOTAL_COMPANIES.other': '{amount} companies',
    INSIDER_FOLLOWED_BY: 'Followers',
    INSIDER_FOLLOWED_BY_AND: 'and',
    INSIDER_FOLLOWED_BY_AND_MORE: 'other people',
    INVISIBLE_ON_PROFILE: 'visible to recruiters',
    INVISIBLE_TO_OTHERS: 'not visible to others',
    JOB_SEARCH_ALERTS_ALERT_NAME_ALL: 'All jobs',
    JS_REALLY: 'Do you really want to do this?',
    JS_REALLY_DELETE: 'Really delete?',
    JS_REALLY_DONT_REMIND: "Really don't remind me again?",
    LANG_NOT_AVAIL: 'I speak a language not listed here.',
    LANG_PREFS: 'My language preferences',
    LANGUAGE: 'Language',
    LANGUAGE_SKILL_LEVEL_0: '- Language skills -',
    LANGUAGE_SKILL_LEVEL_1: 'Basic knowledge',
    LANGUAGE_SKILL_LEVEL_2: 'Good knowledge',
    LANGUAGE_SKILL_LEVEL_3: 'Fluent',
    LANGUAGE_SKILL_LEVEL_4: 'First language',
    LANGUAGE_SKILLS_NOT_AVAILABLE: "The language you speak isn't listed?",
    LANGUAGE_SKILLS_SELECT_LANGUAGE: '- Language -',
    LANGUAGES: 'Languages',
    LEVEL: 'Career level',
    LIKE_BUTTON_LABEL: 'Like',
    LIKERS_LIST_HEADLINE: 'Members who like this:',
    LINKCAP_LIST: 'List',
    LOGGEDOUT_ABOUT_ME: 'About {-display_name}',
    LOGGEDOUT_BUTTON_ADDCONTACT: 'Add {-display_name} as a contact',
    LOGGEDOUT_EDUCATION: "{-display_name}'s education",
    LOGGEDOUT_PERSONAL: "{-display_name}'s personal information",
    LOGGEDOUT_WORK_EXPERIENCE: "{-display_name}'s professional experience",
    MAIL_EMAIL_LOGINABLE_SUBJECT:
      '{EMAIL_SUBJ}: Important notice about your XING login details',
    MAIL_NOT_CONFIRMED:
      'The e-mail address could not be confirmed as you have changed your e-mail details in the meantime. Please try again.',
    MAIL_WAS_CONFIRMED: 'This e-mail address has been confirmed.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE:
      'Unfortunately your {filesTooBig} file exceeds the {maxSize} MB limit.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE_PLURAL:
      'Unfortunately these files exceed the {maxSize} MB limit: {filesTooBig}',
    MALT_FILE_UPLOAD_NO_FILE: 'No file selected yet',
    MALT_FILE_UPLOAD_NUMBER_OF_FILES: '{numberOfFiles} Files',
    MALT_FOOTER_COPYRIGHT_API: '© {siteoperator}  | All rights reserved',
    MALT_IMAGE_UPLOAD_BROWSE_BUTTON: 'Browse files',
    MALT_TEST_RUBY_STYLE_TRANSLATION: 'My name is {name}.',
    MEMBERSHIP_MOTIVATION: 'I’m a XING member because I want to…',
    MEMENU_FOLLOWING_LABEL: 'Following',
    MEMENU_HELP_LABEL: 'Help',
    MEMENU_JOB_ADS_LABEL: 'Manage job ads',
    MEMENU_JOB_PREFERENCES_LABEL: 'Job preferences',
    MEMENU_MY_POSTS_LABEL: 'Your posts',
    MEMENU_PREMIUM_FOR_BASIC_USER_LABEL: 'Go Premium',
    MEMENU_PREMIUM_LABEL: 'Premium',
    MEMENU_PROBUSINESS_LABEL: 'ProBusiness',
    MEMENU_PROFILE_LABEL: 'Profile',
    MEMENU_PROFILE_VISITORS:
      '{total, plural,\n    =0 {0 visitors}\n    one {1 visitor}\n    other {# visitors}\n}',
    MEMENU_PROJOBS_FOR_BASIC_USER_LABEL: 'Go ProJobs',
    MEMENU_PROJOBS_LABEL: 'ProJobs',
    MEMENU_SETTINGS_LABEL: 'Settings',
    MESSENGER_SHARE_COMMENT_PLACEHOLDER: 'Comment on your link here.',
    MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL: 'Recipients:',
    MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER: 'Enter recipients',
    MESSENGER_SHARE_TARGET_LABEL: 'Your message:',
    MONTH_NAMES:
      'January,February,March,April,May,June,July,August,September,October,November,December',
    MONTH_NAMES_SHORT: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
    MORE_PROFILES: 'My other profiles on the web',
    MOTIVATIONS_EMPTY:
      'Let others know why you are on XING, and boost your networking potential.',
    MP_700_INFOBOX_EDIT_PROFILE_LINK: 'Edit your profile',
    MY_NOTIFICATION_PREFS: 'Notification preferences',
    MY_NOTIFICATIONS: 'Notifications',
    MY_PERSONAL_INFO: 'My personal data',
    MY_PRIVACY_SETTINGS: 'Your privacy settings',
    MY_PROFILE_SETTINGS: 'My profile settings',
    MY_SETTINGS: 'Settings',
    MY_USERNAME_PASSWORD: 'My login details',
    MYXING_LOADING_ALERT_MESSAGE:
      'Sorry, something  went wrong. Please reload the page.',
    NAVIGATION_EXPAND_NETWORK_ADDITION: 'Try it now!',
    NBA_BUTTON_CANCEL: 'Cancel',
    NBA_BUTTON_CHANGE_IMAGE: 'Change photo',
    NBA_BUTTON_CONTINUE: 'Continue',
    NBA_CREATE_PHOTO_CARD_BENEFIT_TEXT:
      'A good profile photo emphasises your professional image and will lead to more profile visitors.',
    NBA_CREATE_PHOTO_CARD_GENERIC_ERROR:
      'Something went wrong. Please try again.',
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_MIME_TYPE:
      'Please select an image in either JPG, PNG or BMP format.',
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_SIZE:
      'Please select an image up to 20 MB in size.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MAX: 'Max.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MIN: 'Min.',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_HEADLINE: 'Profile photo',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_SIZES:
      'Recommended resolution: 1,024 x 1,024 px',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_TYPES:
      'JPG, BMP, PNG (max. 20 MB)',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_CLICK: 'Upload photo',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_DRAG_N_DROP:
      'Drag and drop your image here',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OR: 'or',
    NBA_CREATE_PHOTO_CARD_SUCCESS_BENEFIT_TEXT:
      'You can change this photo in your business card whenever you like.',
    NBA_CREATE_PHOTO_CARD_SUCCESS_HEADLINE:
      "Excellent! You've changed your profile image.",
    NEW_JOB: 'Add another job',
    NEW_SCHOOL: 'add another university/college',
    NEWLETTER_AND_MAIL_TIPS: 'XING newsletter, e-mail tips and offers by post',
    NEWSFEED_PROFILE_PREVIEW_AWARDS: 'Awards',
    NEWSFEED_PROFILE_PREVIEW_AWARDS_MORE:
      '{?IF:awards_sg}\n{.awards_more_entries} more award\n{?ELSE:awards_sg}\n{.awards_more_entries} more awards\n{?END:awards_sg}',
    NEWSFEED_PROFILE_PREVIEW_BUSINESS: 'Business',
    NEWSFEED_PROFILE_PREVIEW_DOCUMENTS: 'Attachments',
    NEWSFEED_PROFILE_PREVIEW_DOCUMENTS_MORE:
      '{?IF:certificates_sg}\n{.certificates_more_entries} more attachment\n{?ELSE:certificates_sg} \n{.certificates_more_entries} more attachments\n{?END:certificates_sg}',
    NEWSFEED_PROFILE_PREVIEW_HAVES: 'Skills',
    NEWSFEED_PROFILE_PREVIEW_INTERESTS: 'Interests',
    NEWSFEED_PROFILE_PREVIEW_MOBILE: 'Mobile phone',
    NEWSFEED_PROFILE_PREVIEW_ORGANISATIONS: 'Organisations',
    NEWSFEED_PROFILE_PREVIEW_PRIVATE: 'Private',
    NEWSFEED_PROFILE_PREVIEW_QUALIFICATIONS: 'Qualifications',
    NEWSFEED_PROFILE_PREVIEW_QUALIFICATIONS_MORE:
      '{?IF:qualifications_sg}\n{qualifications_more_entries} more entry\n{?ELSE:qualifications_sg}\n{qualifications_more_entries} more entries\n{?END:qualifications_sg}',
    NEWSFEED_PROFILE_PREVIEW_SCHOOLS_MORE:
      '{?IF:schools_sg}\n{schools_more_entries} more entry\n{?ELSE:schools_sg}\n{schools_more_entries} more entries\n{?END:schools_sg}',
    NEWSFEED_PROFILE_PREVIEW_WANTS: 'Wants',
    NEWSFEED_PROFILE_PREVIEW_WORKEXP_MORE:
      '{?IF:sg}\n{more_entries} more entry\n{?ELSE:sg}\n{more_entries} more entries\n{?END:sg}',
    NEWSFEED_RECOMMEND: 'Share',
    NO_END_DATE_HINT:
      'You haven\'t yet entered an end date or selected the "Current position" option.',
    NO_PRIV_ADD_HINT: "You haven't yet entered any private address details.",
    NOTES: 'Specialised subjects',
    NOTIFICATION_CENTER_LINK: 'Notifications',
    NOTIFICATIONS: 'Notifications',
    OBCPAGEHTML_DETAILS_NOTAPPROVED: '(not visible)',
    OBCPAGEHTML_LANGUAGES: 'Languages',
    OBCPAGEHTML_PERIOD: 'Period',
    OBCPAGEHTML_SHOW_SHARED_CONTACTS: 'Show shared contacts',
    OBCPAGEHTML_TAB5: 'Applications',
    OPENSOCIAL_REFERENCES_NEW: 'NEW',
    OPENSOCIAL_REFERENCES_TEXT:
      '{-DISPLAY_NAME} is using the XING References app. <a href="{-LINK}">View references</a>',
    OPENSOCIAL_REFERENCES_TITLE: 'References',
    OPTIMIZEPROFILE_ADVANTAGES_1:
      'Get found straight away by <b>more than 75,000 recruiters</b>',
    OPTIMIZEPROFILE_ADVANTAGES_2:
      'Create the perfect profile to <b>land your new job</b>',
    OPTIMIZEPROFILE_ADVANTAGES_3:
      "<b>Make contact discretely</b>, e.g. if you're currently at another job",
    OPTIMIZEPROFILE_BTN: 'Optimize profile now',
    OPTIMIZEPROFILE_CHECK_1: 'Are you listed first in search results?',
    OPTIMIZEPROFILE_CHECK_1_MORE_1:
      "Your profile is like a calling card for you - but did you know that it also determines when you'll be found in searches, for example by recruiters. Complete profiles are shown first, so make sure yours is complete!",
    OPTIMIZEPROFILE_CHECK_1_MORE_2:
      "Don't make your professional success a matter of luck: with a completed profile, you'll appear at the top of search results.",
    OPTIMIZEPROFILE_CHECK_1_MORE_3:
      'Follow the hints on your profile page to complete your profile and draw more attention to you.',
    OPTIMIZEPROFILE_CHECK_2: 'Do you refer to your job search?',
    OPTIMIZEPROFILE_CHECK_2_MORE_1:
      'Help success find you: There are over 75,000 recruiters active on XING. Let them know you\'re looking for a new challenge, and write it under "Wants" in your profile.',
    OPTIMIZEPROFILE_CHECK_2_MORE_2:
      'Indicate that you’re looking for a job in the "I’m a XING member because I want to" box.',
    OPTIMIZEPROFILE_CHECK_2_MORE_3:
      'If you’re employed and looking for another job (discreetly), you should choose the "Make invisible to XING members" option. Only recruiters will be able to see that you’re on the job search.',
    OPTIMIZEPROFILE_CHECK_3: 'Is your work experience detailed enough?',
    OPTIMIZEPROFILE_CHECK_3_MORE_1:
      'Recruiters are especially interested in your career. You can add a variety of details in the "Professional experience" section.',
    OPTIMIZEPROFILE_CHECK_3_MORE_2:
      'You can show your network and potential employers your working experience by including details in your profile: how long you worked at a job, for example, in months and years. Use the "career level" field to document your experience.',
    OPTIMIZEPROFILE_CHECK_3_MORE_3:
      "Give them something to think about: Don't just make a list of the companies where you've worked, include specific projects, successes or skills in the description.",
    OPTIMIZEPROFILE_CHECK_4: 'Have you described your skills well enough?',
    OPTIMIZEPROFILE_CHECK_4_MORE_1:
      'Showcase your skills and knowledge in your profile.',
    OPTIMIZEPROFILE_CHECK_4_MORE_2:
      "Keep track of keywords recruiters use on their own profiles as an example of what they're searching for. If a recruiter lists “XHTML”, “HTML 4” and “CSS 3” under his “Wants”, you should be ready.",
    OPTIMIZEPROFILE_CHECK_5:
      "Have you told your network what you're looking for?",
    OPTIMIZEPROFILE_CHECK_5_MORE_1:
      "Don’t wait until a recruiter finds out about how qualified you are - tell your network what you're looking for, and make it easier for recruiters to find you.",
    OPTIMIZEPROFILE_CHECK_5_MORE_2:
      'Under "Wants", you can enter keywords such as "a challenge", “new position", or "job".',
    OPTIMIZEPROFILE_CHECK_5_MORE_3:
      'Be creative: You could enter your dream job here.',
    OPTIMIZEPROFILE_CHECK_6: 'What does your photo say about you?',
    OPTIMIZEPROFILE_CHECK_6_MORE_1:
      'For profile pictures, the same rules apply as for resume pictures: no snapshots, ideally a professional picture from a photographer.',
    OPTIMIZEPROFILE_CHECK_7: 'Do you stay up to date?',
    OPTIMIZEPROFILE_CHECK_7_MORE_1:
      'If you get in touch with a recruiter, aim for clear and rapid communication – human resources is a fast-paced business.',
    OPTIMIZEPROFILE_CHECK_7_MORE_2:
      "Stay on top of things: check your messages regularly - recruiters don't have time to wait long.",
    OPTIMIZEPROFILE_CHECK_7_MORE_3:
      "Keep your notification address on XING up to date: we'll let you know by e-mail when new XING messages arrive.",
    OPTIMIZEPROFILE_CHECK_8:
      'Do you make efficient use of the "Employer" and "Status" fields?',
    OPTIMIZEPROFILE_CHECK_8_MORE_1:
      'Surprise your future employer with a sample of how creative you can be: If you’re looking for work, use the "Employer" field as an extra descriptive line to get attention. "Searching for a challenge" might catch a recruiter\'s eye - or try something even more original. “Your company could be here”, or even "I could work for you!".',
    OPTIMIZEPROFILE_CHECK_8_MORE_2:
      'Change your status to “Seeking employment”. Recruiters often search for people with this setting.',
    OPTIMIZEPROFILE_CHECK_8_MORE_3:
      'It is okay for you to add "(former)" to companies where you no longer work.',
    OPTIMIZEPROFILE_CHECKLIST_TITLE:
      'Profile checklist: Is your profile complete?',
    OPTIMIZEPROFILE_DESCRIPTION:
      'You can make your search far more effective with a complete and polished profile. Remove any gaps in your XING profile now and boost your chances of landing your dream job.',
    OPTIMIZEPROFILE_INFO:
      'Simply click on the individual checklist items on the right to find out more about how to get the most out of your profile.',
    OPTIMIZEPROFILE_SUBTITLE_1: 'Are you looking for a new job?',
    OPTIMIZEPROFILE_TIP: 'Important tip: Your privacy settings',
    OPTIMIZEPROFILE_TIP_MORE_1:
      "If you’re employed at a company, it's probably a good idea to keep your job search to yourself. Keep in mind that all changes you make to your profile appear in your direct contacts' “What’s new in your network” feed. Here's how to avoid potential mishaps:",
    OPTIMIZEPROFILE_TIP_MORE_2:
      "Play it safe: Before you change private data in your profile, be sure to change your privacy settings. Go to \"What’s new in your network” and uncheck the “Personal information” box. That way, your network won’t see you’ve made these changes on their homepage, and the changes won't appear in your contacts' newsletters.",
    OPTIMIZEPROFILE_TIP_MORE_3:
      'Remember to recheck this box after you’ve made your changes. That way, your network will always be informed of news about you.',
    OPTIMIZEPROFILE_TITLE: 'Enhance your profile to land the perfect job!',
    OPTIONS: 'Options',
    OPTIONS_DELETE: 'Yes, do it!',
    OPTIONS_SEND_MESSAGE: 'Write message',
    ORG_TYPE: 'Organisation type',
    PERSONAL: 'Personal information',
    PERSONAL_INFO: 'Personal data',
    PHONE: 'Phone',
    PHOTOBOX_LOCAL_TIME: 'Local time:',
    'POLLS_TIME_REMAINING_DAYS_WEB.one': 'Ends tomorrow',
    'POLLS_TIME_REMAINING_DAYS_WEB.other': 'Ends in {days} days',
    'POLLS_TIME_REMAINING_DAYS_WEB.zero': 'Ends today',
    POLLS_VOTE_ERROR: "Sorry, that didn't work. Please try again.",
    'POLLS_VOTES_NUMBER_WEB.one': '1 vote',
    'POLLS_VOTES_NUMBER_WEB.other': '{votes} votes',
    'POLLS_VOTES_NUMBER_WEB.zero': '0 votes',
    PORTFOLIO_CHOICE_HINT_VIDEO_UPSELL:
      'Max. 15 videos<br>\n<a {href}>(Premium only)</a>',
    PORTFOLIO_DESCRIPTION_VIDEO_UPSELL:
      'Present your work with a video.<br><br>Just go Premium to take advantage of this feature: <a {href}>Go Premium</a>',
    PORTFOLIO_UPGRADE_MESSAGE_WITH_NO_VIDEO:
      'Add up to {max_file_number} images or PDF documents<br>\nEmbed up to {max_video_number} videos<br>\nUse as many text modules as you want',
    PRESENT: 'present',
    PREVIEW: 'Preview',
    PRIMARY_JOB:
      'Display this job next to my name and at the top of my profile page',
    PRIMARY_SCHOOL:
      'Display this university next to my name and at the top of my profile page.',
    PRIVATE: 'Private',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BODY:
      'View the guest list in ProBusiness, apply powerful filters to refine it, and save relevant people as leads.',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BUTTON:
      'View guest list in ProBusiness ',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_HEADLINE: 'Looking for new leads?',
    PROBUSINESS_BANNER_SEARCH_BODY:
      'View your search results in ProBusiness where you can apply powerful filters and add contacts as leads.',
    PROBUSINESS_BANNER_SEARCH_BUTTON: 'Show results in ProBusiness',
    PROBUSINESS_BANNER_SEARCH_HEADLINE:
      'Generate better leads from your search results!',
    PROBUSINESS_DROPDOWN_SHOW_RESULT: 'Show in ProBusiness',
    PROBUSINESS_NO_STATUS_AVAILABLE: 'Lead status not available',
    PROBUSINESS_SAVE_AS_LEAD: 'Save as lead',
    PROFILE_ABOUT_PREVIEW_CREATE: 'Create an "about me" page',
    PROFILE_ABOUT_PREVIEW_EDIT: 'Edit your "about me" page now',
    PROFILE_ABOUT_PREVIEW_EMPTY_TEXT:
      '<strong>Welcome to your "about me" page!</strong><br><br>\nPeople who visit your profile are bound to want to know more about you than they can see in your profile, so you should use this page to let them know what you\'re all about.<br><br>\n\nHere you can provide a more personal description about yourself by adding detailed information about your qualifications, experience, and career goals. If you\'re a freelancer, you can use this page to present the products and services you provide.',
    PROFILE_ABOUT_PREVIEW_MORE: 'More',
    PROFILE_ACTIONS_HEADLINE: 'Options',
    PROFILE_ACTIONS_MORE_TRIGGER: 'More',
    PROFILE_BACKEND_PMBX_INQUIRY_PAYLOAD_SETTINGS_ACTIVITY_TAB_VISIBILITY:
      'Activity visible?',
    PROFILE_BACKEND_PMBX_INQUIRY_PAYLOAD_SETTINGS_PORTFOLIO_TAB_VISIBILITY:
      'Portfolio visible?',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_HEADLINE: 'Ambassadors',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_TEXT:
      'Ambassadors are moderators of Official XING Groups who also organise Official XING Events. There are three kinds of ambassador:',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_HEADLINE: 'Industry Ambassadors',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_LINK: 'Browse industry groups',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_SUB:
      'Moderator and proven expert in their industry',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_TEXT:
      'An Industry Ambassador specialises in a specific field of expertise. He hosts an industry group as a recognised expert of his special field. He supports and encourages the exchange of ideas and knowledge in his group and on official "XING Live!" events.',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_HEADLINE: 'Regional Ambassadors',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_LINK: 'Browse regional groups',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_SUB:
      'Official event organiser and local contact',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_TEXT:
      'The Regional Ambassador is the point of contact for XING related questions in your region. He is moderator of an official regional group which is open to anyone interested. Regional Amassadors regularly organise events in their region to enable their group members to get to know each other.',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_HEADLINE: 'Topic Ambassadors',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_LINK: 'Browse topic groups',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_SUB:
      'On expert on the modern world of work',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_TEXT:
      'Topic Ambassadors are experts for modern working life. They host groups where people discuss the future of work and organise events where those discussions are continued in workshops, keynote presentations, and meetings.',
    PROFILE_BADGES_LAYER_MODERATOR_SUB:
      'Contact person and mediator for the group',
    PROFILE_BADGES_LAYER_PREMIUM_LINK: 'View all Premium benefits',
    PROFILE_BADGES_LAYER_PREMIUM_SUB:
      'Handy advanced features for your business and career',
    PROFILE_BUSINESS_ANCHOR_PRIVATE:
      'Please enter your <a href="#contact_details">private contact details</a> here.',
    PROFILE_BUSINESS_ANCHOR_WEB:
      'Please add any <a href="#web-profiles">Other profiles on the web</a> such as Twitter or Facebook here.',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR_TEXT:
      'How do I become an Ambassador?',
    PROFILE_BUSINESS_CARD_BADGE_BASIC: 'Basic',
    PROFILE_BUSINESS_CARD_BADGE_BASIC_TOOLTIP: 'Discover Premium',
    PROFILE_BUSINESS_CARD_BADGE_EXECUTIVE: 'Executive',
    PROFILE_BUSINESS_CARD_BADGE_INDUSTRY_AMBASSADOR: 'Industry Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR: 'Moderator',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR_TEXT: 'How do I become a moderator?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM: 'Premium',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TEXT:
      'How do I become a Premium Member?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TOOLTIP: 'Premium member',
    PROFILE_BUSINESS_CARD_BADGE_REGIONAL_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_TOPIC_AMBASSADOR: 'Topic Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_XPERT: 'Xpert',
    PROFILE_BUSINESS_CARD_BADGE_XPERT_TEXT: 'How do I become an Xpert?',
    PROFILE_BUSINESS_CARD_BUSINESS_ADDRESS: 'Business',
    PROFILE_BUSINESS_CARD_PRIVATE_ADDRESS: 'Private',
    PROFILE_BUSINESS_CARD_ROUTE: 'Map',
    PROFILE_BUSINESS_CARD_STATUS_UPSELL_BANNER_BUTTON: 'Learn more',
    PROFILE_BUSINESS_CARD_STATUS_UPSELL_BANNER_DESCRIPTION:
      'Premium members can create their own status and customise suggestions.',
    PROFILE_BUSINESS_CARD_STATUS_UPSELL_BANNER_TITLE: 'Want more flexibility?',
    PROFILE_BUSINESS_CARD_WEB_PROFILES: 'Other profiles on the web',
    PROFILE_COMPLETE_WITH:
      'Complete your profile with the following information:',
    PROFILE_COMPLETION_TEXT: 'Profile completion level',
    PROFILE_CONTACTS_MORE: 'more contacts',
    PROFILE_GROUPS_BOX_HEADER_OTHER: "{-ONAME}'s groups",
    PROFILE_GROUPS_BOX_NO_GROUPS_VISIBLE:
      'There are no groups displayed on your profile.',
    PROFILE_GROUPS_SHOW_ALL_LINK: 'Show all',
    PROFILE_GUESTBOOK_BOX_MORE: 'Show more',
    PROFILE_HEAD_MESSAGE: 'Send message',
    PROFILE_INLINETEASER_HEADER_MULTI_ENTRIES:
      '+{num_past_workentries} other entries.',
    PROFILE_INLINETEASER_HEADER_NO_ENTRIES: 'Want to know more about {-ONAME}?',
    PROFILE_INLINETEASER_HEADER_SINGLE_ENTRY: '+1 other entry.',
    PROFILE_INLINETEASER_TEXT:
      'Just sign up now for free. As a XING member you can then get in touch with {-ONAME}.',
    PROFILE_INLINETEASER_TEXT_MULTIPLE:
      "Just sign up now for free to see all of {-ONAME}'s professional experience.",
    PROFILE_LATEST_ACTIVITIES_HEADLINE: 'Latest activity',
    PROFILE_LATEST_ACTIVITIES_MORE: 'More',
    PROFILE_LIGHTBOX_SIGNUP_HEADLINE:
      '{-ONAME} is one of over 21 million XING members.',
    PROFILE_LIGHTBOX_SIGNUP_TEXT:
      'Sign up now for free to find former contacts and meet new people.',
    PROFILE_LOGGED_OUT_JOIN_NOW: 'Sign up for free',
    PROFILE_LOGGEDOUT_RIGHTBOX_1: 'Not a member yet?',
    PROFILE_LOGGEDOUT_RIGHTBOX_2:
      'XING is a business network for professionals that successfully combines know-how with know-who.',
    PROFILE_LOGGEDOUT_RIGHTBOX_3: 'Discover the benefits of XING:',
    PROFILE_LOGGEDOUT_RIGHTBOX_4: 'Find deals, new employees or jobs',
    PROFILE_LOGGEDOUT_RIGHTBOX_5: 'Find coworkers and friends',
    PROFILE_LOGGEDOUT_RIGHTBOX_6: 'Talk to experts in all fields',
    PROFILE_LOGGEDOUT_RIGHTBOX_7: 'Sign up for free',
    PROFILE_LOGGEDOUT_SEACRHBOX_1: 'Search the XING network',
    PROFILE_LOGGEDOUT_SEACRHBOX_2:
      'Find new business contacts on XING and get back in touch with old contacts!',
    PROFILE_LOGGEDOUT_TOPBOX_BUTTON: 'Contact now',
    PROFILE_LOGGEDOUT_TOPBOX_HEADER: 'Contact {-ONAME}!',
    PROFILE_LOGGEDOUT_TOPBOX_HEADER_2: 'Want to know more about {-ONAME}?',
    PROFILE_LOGGEDOUT_TOPBOX_TEXT1:
      'All you need to do is sign up for free on XING.',
    PROFILE_LOGGEDOUT_TOPBOX_TEXT2:
      'Already a member? <a href="/profile/{+obcpage_name}">Log in</a> and add {-ONAME} as a contact.',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE: 'Active',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE_FALSE: 'No',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE_TRUE: 'Yes',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_CAREER_SETTINGS:
      'Job preferences',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_CONTENT_INSIDER:
      'Articles',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_MODULE_NAME: 'Name',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_PATTERNS_SHOWCASE:
      'Patterns showcase',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_PERSONAL_DETAILS:
      'Personal details',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_TIMELINE: 'Timeline',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_TITLE:
      'Profile sections',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_TITLE: 'Profile details visibility',
    PROFILE_MORE_DETAILS_NOTES_CATS:
      'My notes and categories (tags) for {-ONAME}',
    PROFILE_MORE_DETAILS_TOGGLE_LESS: 'less',
    PROFILE_MORE_DETAILS_TOGGLE_MORE: 'More',
    PROFILE_OTHER_EXPERIENCE_HEADLINE:
      'Other visitors also viewed the following profiles:',
    PROFILE_OTHER_EXPERIENCE_LINK: 'Other profiles',
    PROFILE_PMBX_INQUIRY_PAYLOAD_CONTENT: 'Content',
    PROFILE_PMBX_INQUIRY_PAYLOAD_CREATED_AT: 'Created on',
    PROFILE_PMBX_INQUIRY_PAYLOAD_FEED_URL: 'Feed URL',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_CONTENT: 'Content',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_DISPLAY_CONTENT:
      'Displayed content',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_TITLE: 'Legal information',
    PROFILE_PMBX_INQUIRY_PAYLOAD_NO_DATA_REASON: 'No data available',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_IMAGETILE_HEADER:
      'Portfolio: images',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_PDFTILE_HEADER:
      'Portfolio: PDF files',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TEXTTILE_HEADER:
      'Portfolio: text modules',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_CONTENT: 'Description',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_FILE: 'PDF',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_IMAGE: 'Image',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_LINK: 'Link',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_TITLE: 'Heading',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_VIDEOTILE_HEADER:
      'Portfolio: videos',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_ACCURACY: 'Accuracy',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_ADMIN_AREA: 'Region',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_CITY: 'City',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_FORMATTED_COUNTRY: 'Country',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_JSON_ATTRIBUTES:
      'Local details',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LATITUDE: 'Latitude',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LOCATION_TYPE: 'Type',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LONGITUDE: 'Longitude',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_POSTAL_CODE: 'Postcode',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_STREET: 'Street address',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_TITLE: 'Determined location',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_UPDATE_FAILED:
      "Unfortunately the location data couldn't be updated.",
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_PHOTO_ORIGINAL_PICTURE:
      'Profile photo',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_PHOTO_ORIGINAL_TITLE: 'Profile photo',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_GIVEN_AT: 'Given at',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_GIVEN_TO: 'For',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_POSITION: 'For position',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_RECIEVED_FROM: 'By',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN:
      'References provided',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN_TEXT:
      'To {referee_id} on {given_at} | ({referee_position}). {testimonial}',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN_TITLE:
      'Given references',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_POSITON: 'Position',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECEIVED:
      'References received',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECEIVED_TEXT:
      'By {referrer_id} on {given_at} | ({referrer_position}). {testimonial}',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECIEVED_TITLE:
      'Received references',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_TITLE: 'References',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_TESTIMONIAL: 'Content',
    PROFILE_PMBX_INQUIRY_PAYLOAD_RSS_PROFILE_TITLE: 'RSS feeds',
    PROFILE_PMBX_INQUIRY_PAYLOAD_TITLE: 'Location data',
    PROFILE_PMBX_INQUIRY_PAYLOAD_UPDATED_AT: 'Updated on',
    PROFILE_POWERSEARCHES_HEADER: 'Searches related to my profile',
    PROFILE_PREVIEW_HEADER:
      'This is what your profile looks like to non-contacts.',
    PROFILE_PREVIEW_INFO_BUTTON_BACK: 'Back to normal profile view',
    PROFILE_PREVIEW_INFO_HEADLINE:
      'This is what your profile looks like to visitors',
    PROFILE_PREVIEW_INFO_TEXT:
      "This is the visitors' view of your profile. Please go back to the normal view to edit your profile.",
    PROFILE_PREVIEW_OFF: 'Back to normal profile view',
    PROFILE_PREVIEW_ON: 'View as profile visitor',
    PROFILE_PROMOTE_HEADLINE: 'Your personal profile button',
    PROFILE_PROMOTE_MORE: 'Show source code',
    PROFILE_PROMOTE_TEXT:
      'Copy the HTML source code and paste it into the code of your website or blog. Clicking the button will automatically take users to your profile.',
    PROFILE_SECTIONS_GROUPS_TITLE: 'Groups',
    PROFILE_SETTINGS: 'Settings',
    PROFILE_SEVERAL_GROUPS_COUNT: '({-count} of {-total})',
    PROFILE_SEVERAL_GROUPS_TITLE: 'Several groups of {-ONAME}',
    PROFILE_SEVERAL_OF_MY_GROUPS_TITLE: 'Several of my groups',
    PROFILE_TIMELINE_MODULE_ACTION_ADD_ENTRY: 'Other',
    PROFILE_TIMELINE_MODULE_ACTION_ADD_PROMOTION: 'Promotion',
    PROFILE_TIMELINE_MODULE_ACTION_CHANGE_ORGANIZATION: 'New job',
    PROFILE_TIMELINE_MODULE_ACTION_EDIT_ENTRY: 'Internal move',
    PROFILE_TIMELINE_MODULE_BUCKET_PROFESSIONAL_AND_ENTRY_LEVEL_TITLE:
      'Professional experience',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION:
      '{years} and {months}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_FROM:
      '{duration}, from {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_SINCE:
      '{duration}, since {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_SINCE_YEAR:
      '{duration}, since {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_ONLY_FROM:
      'from {date}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_ONLY_SINCE:
      'since {date}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_PERIOD: '{from} - {to}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_TO_PRESENT_ONLY:
      '**Current**',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_WITH_DURATION_AND_PERIOD:
      '{duration}, {period}',
    PROFILEPAGE_MSG_INV_ALREADY_MEMBER:
      '<b>Please note:</b> Your invitation was NOT sent because the recipient is already a member of the group.',
    PROFILEPAGE_MSG_INV_TOO_EARLY:
      '<b>Please note:</b> Your invitation was NOT sent because you have already invited the recipient to join the group.',
    PROFILERAILS_BLOG_PREPARE_INFO: 'Your blog posts will appear here shortly.',
    PROFILERAILS_BLOG_PREPARE_INFO_ERROR:
      "Sorry, this link doesn't seem to be responding. Maybe it contains a typo? If not, please try again later.",
    PROFILERAILS_EDIT_CONTACT_DETAILS_PATH_FENCED_HINT:
      'How are the two of you connected by mutual contacts?',
    PROFILERAILS_EDIT_CONTACT_DETAILS_PATH_SHOW_ALL_FENCED: 'Show all links',
    PROFILERAILS_PROFILE_VISITORS_HL_BASIC:
      'Premium members can view <strong>profile visitors</strong>!',
    PROFILERAILS_PROJOBS_ONBOARDING_HEADER: 'Your ProJobs profile view',
    PROFILERAILS_PROJOBS_ONBOARDING_TEXT:
      'Only people you have granted the corresponding rights in your <a href="/projobs/start/?sc_o=ojm_443_settings">ProJobs settings</a> can see this view. Find out more about how to use ProJobs in our <a href="#" data-mypj-trigger-tour>guided tour</a>.',
    PROFILERAILS_VISITORS_BUTTON_PREMIUM_UPSELL: 'Go Premium',
    PROGRESS_BAR_LOADING_PERCENTAGE: '{percentage}% finished',
    PW_CHANGE_SUGGESTION:
      'We strongly recommend you change your password at least twice a year to prevent fraudulent use of your login details.',
    QUALIFICATIONS: 'Qualifications',
    QUALIFICATIONS_EMPTY:
      'Enter your additional qualifications here such as language certificates, diplomas, etc.',
    RA_1_2_years_in_pos: '1-2 years',
    RA_2_5_years_in_pos: '2-5 years',
    RA_5_10_years_in_pos: '5-10 years',
    RA_ACTIVE: 'Highly active members',
    RA_ACTIVE_INFO:
      "User activity is measured on the basis of a member's activity index. The index is only factored in, however, if the user has made it publicly visible.",
    RA_CLOSE: 'Close',
    RA_GIVE_FEEDBACK_ITEM:
      "Do you have any ideas or suggestions for XING's Recruiter Membership?",
    RA_GIVE_FEEDBACK_LINK: 'Share your feedback with us!',
    ra_hits: 'Treffer',
    RA_JOBSEARCH: 'Members who are interested in new career opportunities',
    RA_JOBSEARCH_INFO:
      'Members appearing here have indicated that they are interested in new career oppportunities in the "I’m a XING member because I want to …" box on their profile.',
    RA_SEARCH_ERROR:
      'Please limit your search with at least one search parameter.',
    RA_SEARCHHITS: 'Matches',
    RA_TEASER_GIVE_FEEDBACK_HEADLINE: 'We care about what you think.',
    RA_XING_USAGE: 'Special candidate filters',
    RECOMMENDED_COMPANY_EMPLOYER_REVIEWS:
      '{number_of_employer_reviews} employer reviews',
    RECOMMENDED_COMPANY_EMPLOYER_REVIEWS_EMPTY:
      'Be the first to rate this company!',
    RECOMMENDED_COMPANY_FOLLOW_UPDATES: 'Follow',
    RECOMMENDED_COMPANY_UNFOLLOW_UPDATES: 'Unfollow',
    RECRUITING_FOOTER_EBP_TEXT: 'Showcase your business as a great employer',
    RECRUITING_FOOTER_EBP_TITLE: 'Employer Branding Profile',
    RECRUITING_FOOTER_JOBS_TEXT: 'Find the right people for your business',
    RECRUITING_FOOTER_JOBS_TITLE: 'Jobs',
    RECRUITING_FOOTER_PROJECTS_TEXT: 'Find freelancers and service providers',
    RECRUITING_FOOTER_PROJECTS_TITLE: 'Projects',
    RECRUITING_FOOTER_XTM_TEXT: 'Reach out to millions of candidates.',
    RECRUITING_FOOTER_XTM_TITLE: 'TalentManager',
    REFERENCES_AWARDS: 'References & awards',
    REMEMBER_PASSWORD: 'Remember me',
    ROFILERAILS_PORTFOLIO_ERROR_TITLE_OR_CONTENT:
      "There's no text in this box.",
    SCHOOL: 'University/College',
    SCHOOL_UNIVERSITY: 'University/College',
    SCHOOLS_EMPTY: "You haven't yet listed any universities or colleges.",
    SE_ALL_VIEW_SEARCH_RESULTS: '{max} of {total} results',
    SE_ERROR_NOTIFICATION_JOIN_GROUP: 'Sorry, something  went wrong.',
    SE_EXTENDED_SEARCH_LIST_DESCRIPTION: 'What are you looking for?',
    SE_FILTER_JOBS_PROJOB_LABEL: 'Jobs posted by top recruiters',
    SE_GROUP_BOOKMARKED_LIST: 'Bookmarked: Go to list',
    SE_JOBS_SUGGESTED_NAME_LOCATION: 'Jobs in {location}',
    SE_LABEL_COMMUNITIES: 'Groups',
    SE_LABEL_COMPANIES: 'Companies',
    SE_LABEL_EVENTS: 'Events',
    SE_LABEL_JOBS: 'Jobs',
    SE_LABEL_MEMBERS: 'Members',
    SE_LABEL_NEWS: 'News',
    SE_OFFICIAL_XING_GROUPS: 'Official XING Groups',
    SE_PREMIUM_FLAG_ALTTEXT: 'Only Premium members',
    SE_SELECT_MEMBERS: 'Members',
    SE_SHOW_ALL_RESULTS: 'All results',
    SE_SUCCESS_NOTIFICATION_GROUP_JOINED: "You're now a member of this group!",
    SE_SUCCESS_NOTIFICATION_REQUESTED_TO_JOIN_GROUP:
      'Your membership request was sent to the moderator of this group.',
    SEARCH_DROPDOWN_COMPANIES: 'Companies',
    SEARCH_DROPDOWN_JOBS: 'Jobs',
    SEARCH_DROPDOWN_MEMBERS: 'Members',
    SEARCH_DROPDOWN_NEWS: 'News',
    SEARCH_OFFER_INTERESTED_HINT:
      'Draw attention to your profile with your "Wants", skills and interests.',
    SEARCH_OFFER_INTERESTED_IN: 'Wants, skills, interests',
    SEARCH_TOPICS_TAB_SEARCH_BUTTON: 'Search',
    SEARCH_TOPICS_TAB_TITLE: 'Topics',
    SELECT_INDUSTRY: 'Please select an industry.',
    SELECT_LANGUAGE: 'Please select a language.',
    SELECT_SERVICE: 'Please select a Web service.',
    SELECT_STATUS: 'Please select a status.',
    SERVICE: 'Web service',
    SETTINGS_LANGUAGES_TEXT:
      "Please select the language in which you'd like to use {-SITENAME}.",
    SETTINGS_MOTIVATIONS:
      '1. generate new business \n2. find new employees\n3. get to know interesting people\n4. manage my network\n5. find out about and attend events\n6. locate old coworkers and friends\n7. discover career opportunities',
    SETTINGS_USERNAME_PASSWORD_TEXT:
      'Change the login details of your {-SITENAME} member account.',
    SHARE_ACTIONSHEET_HEADER: 'Share this post',
    SHARE_BOX_DEFAULT_ERROR_MESSAGE:
      'Sorry, something went wrong. Please try again later.',
    SHARE_BOX_HEADER: 'Share on XING',
    SHARE_BOX_PLACEHOLDER: 'Comment on your link here.',
    SHARE_BOX_SHARE_SUCCESS: 'Thanks for sharing!',
    SHARE_BOX_SUBMIT_SHARE: 'Share',
    SHARE_BUTTON_LABEL: 'Share',
    SHARE_CANCEL_BUTTON: 'Cancel',
    SHARE_CHAT_CONTACTS: 'Select a contact',
    SHARE_CHAT_HINT: 'Your recipients will each receive a message.',
    SHARE_COUNTER_LABEL:
      '{counter, plural,\n    =1 {1 share}\n    other {# shares}\n}',
    SHARE_FEEDBACK_GROUPS_BUTTON: 'View post',
    SHARE_FEEDBACK_GROUPS_MESSAGE: '{item} shared in the {group} group',
    SHARE_FEEDBACK_INSIDERARTICLE_LABEL: 'Article',
    SHARE_FEEDBACK_JOB_LABEL: 'Job',
    SHARE_FEEDBACK_KLARTEXT_LABEL: 'Post',
    SHARE_FEEDBACK_LINK_LABEL: 'Link',
    SHARE_FEEDBACK_MESSENGER_BUTTON: 'View message',
    SHARE_FEEDBACK_MESSENGER_MESSAGE: '{item} shared via XING message',
    SHARE_FEEDBACK_NEWS_LABEL: 'Article',
    SHARE_FEEDBACK_PICTURE_LABEL: 'Image',
    SHARE_FEEDBACK_POST_LABEL: 'Post',
    SHARE_FEEDBACK_STARTPAGE_BUTTON: 'View post',
    SHARE_FEEDBACK_STARTPAGE_MESSAGE: '{item} shared on the homepage',
    SHARE_FEEDBACK_VIDEO_LABEL: 'Video',
    SHARE_FETCH_ERROR:
      "We're having problems connecting right now. Please try again later.",
    SHARE_FETCH_ERROR_COUNTDOWN: 'Trying again in {countdown} seconds.',
    SHARE_FETCH_ERROR_RETRY: 'Try again',
    SHARE_MOST_RECENT_CHATS: 'Chats',
    SHARE_PREVIEW_ERROR_HEADLINE: 'Preview currently unavailable.',
    SHARE_QUICKSHARE_TO_STARTPAGE: 'In the feed',
    SHARE_TEXT_BOX_LENGTH_ERROR:
      "{delta, plural, \none {Sorry, that's 1 character too many.} \nother {Sorry, that's # characters too many.}\n}",
    SHARE_TO_GROUPS: 'In a group',
    SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS: 'Forum',
    SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS: 'Group',
    SHARE_TO_GROUPS_SELECTION_LABEL: 'Select group:',
    SHARE_TO_GROUPS_TEXT_PLACEHOLDER: 'Comment on your link here.',
    SHARE_TO_GROUPS_THREAD_LABEL: 'Your post:',
    SHARE_TO_GROUPS_TITLE_PLACEHOLDER: 'Title',
    SHARE_TO_MESSENGER: 'Via private message',
    SHARE_TO_MESSENGER_EMPTY_STATE:
      "Unfortunately there weren't any hits for {query}.",
    SHARE_TO_STARTPAGE: 'In the feed with a comment',
    SHARE_USER_SUBTEXT_GROUPS: 'Share with a group',
    SHARE_USER_SUBTEXT_MESSAGE: 'Share in a chat message',
    SHARE_USER_SUBTEXT_STARTPAGE: 'Share on XING',
    SHARER_LIST_HEADLINE_MEMBERS: '{total} members shared this.',
    SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS: '{total} members shared this.',
    SHARER_LIST_HEADLINE_ONE_MEMBER: 'One member shared this.',
    SHARER_LIST_ITEM_GO_TO_POST_LINK: 'View post',
    SHARER_LIST_POST_NOTIFICATION:
      "Some posts aren't visible here due to users' privacy settings.",
    SHARERS_BACK_TO_POST_LINK: 'Back',
    SHARERS_LIST_BACK_LINK: 'Back',
    SHOW_OLD_PROFILE_INDUSTRY: 'Display the industry from my old profile',
    SOCIAL_ADD_CONTACT: 'Add as contact',
    SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION:
      'Click on the eye icon to find out your visibility. ',
    SOCIAL_BAR_VIEW_COUNTER_HEADING: 'Your visibility',
    SOCIAL_BAR_VIEW_COUNTER_SEEN:
      'For instance, this post was seen <strong>{views} times</strong>.',
    SOCIAL_BAR_VIEW_COUNTER_TIP:
      'Want to increase your reach? Find out how to <a>boost your visibility on XING</a>.',
    SOCIAL_COMMENT_BUTTON_LABEL: 'Comment',
    SOCIAL_COMMENT_COUNTER_LABEL: '{amount} comments',
    SOCIAL_COMMENT_CREATE_BUTTON_LABEL: 'Comment',
    SOCIAL_COMMENT_DELETE_LABEL: 'Delete comment',
    SOCIAL_COMMENT_DELETED_MESSAGE: 'Comment deleted.',
    SOCIAL_COMMENT_EDIT_LABEL: 'Edit comment',
    SOCIAL_COMMENT_ERROR_TOO_LARGE:
      'Please limit your comment to 20,000 characters.',
    SOCIAL_COMMENT_LIST_EMPTY_HEADLINE: 'Have your say',
    SOCIAL_COMMENT_LIST_EMPTY_SUBLINE: 'Add your voice to the conversation.',
    SOCIAL_COMMENT_OVERFLOW_ERROR: '{amount} characters',
    SOCIAL_COMMENT_REPORT_LABEL: 'Report comment',
    SOCIAL_COMMENT_WAS_EDITED: 'Edited',
    SOCIAL_COMMENTS_COUNTER_LABEL:
      '{counter, plural,\n    =0 {Be the first to comment:}\n    =1 {1 comment} \n    other {# comments}\n}',
    SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER:
      'Comment here and use @ to mention others',
    SOCIAL_COMMENTS_CREATE_PLACEHOLDER: 'Enter your comment here...',
    SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL: 'Cancel',
    SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM: 'Delete',
    SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT:
      'Not entirely happy with what you wrote? Edit or retract it if you like.',
    SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE: 'Delete this comment?',
    SOCIAL_COMMENTS_DELETE_DIALOG_TEXT: "You won't be able to undo this.",
    SOCIAL_COMMENTS_DELETE_MENTION_LABEL: 'Block mentions',
    SOCIAL_COMMENTS_FORM_PLACEHOLDER: 'Comment and use @ to mention',
    SOCIAL_COMMENTS_LOAD_MORE: 'Show more comments',
    SOCIAL_COMMENTS_MORE_REPLIES: 'Show more replies',
    SOCIAL_COMMENTS_PREVIOUS_COMMENTS: 'Show previous comments',
    SOCIAL_COMMENTS_PREVIOUS_REPLIES: 'Show previous replies',
    SOCIAL_COMMENTS_REPLY_PLACEHOLDER: 'Reply to {authorName}',
    SOCIAL_GENERIC_REPORT: 'Report',
    SOCIAL_LIKERS_LIST_HEADLINE: 'Members who like this:',
    SOCIAL_LIKERS_LIST_POST_NOTIFICATION:
      "Some likes aren't visible here due to users' privacy settings.",
    SOCIAL_PMBX_COMMENT_CONTENT_URL: 'Content',
    SOCIAL_PMBX_COMMENT_DATE: 'Date',
    SOCIAL_PMBX_COMMENT_HEADING: 'Your comments and replies',
    SOCIAL_PMBX_COMMENT_MESSAGE: 'Your comment',
    SOCIAL_PMBX_COMMENT_ORIGIN: 'Where did you comment?',
    SOCIAL_PMBX_COMMENT_TITLE: 'Your comments and replies',
    SOCIAL_PMBX_COMMENT_USER_AGENT: 'User agent',
    SOCIAL_PMBX_DESCRIPTION:
      'Posts on XING you liked, shared, mentioned someone or commented on',
    SOCIAL_PMBX_REACTION_CONTENT_URL: 'Content',
    SOCIAL_PMBX_REACTION_DATE: 'Date',
    SOCIAL_PMBX_REACTION_LIKE: 'Posts you like',
    SOCIAL_PMBX_REACTION_ORIGIN: 'Where did you react to this post?',
    SOCIAL_PMBX_REACTION_TITLE: 'Posts you reacted to\t ',
    SOCIAL_PMBX_REACTION_USER_AGENT: 'User agent',
    SOCIAL_PMBX_SHARE_CONTENT_URL: 'Content',
    SOCIAL_PMBX_SHARE_DATE: 'Date',
    SOCIAL_PMBX_SHARE_GROUPS: 'Posts you shared with a group',
    SOCIAL_PMBX_SHARE_MESSAGE: 'What you wrote',
    SOCIAL_PMBX_SHARE_MESSENGER: 'Posts you shared as a private message',
    SOCIAL_PMBX_SHARE_ORIGIN: 'Where did you share this post?',
    SOCIAL_PMBX_SHARE_STARTPAGE: 'Posts you shared on XING',
    SOCIAL_PMBX_SHARE_TITLE: 'Posts you shared',
    SOCIAL_PMBX_SHARE_USER_AGENT: 'User agent',
    SOCIAL_PMBX_TITLE: 'Interactions',
    SOCIAL_REPLIES_LOAD_MORE: 'Show more replies',
    SOCIAL_REPLY_BUTTON: 'Reply',
    SOCIAL_REPLY_DISCARD_MESSAGE: 'Really discard this comment?',
    SOCIAL_REPLY_LOAD_MORE: 'Show 1 more reply',
    SOCIAL_REPLY_LOAD_MULTIPLE: 'Show more comments',
    SOCIAL_REPLY_POST_BUTTON: 'Reply',
    SOCIAL_SEND_MESSAGE: 'Write a message',
    SOCIAL_SHARE_COUNTER_LABEL: '{amount} shares',
    SOCIAL_SHARE_EXTERNAL_LINK_ERROR: "This link can't be shared.",
    SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS: 'Members who shared this:',
    SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK: 'View post',
    SOCIAL_SHARERS_LIST_POST_NOTIFICATION:
      "Some posts aren't visible here due to users' privacy settings.",
    SOCIAL_SHOW_MORE: 'Show more',
    SOCIAL_SOCIAL_PROOF_LABEL:
      '{counter, plural,\n    =1 {1 like:} \n    other {# likes:}\n}',
    SOCIAL_UPDATE_COMMENT_LABEL: 'Save',
    SP_101_TEASER_ENTERPRISEGROUPS_HEADLINE:
      '<a href="/app/user?op=info.partners#enterprisegroups-info">XING Enterprise Groups</a>',
    STATE: 'State',
    STATUS: 'Employment status',
    STATUS_BUTTON_CHANGE: 'Update now',
    STATUS_BUTTON_SEND: 'Save',
    STATUS_CHANGE_COMPANY_EXPL:
      'Please select a company you wish to have displayed alongside your name and at the top of your profile. If your current company isn’t listed, please add it to your profile.',
    STATUS_CHANGE_SCHOOL_EXPL:
      'Please select a university you wish to have displayed alongside your name and at the top of your profile. If your current university isn’t listed, please add it to your profile.',
    STATUS_CHANGE_TO_UNEMPLOYED_HINT:
      'Make sure you always keep your profile up to date! Filling in the "wants" and skills in your profile will considerably increase your chances of being found by a new employer.',
    STATUS_CHANGE_TO_UNEMPLOYED_HINT_TITLE: 'Find your new job on XING now!',
    STATUS_MESSAGE_DELETE: 'Delete',
    STILL_IN_POSITION: 'Current position',
    SUBJECT: 'Field of study',
    SUBJECT_HINT: '(field of study)',
    SYSTEM_LANGUAGE: 'This is your system language.',
    SYSTEM_LANGUAGE_LABEL: 'System language',
    TARGET_DEGREE: '(Future) degree',
    TEXTAREA_EMPTY: "You haven't yet entered any information in this category.",
    TITLE: 'Title',
    TO: 'Until',
    TO_LOWERCASE: 'to',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL: 'Back',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM: 'Back to {section}',
    TOP_BAR_ME_MENU_DIMMER_ARIA_LABEL: 'Close menu',
    TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE: 'Profile',
    UNIVERSAL_CAREER_LEVEL_LIST:
      '1. Student/Intern\n2. Entry level\n3. Professional/experienced\n4. Manager/supervisor\n5. Executive (VP, SVP, etc.)\n6. Senior executive (CEO, etc.)',
    UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST:
      '1001. Analysis & Statistics\n1002. Administration\n1003. Consulting\n4. Controlling & Planning\n1004. Customer Service\n1005. Purchasing, Materials Management & Logistics\n1006. Finance, Accounting & Controlling\n1007. Teaching, R&D\n1008. Health, Medical & Social\n1009. Graphic Design & Architecture\n1010. Engineering & Technical\n1011. IT & Software Development\n1012. Management & Corporate Development\n1013. Marketing & Advertising\n1014. HR\n1015. PR & Journalism\n1016. Production & Manufacturing\n1017. Product Management\n1018. Project Management\n1019. Process Planning & QA\n1020. Law\n1021. Sales & Commerce\n1022. Other Disciplines',
    UNIVERSITY_HINT: '(student)',
    UPLOAD_PHOTO: 'Upload photo',
    UPLOAD_PHOTO_HINT:
      'Upload a photo and make yourself more recognizable to your business contacts and coworkers.',
    UPLOADER_ADD_IMAGE: 'Add image',
    UPLOADER_ADD_VIDEO: 'Add video',
    UPLOADER_CANCEL_UPLOAD: 'Cancel upload',
    UPLOADER_ERROR_BODY: 'Please try again.',
    UPLOADER_ERROR_HEADLINE: "Sorry, that didn't work.",
    UPLOADER_IMAGE_LOADING_HEADLINE: 'Uploading image...',
    UPLOADER_TRY_AGAIN: 'Try again',
    UPLOADER_VIDEO_LOADED_BODY:
      "We are now processing it to make sure it'll look great. This may take a few minutes – but don't let that keep you from posting or sharing it now.\n\n",
    UPLOADER_VIDEO_LOADED_HEADLINE: 'Your video has been uploaded.',
    UPLOADER_VIDEO_LOADING_HEADLINE: 'Uploading video...',
    URL: 'URL',
    USER_FLAG_BUTTON_ARIA_LABEL: '{type} membership badge',
    USER_FLAG_ERROR:
      "This information isn't available right now.<br>\nPlease try again later.",
    USER_FLAG_ERROR_PARAGRAPH_1: "This information isn't available right now.",
    USER_FLAG_ERROR_PARAGRAPH_2: 'Please try again later.',
    USER_FLAG_LOADING: 'Loading...',
    USER_SETTINGS_TAB_PROFILE_SETTINGS: 'Profile settings',
    USER_SETTINGS_TAB_USERNAME_PASSWORD: 'Login details',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_LABEL: 'Business solutions',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_SHORT_LABEL: 'Business',
    VERTICAL_NAV_FIND_JOBS_LABEL: 'Find jobs',
    VERTICAL_NAV_FOLLOWING_LABEL: 'Following',
    VERTICAL_NAV_INSIGHTS_LABEL: 'Insights',
    VERTICAL_NAV_JOB_PREFERENCES_LABEL: 'Job preferences',
    VERTICAL_NAV_MESSAGES_LABEL: 'Messages',
    VERTICAL_NAV_MY_POSTS_LABEL: 'Your posts',
    VERTICAL_NAV_NETWORK_LABEL: 'Network',
    VERTICAL_NAV_NETWORK_SHORT_LABEL: 'Network',
    VERTICAL_NAV_PREMIUM_FOR_BASIC_USER_LABEL: 'Go Premium',
    VERTICAL_NAV_PREMIUM_LABEL: 'Premium',
    VERTICAL_NAV_PREMIUM_SHORT_LABEL: 'Premium',
    VERTICAL_NAV_PROBUSINESS_LABEL: 'ProBusiness',
    VERTICAL_NAV_PROFILE_LABEL: 'Profile',
    VERTICAL_NAV_PROJOBS_FOR_BASIC_USER_LABEL: 'Go ProJobs',
    VERTICAL_NAV_PROJOBS_LABEL: 'ProJobs',
    VERTICAL_NAV_YOUR_JOBS_LABEL: 'Your jobs',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS: 'Business solutions',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT: 'Business',
    VERTICAL_NAVIGATION_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_COMMUNITIES: 'Groups',
    VERTICAL_NAVIGATION_COMPANIES: 'Companies',
    VERTICAL_NAVIGATION_CONTACTS: 'Your network',
    VERTICAL_NAVIGATION_CONTACTS_SHORT: 'Network',
    VERTICAL_NAVIGATION_CONTENT_PAGES: 'News',
    VERTICAL_NAVIGATION_EVENTS: 'Events',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE:
      'The new XING app: Feedback & Help',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT: 'New app',
    VERTICAL_NAVIGATION_FOOTER_ADVERTISE: 'Advertise on XING',
    VERTICAL_NAVIGATION_FOOTER_AMIANDO: 'Ticketing and event promotion',
    VERTICAL_NAVIGATION_FOOTER_ANDROID: 'Android',
    VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN: 'Cover letter editor',
    VERTICAL_NAVIGATION_FOOTER_APP_GALLERY: 'Mobile & desktop apps',
    VERTICAL_NAVIGATION_FOOTER_APPS: 'Apps',
    VERTICAL_NAVIGATION_FOOTER_BEWERBUNG: 'Job application tips',
    VERTICAL_NAVIGATION_FOOTER_BLOG: 'Blog',
    VERTICAL_NAVIGATION_FOOTER_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_FOOTER_CAREER: 'Careers',
    VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE: 'Career Guide',
    VERTICAL_NAVIGATION_FOOTER_COACHES: 'Coaches + Trainers',
    VERTICAL_NAVIGATION_FOOTER_COMMUNITY: 'Community',
    VERTICAL_NAVIGATION_FOOTER_COMPANIES: 'Companies',
    VERTICAL_NAVIGATION_FOOTER_COMPANY: 'Company',
    VERTICAL_NAVIGATION_FOOTER_DEVBLOG: 'Devblog',
    VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL: 'Developers',
    VERTICAL_NAVIGATION_FOOTER_DOWNLOAD: 'Downloads',
    VERTICAL_NAVIGATION_FOOTER_EVENTS: 'Events',
    VERTICAL_NAVIGATION_FOOTER_EXECUTIVES_MEMBERSHIP: 'Executive Circles',
    VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH: 'Salary check',
    VERTICAL_NAVIGATION_FOOTER_GROUPS: 'Groups',
    VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER: 'Freelancer verwalten',
    VERTICAL_NAVIGATION_FOOTER_HELP: 'Help & Contact',
    VERTICAL_NAVIGATION_FOOTER_IMPRINT: 'About this site',
    VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS: 'Investor Relations',
    VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD: 'iPhone & iPad',
    VERTICAL_NAVIGATION_FOOTER_JOB_MARKET: 'Jobs',
    VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY: 'Jobs Directory',
    VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF: 'CV editor',
    VERTICAL_NAVIGATION_FOOTER_LOGINWXING: 'Log in with XING',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION: 'Cancel membership',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS: 'Memberships',
    VERTICAL_NAVIGATION_FOOTER_MOBILE: 'Mobile',
    VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE:
      'NWX – Neues zur Zukunft der Arbeit',
    VERTICAL_NAVIGATION_FOOTER_NEWWORKSE: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY: 'Member directory',
    VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE: 'Praktikum-Guide',
    VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_FOOTER_PRESS: 'Press',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY: 'Privacy at XING',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY: 'Privacy Policy',
    VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_FOOTER_RESOURCES: 'Resources',
    VERTICAL_NAVIGATION_FOOTER_SERVICES: 'Additional services',
    VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER: 'Recruiting with XING',
    VERTICAL_NAVIGATION_FOOTER_TANDC: 'Terms & Conditions',
    VERTICAL_NAVIGATION_FOOTER_TRACKING: 'Tracking',
    VERTICAL_NAVIGATION_FOOTER_WINDOWS_10: 'Windows 10',
    VERTICAL_NAVIGATION_FOOTER_XAS: 'Post an ad',
    VERTICAL_NAVIGATION_FOOTER_XING_AG: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_XING_NEWS: 'XING News',
    VERTICAL_NAVIGATION_FOOTER_XING_SHARE: 'XING share button',
    VERTICAL_NAVIGATION_FOOTER_YOUR_XING: 'Main Sections',
    VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR: 'BrandManager',
    VERTICAL_NAVIGATION_HEADER_HELP: 'Help',
    VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS: 'Job ads',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS: 'AdManager',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE: 'Coach profile',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES: 'Invoices & Accounts',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT: 'Log out',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES:
      'Memberships & invoices',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS: 'ProJobs settings',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS: 'Settings',
    VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS: 'View all',
    VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON: 'Search',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES: 'Groups',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE: 'Employer',
    VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS: 'Events',
    VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS: 'Jobs',
    VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS: 'Members',
    VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS: 'Industry News',
    VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER:
      'Enter a job title, name or keyword',
    VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN: 'LicenceManager',
    VERTICAL_NAVIGATION_HEADER_XTM: 'TalentManager',
    VERTICAL_NAVIGATION_MESSAGES: 'Messages',
    VERTICAL_NAVIGATION_MORE: 'More',
    VERTICAL_NAVIGATION_MYPROJOBS: 'ProJobs',
    VERTICAL_NAVIGATION_OTHER_SERVICES: 'Other services',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS: 'Premium',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER: 'Go Premium',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT: 'Premium',
    VERTICAL_NAVIGATION_PROBUSINESS: 'ProBusiness',
    VERTICAL_NAVIGATION_PROJOBS_BENEFITS_FOR_BASIC_USER: 'Go ProJobs',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL: 'Check out ProJobs',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT: 'ProJobs',
    VERTICAL_NAVIGATION_STARTPAGE: 'Home',
    VIDEO_ENCODING_HEADLINE: 'Encoding your video...',
    VIDEO_ENCODING_MESSAGE:
      'Please bear with us as this may take a few minutes.',
    VIDEOS_AUTOPLAY: 'Autoplay',
    VIDEOS_SETTINGS: 'Autoplay videos?',
    VIDEOS_WATCH_VIDEO: 'Watch video',
    VIEW_PAGE_IN_CHINESE: 'View this page in Chinese',
    VIEW_PAGE_IN_DUTCH: 'View this page in Dutch',
    VIEW_PAGE_IN_ENGLISH: 'View this page in English',
    VIEW_PAGE_IN_FINNISH: 'View this page in Finnish',
    VIEW_PAGE_IN_FRENCH: 'View this page in French',
    VIEW_PAGE_IN_GERMAN: 'View this page in German',
    VIEW_PAGE_IN_HUNGARIAN: 'View this page in Hungarian',
    VIEW_PAGE_IN_ITALIAN: 'View this page in Italian',
    VIEW_PAGE_IN_JAPANESE: 'View this page in Japanese',
    VIEW_PAGE_IN_KOREAN: 'View this page in Korean',
    VIEW_PAGE_IN_POLISH: 'View this page in Polish',
    VIEW_PAGE_IN_PORTUGUESE: 'View this page in Portuguese',
    VIEW_PAGE_IN_RUSSIAN: 'View this page in Russian',
    VIEW_PAGE_IN_SPANISH: 'View this page in Spanish',
    VIEW_PAGE_IN_SWEDISH: 'View this page in Swedish',
    VIEW_PAGE_IN_TURKISH: 'View this page in Turkish',
    VISIBLE_ON_MY_PROFILE: 'visible to profile visitors',
    VISIBLE_TO_ALL_MEMBERS: 'visible for all XING members',
    VISIBLE_TO_RECRUITERS: 'only visible for recruiters',
    WEB: 'Web',
    WEB_PROFILES_EMPTY: "You haven't listed any other web profiles.",
    WELCOME_BOX:
      'Welcome <a href="/profile/my_profile" title="{\'NAVI_EDITCONTACTPAGE}">{-FULL_NAME}</a>{!USER_ICONS}',
    WORK: 'Jobs',
    WORK_EXPERIENCE: 'Professional experience',
    WORKEXPERIENCE_ADDITIONAL_INDUSTRIES: 'Additional industries',
    WORKEXPERIENCE_DISCIPLINE_LIST:
      '1. Administration\n2. Analysis & Statistics\n3. Consulting\n4. Controlling & Planning\n5. Customer Service\n6. Graphic Design\n7. Purchasing, Materials Management & Logistics\n8. Finance & Accounting\n9. Research & Teaching\n10. Corporate Management, M&A & Strategic Management\n11. Manual Trade\n12. Hardware & Software Development\n13. Journalism\n14. Marketing & Advertising\n15. Medicine\n16. PR\n17. Organisation & Management\n18. HR\n19. Production & Manufacturing\n20. Product Management\n21. Project Management\n22. R&D\n23. Law\n24. Sales',
    WORKEXPERIENCE_GET_OLD_INDUSTRIES:
      'Copy your industries from old XING profile',
    WORKEXPERIENCE_ORG_TYPE_LIST:
      '1. Publicly held corporation\n2. Privately held company\n3. Non-profit organisation\n4. Business partnership\n5. Individual enterprise\n6. Freelance',
    WORKEXPERIENCE_SIZE_LIST:
      '1. Just me\n2. 1-10 employees\n3. 11-50 employees\n4. 51-200 employees\n5. 201-500 employees\n6. 501-1,000 employees\n7. 1,001-5,000 employees\n8. 5,001-10,000 employees\n9. 10,001 or more employees',
    WORKEXPERIENCE_STATUS_LIST:
      '1. Full-time employee\n2. Part-time employee\n3. Intern\n4. Freelancer/Self-employed\n5. Owner\n6. Partner/Shareholder\n7. Board member\n8. Volunteer\n9. Self-employed\n10. Shareholder\n11. Civil servant\n12. Recruiter\n13. Freelancer\n14. Partner\n17. Apprentice',
    WRONG_END_DATE_HINT:
      'You have selected "Current position", but the end date is in the past.',
    X_UI_HEADER_REGISTER: 'Sign up',
    X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK: 'Log in',
    XBP_NAVIGATION_ENTRY_LINK: 'Manage Business Pages',
    XBP_TAB_COMPANIES: 'Employers',
    XBP_TAB_PRODUCTS_AND_SERVICES: 'Products and services',
    XDS_A11Y_CHARACTER_COUNTER_MAX: 'Maximum exceeded',
    XDS_A11Y_CHARACTER_COUNTER_TEXT:
      '{currentCount} of {maxCount} characters used',
    XDS_A11Y_LOADING: 'Loading',
    XDS_BACK_TO_TOP_BUTTON: 'Back to top',
    XDS_BREADCRUMB_HOME: 'Home',
    XDS_CAROUSEL_NEXT_BUTTON_A11Y: 'Next page',
    XDS_CAROUSEL_PREVIOUS_BUTTON_A11Y: 'Previous page',
    XDS_CLOSE_BUTTON_A11Y: 'Close',
    XDS_DELETE_TAG_BUTTON_A11Y: 'Delete',
    XDS_DISCOVER_BADGE_A11Y: 'New feature',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Try again',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: 'Please try again.',
    XDS_EMPTYSTATE_ERROR_TITLE: "That didn't work.",
    XDS_FEEDBACK_BAR_THUMB_DOWN_A11Y: 'Thumbs down',
    XDS_FEEDBACK_BAR_THUMB_UP_A11Y: 'Thumbs up',
    XDS_FLAG_AMBASSADOR_DIVERSE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_FEMALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_MALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_NEUTRAL: 'Ambassador',
    XDS_FLAG_BASIC_DIVERSE: 'Basic',
    XDS_FLAG_BASIC_FEMALE: 'Basic',
    XDS_FLAG_BASIC_MALE: 'Basic',
    XDS_FLAG_BASIC_NEUTRAL: 'Basic',
    XDS_FLAG_BETA_DIVERSE: 'Beta',
    XDS_FLAG_BETA_FEMALE: 'Beta',
    XDS_FLAG_BETA_MALE: 'Beta',
    XDS_FLAG_BETA_NEUTRAL: 'Beta',
    XDS_FLAG_INSIDER_DIVERSE: 'Insider',
    XDS_FLAG_INSIDER_FEMALE: 'Insider',
    XDS_FLAG_INSIDER_MALE: 'Insider',
    XDS_FLAG_INSIDER_NEUTRAL: 'Insider',
    XDS_FLAG_MODERATOR_DIVERSE: 'Moderator',
    XDS_FLAG_MODERATOR_FEMALE: 'Moderator',
    XDS_FLAG_MODERATOR_MALE: 'Moderator',
    XDS_FLAG_MODERATOR_NEUTRAL: 'Moderator',
    XDS_FLAG_NEW_DIVERSE: 'New',
    XDS_FLAG_NEW_FEMALE: 'New',
    XDS_FLAG_NEW_MALE: 'New',
    XDS_FLAG_NEW_NEUTRAL: 'New',
    XDS_FLAG_PREMIUM_DIVERSE: 'Premium',
    XDS_FLAG_PREMIUM_FEMALE: 'Premium',
    XDS_FLAG_PREMIUM_MALE: 'Premium',
    XDS_FLAG_PREMIUM_NEUTRAL: 'Premium',
    XDS_FLAG_PROBUSINESS_DIVERSE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_FEMALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_MALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_NEUTRAL: 'ProBusiness',
    XDS_FLAG_PROCOACH_DIVERSE: 'ProCoach',
    XDS_FLAG_PROCOACH_FEMALE: 'ProCoach',
    XDS_FLAG_PROCOACH_MALE: 'ProCoach',
    XDS_FLAG_PROCOACH_NEUTRAL: 'ProCoach',
    XDS_FLAG_PROJOBS_DIVERSE: 'ProJobs',
    XDS_FLAG_PROJOBS_FEMALE: 'ProJobs',
    XDS_FLAG_PROJOBS_MALE: 'ProJobs',
    XDS_FLAG_PROJOBS_NEUTRAL: 'ProJobs',
    XDS_FLAG_PROTRAINER_DIVERSE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_FEMALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_MALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_NEUTRAL: 'ProTrainer',
    XDS_INPUT_BAR_CLEAR_BUTTON_A11Y: 'Clear',
    XDS_MINI_BADGE_A11Y: 'New notification',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.one': '1 new notification',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.other': '{value} new notifications',
    XDS_SKELETON_GENERIC_A11Y: 'Loading',
    XDS_STAR_RATING_A11Y: 'Rating: {rating} out of 5 stars',
    XDS_STAR_RATING_NO_RATING_A11Y: 'No rating available',
    XING_FAQ_GUIDE_URL:
      'https://help.xing.com/hc/en-us/articles/33816993574801-Your-guide-to-networking?segment=b2c',
    XINGID_ADD_LEAD_SUCCESS: '{displayName} added to leads',
    XINGID_REMOVE_LEAD_SUCCESS: '{displayName} removed from leads',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_CANCEL: 'Jetzt nicht',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_CONTENT_1:
      'Bitte beantworte uns zwei Fragen, damit wir unser Informationsangebot noch besser auf Deine Interessen abstimmen können. Vielen Dank!',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_CTA: 'Zur Umfrage',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_TITLE:
      'Was möchtest Du über diesen Arbeitgeber erfahren?',
    XTP_IDEAL_EMPLOYER_DUPLICATED_LIGHTBOX_HEADLINE:
      'You already notified this employer.',
    XTP_IDEAL_EMPLOYER_LIGHTBOX_BUTTON: 'Edit ideal employers',
    XTP_IDEAL_EMPLOYER_LIGHTBOX_CONTENT:
      'You can edit your ideal employers in your settings whenever you like.',
    XTP_IDEAL_EMPLOYER_SUCCESS_LIGHTBOX_HEADLINE: 'Ideal employer notified',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS: 'Access XING videos vendor API',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING: 'XING videos API',
    XWS_100_INACTIVE_MEMBER: 'Inactive member',
    YEAR: 'Year',
    YEARS: 'years',
    YOUR_BIRTHDAY: 'Your birthday',
    YOUR_CURRENT_ADDRESS: 'Your current business address',
    YOUR_CURRENT_COMPANY: 'Your current company',
    YOUR_LANGUAGE_NOT_AVAIL: "The language you speak isn't listed?",
    YOUR_PIC: 'Your photo',
    YOUR_PREVIOUS_COMPANIES: 'Your previous companies',
    YOUR_STATUS: 'Your status',
    YOUR_UNIVERSITY: 'Your university/college',
    ZIP_CODE: 'Postcode',
  },
};
